// Generated from local HTML sources under 规则/中文翻译.
// Do not edit clause text by hand; regenerate from the source HTML when the rules source changes.

export interface WaterPoloRuleClause {
  number: string;
  html: string;
  text: string;
}

export interface WaterPoloRuleSection {
  id: string;
  no: string;
  title: string;
  en: string;
  clauses: WaterPoloRuleClause[];
}

export interface WaterPoloSignalCard {
  id: string;
  image: string;
  alt: string;
  category: string;
  whistle: string;
  gestureHtml: string;
  gestureText: string;
  whistleHtml: string;
  whistleText: string;
}

export interface WaterPoloWhistleRow {
  scene: string;
  whistleHtml: string;
  signal: string;
  basis: string;
}

export const waterPoloRulesMeta = {
  "title": "水球比赛规则",
  "subtitle": "World Aquatics 竞赛规则第六部分 · 2025-06-25 生效版中文参考译本",
  "scope": "正文 §1-§19、附录 3、5、6、7、10，另含裁判手势与哨声规则。",
  "effectiveDate": "2025-06-25",
  "sectionCount": 24,
  "clauseCount": 370,
  "signalCount": 30,
  "sourceNote": "中文参考译本用于学习与站内说明；正式比赛、报名、执裁和争议处理应以 World Aquatics 官方英文规则、赛事手册和当地竞赛规程为准。"
} as const;

export const waterPoloRuleSections: WaterPoloRuleSection[] = [
  {
    "id": "s1",
    "no": "1",
    "title": "比赛场地与器材",
    "en": "The Field of Play & Equipment",
    "clauses": [
      {
        "number": "1.1",
        "html": "<p>比赛场地、球门、用球及其他器材必须符合第六部分附录 4 的规定。</p>",
        "text": "比赛场地、球门、用球及其他器材必须符合第六部分附录 4 的规定。"
      },
      {
        "number": "1.2",
        "html": "<p>两条球门线之间的距离应为 25 米。该距离适用于男子和女子比赛。</p>",
        "text": "两条球门线之间的距离应为 25 米。该距离适用于男子和女子比赛。"
      },
      {
        "number": "1.3",
        "html": "<p>在比赛场地的横向外侧、即球队替补席所在的一侧，必须设有飞行换人区（<span class=\"term\">flying substitutions</span>）。该区域宽度须介于 0.5 米至 1 米之间。每队的指定飞行换人区位于本队替补席前方的球门线与比赛场地中线之间。</p>",
        "text": "在比赛场地的横向外侧、即球队替补席所在的一侧，必须设有飞行换人区（flying substitutions）。该区域宽度须介于 0.5 米至 1 米之间。每队的指定飞行换人区位于本队替补席前方的球门线与比赛场地中线之间。"
      }
    ]
  },
  {
    "id": "s2",
    "no": "2",
    "title": "球队与队员",
    "en": "Teams & Players",
    "clauses": [
      {
        "number": "2.1",
        "html": "<p>在 World Aquatics 赛事、或任何取得 World Aquatics 赛事参赛资格的赛事中，每队的上场名单（<span class=\"term\">start list</span>）最多由 14 名符合资格的队员组成。该名单最多包含 12 名场上队员（<span class=\"term\">field players</span>）和最多 2 名守门员（<span class=\"term\">goalkeepers</span>）。</p>\n        <p>每队的上场名单中至少须有 1 名守门员。即使球队只有 1 名守门员，场上队员的最大人数仍为 12 名。守门员必须佩戴红色泳帽，因为红帽赋予该队员守门员的各项权利。</p>\n        <p>球队必须以 7 名队员开始比赛，其中 1 名必须为守门员。比赛开始后，球队不必在水中保留守门员，可改为派出 7 名场上队员。</p>\n        <p>若在任何时刻某队已无剩余可用的场上队员，则已登记的守门员或已登记的替补守门员可作为场上队员上场。同样，若在任何时刻某队已无剩余可用的守门员，则一名已登记的场上队员可担任守门员，前提是其佩戴红色泳帽。</p>",
        "text": "在 World Aquatics 赛事、或任何取得 World Aquatics 赛事参赛资格的赛事中，每队的上场名单（start list）最多由 14 名符合资格的队员组成。该名单最多包含 12 名场上队员（field players）和最多 2 名守门员（goalkeepers）。 每队的上场名单中至少须有 1 名守门员。即使球队只有 1 名守门员，场上队员的最大人数仍为 12 名。守门员必须佩戴红色泳帽，因为红帽赋予该队员守门员的各项权利。 球队必须以 7 名队员开始比赛，其中 1 名必须为守门员。比赛开始后，球队不必在水中保留守门员，可改为派出 7 名场上队员。 若在任何时刻某队已无剩余可用的场上队员，则已登记的守门员或已登记的替补守门员可作为场上队员上场。同样，若在任何时刻某队已无剩余可用的守门员，则一名已登记的场上队员可担任守门员，前提是其佩戴红色泳帽。"
      },
      {
        "number": "2.2",
        "html": "<p>当时未参加比赛的所有队员，连同教练和官员（主教练除外），必须坐在本队替补席上，且自比赛开始起不得离开替补席；换人、节间间歇或暂停期间除外。进攻方的主教练可随时移动至 6 米线。球队只能在中场休息时交换场地与替补席。两队替补席都必须设在记录台对面的一侧。</p>",
        "text": "当时未参加比赛的所有队员，连同教练和官员（主教练除外），必须坐在本队替补席上，且自比赛开始起不得离开替补席；换人、节间间歇或暂停期间除外。进攻方的主教练可随时移动至 6 米线。球队只能在中场休息时交换场地与替补席。两队替补席都必须设在记录台对面的一侧。"
      },
      {
        "number": "2.3",
        "html": "<p>队长应为各自球队的上场队员，并与主教练共同负责本队的良好行为与纪律。</p>",
        "text": "队长应为各自球队的上场队员，并与主教练共同负责本队的良好行为与纪律。"
      },
      {
        "number": "2.4",
        "html": "<p>队员应穿着不透明的泳衣、或带有独立内衬的泳衣，参赛前须摘除任何可能造成伤害的物品。</p>",
        "text": "队员应穿着不透明的泳衣、或带有独立内衬的泳衣，参赛前须摘除任何可能造成伤害的物品。"
      },
      {
        "number": "2.5",
        "html": "<p>队员身上不得涂抹油脂、油类或任何可能带来优势的物质。若裁判员在比赛开始前认定使用了此类物质，应命令立即清除，且比赛不得因清除该物质而延迟开始。若在比赛开始后才发现此类违规，违规队员应被罚出、不得参加本场比赛余下部分，并允许一名替补队员立即从本队的罚出再入场区（<span class=\"term\">exclusion re-entry area</span>）进入比赛场地。</p>",
        "text": "队员身上不得涂抹油脂、油类或任何可能带来优势的物质。若裁判员在比赛开始前认定使用了此类物质，应命令立即清除，且比赛不得因清除该物质而延迟开始。若在比赛开始后才发现此类违规，违规队员应被罚出、不得参加本场比赛余下部分，并允许一名替补队员立即从本队的罚出再入场区（exclusion re-entry area）进入比赛场地。"
      },
      {
        "number": "2.6",
        "html": "<p>比赛中的任何时刻，队员或守门员均可通过从本队罚出再入场区离开比赛场地的方式进行换人。一旦离场队员在再入场区内明显浮出水面，替补队员即可从罚出再入场区进入比赛场地。当替补队员从延长球门线后方进入飞行换人区，且离场队员与替补队员二人均在水中、位于比赛场地之外、并在水面以上击掌时，亦允许从飞行换人区换人。替补队员应做好准备、随时替换且不得拖延。若替补队员未准备好，比赛将在没有该替补的情况下继续，该替补此后可在任何时刻从本队指定换人区进入比赛场地（适用时须先击掌）。若队员经罚出再入场区或飞行换人区离场而未被替补替换，则该同一队员可从同一罚出再入场区或飞行换人区重新进入比赛场地。</p>",
        "text": "比赛中的任何时刻，队员或守门员均可通过从本队罚出再入场区离开比赛场地的方式进行换人。一旦离场队员在再入场区内明显浮出水面，替补队员即可从罚出再入场区进入比赛场地。当替补队员从延长球门线后方进入飞行换人区，且离场队员与替补队员二人均在水中、位于比赛场地之外、并在水面以上击掌时，亦允许从飞行换人区换人。替补队员应做好准备、随时替换且不得拖延。若替补队员未准备好，比赛将在没有该替补的情况下继续，该替补此后可在任何时刻从本队指定换人区进入比赛场地（适用时须先击掌）。若队员经罚出再入场区或飞行换人区离场而未被替补替换，则该同一队员可从同一罚出再入场区或飞行换人区重新进入比赛场地。"
      },
      {
        "number": "2.7",
        "html": "<p>若守门员、或（适用时）替补守门员无资格或无法参赛，以 7 名队员比赛的球队可启用一名享有守门员权利的替代守门员。该替代守门员应佩戴红色泳帽，号码与其作为场上队员时所戴号码相同。被替补替换下场的守门员不得在守门员以外的任何位置比赛。替代守门员的换人及换帽必须在替补席处进行，并须遵守相关换人规则。</p>",
        "text": "若守门员、或（适用时）替补守门员无资格或无法参赛，以 7 名队员比赛的球队可启用一名享有守门员权利的替代守门员。该替代守门员应佩戴红色泳帽，号码与其作为场上队员时所戴号码相同。被替补替换下场的守门员不得在守门员以外的任何位置比赛。替代守门员的换人及换帽必须在替补席处进行，并须遵守相关换人规则。"
      },
      {
        "number": "2.8",
        "html": "<p>除流血或受伤外，自裁判员判予罚点球起至该球掷出止的期间，不得依本规则进行换人（暂停期间除外）。</p>",
        "text": "除流血或受伤外，自裁判员判予罚点球起至该球掷出止的期间，不得依本规则进行换人（暂停期间除外）。"
      },
      {
        "number": "2.9",
        "html": "<p>替补队员可在下列任何地点进入比赛场地：(a) 节与节之间的间歇期间；(b) 进球之后；(c) 暂停期间；(d) 替换流血或受伤的队员。</p>",
        "text": "替补队员可在下列任何地点进入比赛场地：(a) 节与节之间的间歇期间；(b) 进球之后；(c) 暂停期间；(d) 替换流血或受伤的队员。"
      },
      {
        "number": "2.10",
        "html": "<p>若队员出于本人主动，在罚出再入场区或指定横向换人区以外的地点离开比赛场地（而非从指定横向换人区进行换人），该队员不会因离场受罚；该队员或其替补只有经裁判员许可，方可从罚出再入场区（重新）进入比赛场地。该队员也可在进球后、暂停后或下一节开始时重新入场。</p>",
        "text": "若队员出于本人主动，在罚出再入场区或指定横向换人区以外的地点离开比赛场地（而非从指定横向换人区进行换人），该队员不会因离场受罚；该队员或其替补只有经裁判员许可，方可从罚出再入场区（重新）进入比赛场地。该队员也可在进球后、暂停后或下一节开始时重新入场。"
      }
    ]
  },
  {
    "id": "s3",
    "no": "3",
    "title": "裁判员与技术官员",
    "en": "Referees and Technical Officials",
    "clauses": [
      {
        "number": "3.1",
        "html": "<p>在 World Aquatics 赛事中，官员应包括两名裁判员、两名助理裁判员、计时员与记录员，以及两名视频助理裁判员（VAR），各自拥有第六部分附录 5 规定的权力与职责，并（适用时）遵循第六部分附录 7 规定的程序。</p>",
        "text": "在 World Aquatics 赛事中，官员应包括两名裁判员、两名助理裁判员、计时员与记录员，以及两名视频助理裁判员（VAR），各自拥有第六部分附录 5 规定的权力与职责，并（适用时）遵循第六部分附录 7 规定的程序。"
      },
      {
        "number": "3.2",
        "html": "<p>为执行规则，裁判员对比赛拥有绝对控制权；其对队员、球队官员及观众的权力，自其进入比赛场馆起至离开场馆止均为有效。</p>",
        "text": "为执行规则，裁判员对比赛拥有绝对控制权；其对队员、球队官员及观众的权力，自其进入比赛场馆起至离开场馆止均为有效。"
      },
      {
        "number": "3.3",
        "html": "<p>裁判员有下列权力：</p>\n        <ul class=\"dash\">\n          <li>判予或不判予任何普通犯规、排他犯规或点球犯规，同时鼓励进攻、保护进攻方的有利（<span class=\"term\">advantage</span>）。若判罚反而有利于犯规方球队，裁判员可不予判罚；</li>\n          <li>命令将任何行为妨碍裁判员以适当、公正方式履行职责的队员、替补、观众或官员逐出泳池范围或场馆；</li>\n          <li>在任何时刻，若队员或观众的行为、或其他情形致使比赛无法正常完成，可终止比赛。</li>\n        </ul>",
        "text": "裁判员有下列权力： 判予或不判予任何普通犯规、排他犯规或点球犯规，同时鼓励进攻、保护进攻方的有利（advantage）。若判罚反而有利于犯规方球队，裁判员可不予判罚； 命令将任何行为妨碍裁判员以适当、公正方式履行职责的队员、替补、观众或官员逐出泳池范围或场馆； 在任何时刻，若队员或观众的行为、或其他情形致使比赛无法正常完成，可终止比赛。"
      }
    ]
  },
  {
    "id": "s4",
    "no": "4",
    "title": "比赛时长",
    "en": "Duration of the Game",
    "clauses": [
      {
        "number": "4.1",
        "html": "<p>比赛时长为四节，每节 8 分钟实际比赛时间（<span class=\"term\">actual play</span>）。每节计时自队员触球时开始。在每次停表信号发出后，计时应停止，直至主罚相应掷球的队员将球脱手使球重新进入比赛、或中立球后球被队员触及为止。</p>",
        "text": "比赛时长为四节，每节 8 分钟实际比赛时间（actual play）。每节计时自队员触球时开始。在每次停表信号发出后，计时应停止，直至主罚相应掷球的队员将球脱手使球重新进入比赛、或中立球后球被队员触及为止。"
      },
      {
        "number": "4.1.1",
        "html": "<p>最长控球时间为 28 秒。</p>",
        "text": "最长控球时间为 28 秒。"
      },
      {
        "number": "4.2",
        "html": "<p>第一节与第二节之间、第三节与第四节之间各有 2 分钟间歇；第二节与第三节之间有 5 分钟间歇。各队（含队员、教练和官员）应在第三节开始前交换场地。</p>",
        "text": "第一节与第二节之间、第三节与第四节之间各有 2 分钟间歇；第二节与第三节之间有 5 分钟间歇。各队（含队员、教练和官员）应在第三节开始前交换场地。"
      },
      {
        "number": "4.3",
        "html": "<p>每场 World Aquatics 水球比赛在常规时间结束时均须分出胜负。应按第六部分附录 6 的规定进行点球大战（<span class=\"term\">penalty shoot out</span>）以决定结果。若在最初五轮点球结束后两队仍然战平，则由同样的五名队员轮流主罚，直至一队罚失而另一队罚中为止。</p>",
        "text": "每场 World Aquatics 水球比赛在常规时间结束时均须分出胜负。应按第六部分附录 6 的规定进行点球大战（penalty shoot out）以决定结果。若在最初五轮点球结束后两队仍然战平，则由同样的五名队员轮流主罚，直至一队罚失而另一队罚中为止。"
      },
      {
        "number": "4.4",
        "html": "<p>若某场比赛（或比赛的一部分）必须重赛，则在须重赛的时段内发生的进球、个人犯规和暂停应从比赛记录表中删除；但因暴力行为、不当行为而被罚出，以及任何红牌罚出，均须记录于比赛记录表中。</p>",
        "text": "若某场比赛（或比赛的一部分）必须重赛，则在须重赛的时段内发生的进球、个人犯规和暂停应从比赛记录表中删除；但因暴力行为、不当行为而被罚出，以及任何红牌罚出，均须记录于比赛记录表中。"
      }
    ]
  },
  {
    "id": "s5",
    "no": "5",
    "title": "暂停",
    "en": "Timeouts",
    "clauses": [
      {
        "number": "5.1",
        "html": "<p>每队每场比赛可请求两次暂停，每次时长为 1 分钟。控球方球队的教练可在任何时刻（包括进球后，但 VAR 回看期间除外）请求暂停，方式为高呼“暂停（timeout）”并以双手做出 T 形手势向记录台或裁判员示意。当某队的一名队员持球或带球游动时，即视为该队控球。一旦请求暂停，记录员或裁判员应立即鸣哨停止比赛，队员须立即返回各自半场。暂停请求也可通过任何获准在比赛中使用的设备提出。</p>",
        "text": "每队每场比赛可请求两次暂停，每次时长为 1 分钟。控球方球队的教练可在任何时刻（包括进球后，但 VAR 回看期间除外）请求暂停，方式为高呼“暂停（timeout）”并以双手做出 T 形手势向记录台或裁判员示意。当某队的一名队员持球或带球游动时，即视为该队控球。一旦请求暂停，记录员或裁判员应立即鸣哨停止比赛，队员须立即返回各自半场。暂停请求也可通过任何获准在比赛中使用的设备提出。"
      },
      {
        "number": "5.2",
        "html": "<p>比赛应在裁判员鸣哨后、由控球方球队在中线上或中线后将球掷入比赛而重新开始；但若暂停是在裁判员判予罚点球起至该球掷出止的期间请求的，则该罚点球仍予保留。</p>",
        "text": "比赛应在裁判员鸣哨后、由控球方球队在中线上或中线后将球掷入比赛而重新开始；但若暂停是在裁判员判予罚点球起至该球掷出止的期间请求的，则该罚点球仍予保留。"
      },
      {
        "number": "5.3",
        "html": "<p>若控球方球队的教练请求一次该队无权享有的额外暂停，比赛应停止，随后由对方球队的一名队员在中线处将球掷入比赛而重新开始。</p>",
        "text": "若控球方球队的教练请求一次该队无权享有的额外暂停，比赛应停止，随后由对方球队的一名队员在中线处将球掷入比赛而重新开始。"
      },
      {
        "number": "5.4",
        "html": "<p>若非控球方球队的教练请求暂停，比赛应停止，并判予对方球队一个罚点球。提出此违例暂停后，该教练即丧失请求合法暂停的权利（即使该队仍有暂停名额）。</p>",
        "text": "若非控球方球队的教练请求暂停，比赛应停止，并判予对方球队一个罚点球。提出此违例暂停后，该教练即丧失请求合法暂停的权利（即使该队仍有暂停名额）。"
      },
      {
        "number": "5.5",
        "html": "<p>暂停后重新开始时，队员可在比赛场地内任取位置；但若暂停是在裁判员判予罚点球起至该球掷出止的期间请求的，则须遵守关于角球或罚点球掷球的相关规则。</p>",
        "text": "暂停后重新开始时，队员可在比赛场地内任取位置；但若暂停是在裁判员判予罚点球起至该球掷出止的期间请求的，则须遵守关于角球或罚点球掷球的相关规则。"
      }
    ]
  },
  {
    "id": "s6",
    "no": "6",
    "title": "比赛的开始与重新开始",
    "en": "Start and Restart of Play",
    "clauses": [
      {
        "number": "6.1",
        "html": "<p>在正式秩序册中列于前者的球队，佩戴白色泳帽或反映其国家颜色的泳帽，并在记录台左侧开始比赛。另一队佩戴蓝色泳帽或对比色泳帽，在记录台右侧开始比赛。</p>",
        "text": "在正式秩序册中列于前者的球队，佩戴白色泳帽或反映其国家颜色的泳帽，并在记录台左侧开始比赛。另一队佩戴蓝色泳帽或对比色泳帽，在记录台右侧开始比赛。"
      },
      {
        "number": "6.2",
        "html": "<p>每节开始时，队员必须在各自的球门线上就位，彼此相距约 1 米，且距球门柱至少 1 米。球门柱之间至多允许 2 名队员。在水面位置，队员身体的任何部位都不得越过球门线。</p>",
        "text": "每节开始时，队员必须在各自的球门线上就位，彼此相距约 1 米，且距球门柱至少 1 米。球门柱之间至多允许 2 名队员。在水面位置，队员身体的任何部位都不得越过球门线。"
      },
      {
        "number": "6.3",
        "html": "<p>当裁判员确认两队均已准备就绪后，裁判员应鸣哨开始，并在中线上放球或将球掷入比赛。</p>",
        "text": "当裁判员确认两队均已准备就绪后，裁判员应鸣哨开始，并在中线上放球或将球掷入比赛。"
      },
      {
        "number": "6.4",
        "html": "<p>进球后，队员应在各自半场内任意位置就位。在水面位置，队员身体的任何部位都不得越过中线。裁判员应鸣哨重新开始比赛。重新开始时，当未进球一方球队的一名队员将球脱手时，实际比赛即恢复。未按本规则进行的重新开始须重新执行。</p>",
        "text": "进球后，队员应在各自半场内任意位置就位。在水面位置，队员身体的任何部位都不得越过中线。裁判员应鸣哨重新开始比赛。重新开始时，当未进球一方球队的一名队员将球脱手时，实际比赛即恢复。未按本规则进行的重新开始须重新执行。"
      }
    ]
  },
  {
    "id": "s7",
    "no": "7",
    "title": "得分方式",
    "en": "Method of Scoring",
    "clauses": [
      {
        "number": "7.1",
        "html": "<p>当整个球完全越过球门线、在两球门柱之间且横梁之下通过时，即为进球。球门线是一条假想的“激光线”，在正面从一根球门柱延伸至另一根球门柱。当球如位置 D 所示完全越过球门线时即为进球；进球可在比赛场地内任何位置、用除握拳之外的身体任何部位完成。</p>",
        "text": "当整个球完全越过球门线、在两球门柱之间且横梁之下通过时，即为进球。球门线是一条假想的“激光线”，在正面从一根球门柱延伸至另一根球门柱。当球如位置 D 所示完全越过球门线时即为进球；进球可在比赛场地内任何位置、用除握拳之外的身体任何部位完成。"
      },
      {
        "number": "7.2",
        "html": "<p>进球也可通过下列方式取得：</p>\n        <ol class=\"alpha\">\n          <li>在比赛开始或任何重新开始时，须经至少两名队员（任一方均可，但不含防守方守门员）有意触球或触及球之后；</li>\n          <li>通过罚点球；</li>\n          <li>若队员在主罚任意球时将球掷入本方球门；</li>\n          <li>通过在 6 米外由队员主罚的球门球、角球或任意球的直接射门取得——但下列重新开始情形除外:进球后、暂停后、中立球后、裁判员因受伤/换帽或任何其他原因叫球后，或球从场地边线出界后；</li>\n          <li>由明显将球掷入比赛的队员，在角球或 6 米外的下列情形中取得：\n            <ul class=\"dash\">\n              <li>球门球开出后；</li>\n              <li>游泳上前（swim up）或某节开始后；</li>\n              <li>暂停后或进球后；</li>\n              <li>受伤后；</li>\n              <li>换帽后；</li>\n              <li>裁判员叫球或判中立球后；</li>\n              <li>球从场地边线出界后；</li>\n              <li>主罚在 6 米外判予的任意球时；</li>\n              <li>任何其他延误之后。</li>\n            </ul>\n          </li>\n          <li>由明显在 6 米内将球掷入比赛、随后游至 6 米外的队员，在下列情形中取得：\n            <ul class=\"dash\">\n              <li>受伤后；</li>\n              <li>换帽后；</li>\n              <li>裁判员叫球或判中立球后；</li>\n              <li>球从场地边线出界后；</li>\n              <li>主罚任意球时；</li>\n              <li>任何其他延误之后。</li>\n            </ul>\n          </li>\n        </ol>",
        "text": "进球也可通过下列方式取得： 在比赛开始或任何重新开始时，须经至少两名队员（任一方均可，但不含防守方守门员）有意触球或触及球之后； 通过罚点球； 若队员在主罚任意球时将球掷入本方球门； 通过在 6 米外由队员主罚的球门球、角球或任意球的直接射门取得——但下列重新开始情形除外:进球后、暂停后、中立球后、裁判员因受伤/换帽或任何其他原因叫球后，或球从场地边线出界后； 由明显将球掷入比赛的队员，在角球或 6 米外的下列情形中取得： 球门球开出后； 游泳上前（swim up）或某节开始后； 暂停后或进球后； 受伤后； 换帽后； 裁判员叫球或判中立球后； 球从场地边线出界后； 主罚在 6 米外判予的任意球时； 任何其他延误之后。 由明显在 6 米内将球掷入比赛、随后游至 6 米外的队员，在下列情形中取得： 受伤后； 换帽后； 裁判员叫球或判中立球后； 球从场地边线出界后； 主罚任意球时； 任何其他延误之后。"
      },
      {
        "number": "7.3",
        "html": "<p>若在控球时间届满时或某节结束时，球正在飞行中或正朝球门移动并进入球门（包括在水面弹跳、击中球门柱、守门员或另一名队员之后入门），该球应计为进球；但被另一名进攻方队员有意触球或触及的情形除外。</p>",
        "text": "若在控球时间届满时或某节结束时，球正在飞行中或正朝球门移动并进入球门（包括在水面弹跳、击中球门柱、守门员或另一名队员之后入门），该球应计为进球；但被另一名进攻方队员有意触球或触及的情形除外。"
      }
    ]
  },
  {
    "id": "s8",
    "no": "8",
    "title": "普通犯规",
    "en": "Ordinary Fouls",
    "clauses": [
      {
        "number": "8.1",
        "html": "<p>实施下列任一行为（第六部分第 8.2 至 8.15 条）即为普通犯规，除规则另有规定外，应判予对方球队一个任意球。</p>",
        "text": "实施下列任一行为（第六部分第 8.2 至 8.15 条）即为普通犯规，除规则另有规定外，应判予对方球队一个任意球。"
      },
      {
        "number": "8.2",
        "html": "<p>在某节开始时、于裁判员发出开始信号之前越过球门线前进。该任意球应在球所在位置主罚；若球尚未被放入比赛场地，则在中线处主罚。</p>",
        "text": "在某节开始时、于裁判员发出开始信号之前越过球门线前进。该任意球应在球所在位置主罚；若球尚未被放入比赛场地，则在中线处主罚。"
      },
      {
        "number": "8.3",
        "html": "<p>在某节开始时或比赛中任何其他时刻借力托举或协助（assist）某名队员。</p>",
        "text": "在某节开始时或比赛中任何其他时刻借力托举或协助（assist）某名队员。"
      },
      {
        "number": "8.4",
        "html": "<p>在实际比赛中或某节开始时，抓扶球门柱或其附属装置、或从其借力，抓扶池壁（池侧或池端）或从池壁借力。</p>",
        "text": "在实际比赛中或某节开始时，抓扶球门柱或其附属装置、或从其借力，抓扶池壁（池侧或池端）或从池壁借力。"
      },
      {
        "number": "8.5",
        "html": "<p>站在池底时积极参与比赛、在比赛进行中行走、或从池底起跳去触球或抢截对手。本条不适用于处于本方 6 米区域内的守门员。</p>",
        "text": "站在池底时积极参与比赛、在比赛进行中行走、或从池底起跳去触球或抢截对手。本条不适用于处于本方 6 米区域内的守门员。"
      },
      {
        "number": "8.6",
        "html": "<p>被抢截时将整个球压入或抓在水下，或故意将球藏匿以躲避对方球队。</p>",
        "text": "被抢截时将整个球压入或抓在水下，或故意将球藏匿以躲避对方球队。"
      },
      {
        "number": "8.7",
        "html": "<p>以握拳击球，但在 6 米区域内的守门员除外。</p>",
        "text": "以握拳击球，但在 6 米区域内的守门员除外。"
      },
      {
        "number": "8.8",
        "html": "<p>同时用双手触球或处理球，但在 6 米区域内的守门员除外。</p>",
        "text": "同时用双手触球或处理球，但在 6 米区域内的守门员除外。"
      },
      {
        "number": "8.9",
        "html": "<p>推搡未持球的对手、或从未持球的对手身上借力。</p>",
        "text": "推搡未持球的对手、或从未持球的对手身上借力。"
      },
      {
        "number": "8.10",
        "html": "<p>进入对方球门区（<span class=\"term\">goal area</span>），除非位于球的位置线之后。若队员处于 2 米线以内但在球门区之外，则不构成违规。任何位于球的位置线之后的队员均可进入球门区接球。任何位于球门区内、未射门而将球向后传出的队员，必须立即离开球门区，以免依本条受罚。</p>",
        "text": "进入对方球门区（goal area），除非位于球的位置线之后。若队员处于 2 米线以内但在球门区之外，则不构成违规。任何位于球的位置线之后的队员均可进入球门区接球。任何位于球门区内、未射门而将球向后传出的队员，必须立即离开球门区，以免依本条受罚。"
      },
      {
        "number": "8.11",
        "html": "<p>以非规定方式主罚任意球、球门球、角球或罚点球，但第六部分第 12.2 条与第 13.4 条规定的情形除外。</p>",
        "text": "以非规定方式主罚任意球、球门球、角球或罚点球，但第六部分第 12.2 条与第 13.4 条规定的情形除外。"
      },
      {
        "number": "8.12",
        "html": "<p>球队保持控球而不射向对方球门的时间不得超过 (i) 28 秒实际比赛时间。</p>\n        <p>在男子组别中，球队保持控球而不射向对方球门的具体时间限制概括如下（记录控球时间的计时员应据此重置计时钟）：</p>\n        <ol class=\"alpha\">\n          <li>在射门队员将球脱手后，若球从球门柱、某名队员或守门员处反弹回比赛中，则在球被任一球队控制之前控球时间不重新计时。若球被进攻方控制，计时钟重置为 18 秒；若被防守方控制，则重置为 28 秒；</li>\n          <li>当球被防守方控制时，计时钟重置为 28 秒控球时间；</li>\n          <li>当因对防守方队员判予排他犯规而将球掷入比赛时，计时钟重置为 18 秒控球时间；但若剩余控球时间多于 18 秒，则计时继续、不予重置；</li>\n          <li>当在未发生控球权转换的罚点球之后、或在角球之后将球掷入比赛时，计时钟重置为 18 秒控球时间。当球因防守队员的故意行为、或防守方守门员封挡射门而经边线离开比赛场地时，亦重置为 18 秒控球时间；</li>\n          <li>当在发生控球权转换的罚点球之后、或在球门球、中立球之后将球掷入比赛时，计时钟重置为 28 秒控球时间。</li>\n        </ol>\n        <p>可视计时钟应以递减方式显示时间（即显示剩余控球时间）。</p>",
        "text": "球队保持控球而不射向对方球门的时间不得超过 (i) 28 秒实际比赛时间。 在男子组别中，球队保持控球而不射向对方球门的具体时间限制概括如下（记录控球时间的计时员应据此重置计时钟）： 在射门队员将球脱手后，若球从球门柱、某名队员或守门员处反弹回比赛中，则在球被任一球队控制之前控球时间不重新计时。若球被进攻方控制，计时钟重置为 18 秒；若被防守方控制，则重置为 28 秒； 当球被防守方控制时，计时钟重置为 28 秒控球时间； 当因对防守方队员判予排他犯规而将球掷入比赛时，计时钟重置为 18 秒控球时间；但若剩余控球时间多于 18 秒，则计时继续、不予重置； 当在未发生控球权转换的罚点球之后、或在角球之后将球掷入比赛时，计时钟重置为 18 秒控球时间。当球因防守队员的故意行为、或防守方守门员封挡射门而经边线离开比赛场地时，亦重置为 18 秒控球时间； 当在发生控球权转换的罚点球之后、或在球门球、中立球之后将球掷入比赛时，计时钟重置为 28 秒控球时间。 可视计时钟应以递减方式显示时间（即显示剩余控球时间）。"
      },
      {
        "number": "8.13",
        "html": "<p>球队故意放弃控球。</p>",
        "text": "球队故意放弃控球。"
      },
      {
        "number": "8.14",
        "html": "<p>假摔（模拟被犯规）。</p>",
        "text": "假摔（模拟被犯规）。"
      },
      {
        "number": "8.15",
        "html": "<p>潜入水下以获取位置优势。</p>",
        "text": "潜入水下以获取位置优势。"
      }
    ]
  },
  {
    "id": "s9",
    "no": "9",
    "title": "排他犯规",
    "en": "Exclusion Fouls",
    "clauses": [
      {
        "number": "9.1",
        "html": "<p>实施下列任一行为（第六部分第 9.4 至 9.18 条）即为排他犯规，除规则另有规定外，应判予对方球队一个任意球，并将犯规队员罚出。</p>",
        "text": "实施下列任一行为（第六部分第 9.4 至 9.18 条）即为排他犯规，除规则另有规定外，应判予对方球队一个任意球，并将犯规队员罚出。"
      },
      {
        "number": "9.2",
        "html": "<p>被罚出的队员（包括被罚出、不得参加比赛余下部分的队员）必须立即在任何地点离开比赛场地（但不离开水面），并在不干扰比赛的情况下，移动至距本方球门线最近的罚出再入场区（须明显浮出水面）。</p>",
        "text": "被罚出的队员（包括被罚出、不得参加比赛余下部分的队员）必须立即在任何地点离开比赛场地（但不离开水面），并在不干扰比赛的情况下，移动至距本方球门线最近的罚出再入场区（须明显浮出水面）。"
      },
      {
        "number": "9.3",
        "html": "<p>被罚出队员或其替补，在下列情形中最先发生者出现后，可从距本方球门线最近的再入场区重新进入比赛场地：</p>\n        <ol class=\"alpha\">\n          <li>已过去 18 秒实际比赛时间——此时记录员应升起相应旗帜，或通过任何获准在比赛中使用的设备示意 18 秒实际比赛时间已过；</li>\n          <li>已有进球——此时被罚出队员或替补可从任何地点重新进入比赛场地；</li>\n          <li>被罚出队员的球队在实际比赛中重新获得控球权——此时防守端裁判员应以手势示意可再入场；</li>\n          <li>被罚出队员的球队获得任意球、球门球或罚点球。</li>\n        </ol>\n        <p>被罚出队员或其替补不得：</p>\n        <ul class=\"dash\">\n          <li>从池侧、池壁或比赛场地起跳或借力；</li>\n          <li>影响球门的对位（对齐）；</li>\n          <li>在被罚出队员到达距本方球门线最近的罚出再入场区之前替其入场（节间、进球后或暂停期间除外）。当被罚出队员已累计三次个人犯规、或依规则被罚出不得参加比赛余下部分时，上述规定同样适用于替补的入场。</li>\n        </ul>",
        "text": "被罚出队员或其替补，在下列情形中最先发生者出现后，可从距本方球门线最近的再入场区重新进入比赛场地： 已过去 18 秒实际比赛时间——此时记录员应升起相应旗帜，或通过任何获准在比赛中使用的设备示意 18 秒实际比赛时间已过； 已有进球——此时被罚出队员或替补可从任何地点重新进入比赛场地； 被罚出队员的球队在实际比赛中重新获得控球权——此时防守端裁判员应以手势示意可再入场； 被罚出队员的球队获得任意球、球门球或罚点球。 被罚出队员或其替补不得： 从池侧、池壁或比赛场地起跳或借力； 影响球门的对位（对齐）； 在被罚出队员到达距本方球门线最近的罚出再入场区之前替其入场（节间、进球后或暂停期间除外）。当被罚出队员已累计三次个人犯规、或依规则被罚出不得参加比赛余下部分时，上述规定同样适用于替补的入场。"
      },
      {
        "number": "9.4",
        "html": "<p>比赛中离开水面（替补入场的情形除外）、或坐/站在池梯或池侧的队员，除事故、受伤、疾病或经裁判员许可外，应视为违反第六部分第 9.13 条（不当行为）。</p>",
        "text": "比赛中离开水面（替补入场的情形除外）、或坐/站在池梯或池侧的队员，除事故、受伤、疾病或经裁判员许可外，应视为违反第六部分第 9.13 条（不当行为）。"
      },
      {
        "number": "9.5",
        "html": "<p>干扰任意球、球门球或角球的主罚，包括：(a) 故意将球掷开或拒不放球，以阻碍比赛正常进行；(b) 在球离开主罚者之手前任何试图触球的行为。</p>",
        "text": "干扰任意球、球门球或角球的主罚，包括：(a) 故意将球掷开或拒不放球，以阻碍比赛正常进行；(b) 在球离开主罚者之手前任何试图触球的行为。"
      },
      {
        "number": "9.6",
        "html": "<p>在 6 米区域外用双手试图封挡传球或射门。</p>",
        "text": "在 6 米区域外用双手试图封挡传球或射门。"
      },
      {
        "number": "9.7",
        "html": "<p>故意向对手脸部泼水。</p>",
        "text": "故意向对手脸部泼水。"
      },
      {
        "number": "9.8",
        "html": "<p>妨碍或以其他方式阻止未持球对手的自由移动，包括压游于对手的肩、背或腿上，或潜入水下妨碍对手占位。“持球（Holding）”指举球、托球或触球，但不包括运球（dribbling）。</p>",
        "text": "妨碍或以其他方式阻止未持球对手的自由移动，包括压游于对手的肩、背或腿上，或潜入水下妨碍对手占位。“持球（Holding）”指举球、托球或触球，但不包括运球（dribbling）。"
      },
      {
        "number": "9.9",
        "html": "<p>抓拉、按沉或回拽未持球的对手。</p>",
        "text": "抓拉、按沉或回拽未持球的对手。"
      },
      {
        "number": "9.10",
        "html": "<p>在比赛场地任何位置，用双手抓握未持球的对手。</p>",
        "text": "在比赛场地任何位置，用双手抓握未持球的对手。"
      },
      {
        "number": "9.11",
        "html": "<p>战术犯规。在比赛场地任何位置，防守队员对控球方任一队员实施犯规、意图中断进攻节奏。此类犯规称为战术犯规（<span class=\"term\">tactical foul</span>）。</p>",
        "text": "战术犯规。在比赛场地任何位置，防守队员对控球方任一队员实施犯规、意图中断进攻节奏。此类犯规称为战术犯规（tactical foul）。"
      },
      {
        "number": "9.12",
        "html": "<p>做出不成比例的过分动作，包括踢踹和击打。</p>",
        "text": "做出不成比例的过分动作，包括踢踹和击打。"
      },
      {
        "number": "9.13",
        "html": "<p>有不当行为（<span class=\"term\">misconduct</span>），包括使用不可接受的言语、侵略性动作、拒不服从或不尊重裁判员或官员，或违背规则精神、可能损害比赛声誉的行为。</p>",
        "text": "有不当行为（misconduct），包括使用不可接受的言语、侵略性动作、拒不服从或不尊重裁判员或官员，或违背规则精神、可能损害比赛声誉的行为。"
      },
      {
        "number": "9.13.1",
        "html": "<p>若此情形发生在比赛进行中，违规队员应被罚出、不得参加比赛余下部分，并在第六部分第 9.3 条所述最先发生的情形之后方可换人；该队员必须离开比赛区域。</p>",
        "text": "若此情形发生在比赛进行中，违规队员应被罚出、不得参加比赛余下部分，并在第六部分第 9.3 条所述最先发生的情形之后方可换人；该队员必须离开比赛区域。"
      },
      {
        "number": "9.13.2",
        "html": "<p>若该事件发生在任何停表期间、节间间歇、暂停期间或进球之后，该队员应被罚出、不得参加比赛余下部分；替补队员可在比赛重新开始前立即再入场，比赛以正常方式重新开始。</p>",
        "text": "若该事件发生在任何停表期间、节间间歇、暂停期间或进球之后，该队员应被罚出、不得参加比赛余下部分；替补队员可在比赛重新开始前立即再入场，比赛以正常方式重新开始。"
      },
      {
        "number": "9.13.3",
        "html": "<p>当一队的一名或多名队员持续重复犯规（侵略性动作或不当行为除外），或在未使用不可接受言语的情况下抗议裁判员或官员的判罚时，裁判员可向该违规球队出示黄牌。若该行为继续，裁判员将依第六部分第 9.13 条（不当行为）向同队的违规队员出示红牌，将其罚出、不得参加比赛余下部分。</p>",
        "text": "当一队的一名或多名队员持续重复犯规（侵略性动作或不当行为除外），或在未使用不可接受言语的情况下抗议裁判员或官员的判罚时，裁判员可向该违规球队出示黄牌。若该行为继续，裁判员将依第六部分第 9.13 条（不当行为）向同队的违规队员出示红牌，将其罚出、不得参加比赛余下部分。"
      },
      {
        "number": "9.14",
        "html": "<p>实施暴力行为（<span class=\"term\">violent action</span>），包括在实际比赛中、任何停表、暂停、进球后或节间间歇期间，怀恶意踢打或试图踢打对手或官员。若违规者为守门员，可依第六部分第 2.6 条用另一名队员替换替补守门员。</p>",
        "text": "实施暴力行为（violent action），包括在实际比赛中、任何停表、暂停、进球后或节间间歇期间，怀恶意踢打或试图踢打对手或官员。若违规者为守门员，可依第六部分第 2.6 条用另一名队员替换替补守门员。"
      },
      {
        "number": "9.14.1",
        "html": "<p>若此情形发生在比赛进行中，违规队员应被罚出、不得参加比赛余下部分、必须离开比赛区域，并判予对方球队一个罚点球。该违规队员在 4 分钟实际比赛时间过去后方可被替补替换。</p>",
        "text": "若此情形发生在比赛进行中，违规队员应被罚出、不得参加比赛余下部分、必须离开比赛区域，并判予对方球队一个罚点球。该违规队员在 4 分钟实际比赛时间过去后方可被替补替换。"
      },
      {
        "number": "9.14.2",
        "html": "<p>若该事件发生在任何停表、暂停、进球后或节间间歇期间，该队员应被罚出、不得参加比赛余下部分并必须离开比赛区域，不判予罚点球。该违规队员在 4 分钟实际比赛时间过去后方可被替补替换。比赛以正常方式重新开始。</p>",
        "text": "若该事件发生在任何停表、暂停、进球后或节间间歇期间，该队员应被罚出、不得参加比赛余下部分并必须离开比赛区域，不判予罚点球。该违规队员在 4 分钟实际比赛时间过去后方可被替补替换。比赛以正常方式重新开始。"
      },
      {
        "number": "9.14.3",
        "html": "<p>若裁判员在比赛中同时判罚对阵双方队员的暴力行为，则两名队员均被罚出、不得参加比赛余下部分，并在 4 分钟实际比赛时间过去后方可换人。原控球方球队先主罚一个罚点球，随后另一队主罚一个罚点球。第二个罚点球之后，由原控球方球队在中线上或中线后以任意球重新开始比赛。</p>",
        "text": "若裁判员在比赛中同时判罚对阵双方队员的暴力行为，则两名队员均被罚出、不得参加比赛余下部分，并在 4 分钟实际比赛时间过去后方可换人。原控球方球队先主罚一个罚点球，随后另一队主罚一个罚点球。第二个罚点球之后，由原控球方球队在中线上或中线后以任意球重新开始比赛。"
      },
      {
        "number": "9.15",
        "html": "<p>若在比赛中同时罚出对阵双方的队员，则两名队员均被罚出 18 秒，直至第六部分第 9.3 条所述最先发生的情形出现、或至下一次控球权转换为止；控球计时钟不重置。比赛由原控球方球队以任意球重新开始。若判罚同时罚出时两队均未控球，则控球计时钟重置为 28 秒，比赛以中立球重新开始。依本条被罚出的两名队员，均可在第六部分第 9.3 条 (a)(b) 所述下一最先发生的情形出现时、或下一次控球权转换时重新入场。</p>",
        "text": "若在比赛中同时罚出对阵双方的队员，则两名队员均被罚出 18 秒，直至第六部分第 9.3 条所述最先发生的情形出现、或至下一次控球权转换为止；控球计时钟不重置。比赛由原控球方球队以任意球重新开始。若判罚同时罚出时两队均未控球，则控球计时钟重置为 28 秒，比赛以中立球重新开始。依本条被罚出的两名队员，均可在第六部分第 9.3 条 (a)(b) 所述下一最先发生的情形出现时、或下一次控球权转换时重新入场。"
      },
      {
        "number": "9.16",
        "html": "<p>干扰罚点球的主罚。违规队员应被罚出、不得参加比赛余下部分，并在第六部分第 9.3 条所述最先发生的情形之后方可换人；该罚点球应视情况予以保留或重罚。裁判员可使用 VAR 系统判定是否存在对罚点球的干扰。此违规可能发生在裁判员鸣哨之后。参见第六部分第 15.2 条。</p>",
        "text": "干扰罚点球的主罚。违规队员应被罚出、不得参加比赛余下部分，并在第六部分第 9.3 条所述最先发生的情形之后方可换人；该罚点球应视情况予以保留或重罚。裁判员可使用 VAR 系统判定是否存在对罚点球的干扰。此违规可能发生在裁判员鸣哨之后。参见第六部分第 15.2 条。"
      },
      {
        "number": "9.17",
        "html": "<p>在主罚罚点球时，防守方守门员经裁判员命令一次后仍未在球门线上占据正确位置。可由另一名防守队员占据守门员的位置，但不享有守门员的权利、亦不受其限制。</p>",
        "text": "在主罚罚点球时，防守方守门员经裁判员命令一次后仍未在球门线上占据正确位置。可由另一名防守队员占据守门员的位置，但不享有守门员的权利、亦不受其限制。"
      },
      {
        "number": "9.18",
        "html": "<p>在主罚罚点球时，若守门员在裁判员鸣哨前向前移动、而主罚队员射门未进，则守门员应依第 9.17 条被罚出，且该罚点球应重罚。</p>",
        "text": "在主罚罚点球时，若守门员在裁判员鸣哨前向前移动、而主罚队员射门未进，则守门员应依第 9.17 条被罚出，且该罚点球应重罚。"
      }
    ]
  },
  {
    "id": "s10",
    "no": "10",
    "title": "点球犯规",
    "en": "Penalty Fouls",
    "clauses": [
      {
        "number": "10.1",
        "html": "<p>实施下列任一行为（第六部分第 10.2 至 10.12 条）即为点球犯规，应判予对方球队一个罚点球。裁判员可延迟鸣哨，观察进攻队员是否在同一动作中进球；若未进球，则裁判员应判罚点球。裁判员可举起一臂，示意可能判罚点球。</p>",
        "text": "实施下列任一行为（第六部分第 10.2 至 10.12 条）即为点球犯规，应判予对方球队一个罚点球。裁判员可延迟鸣哨，观察进攻队员是否在同一动作中进球；若未进球，则裁判员应判罚点球。裁判员可举起一臂，示意可能判罚点球。"
      },
      {
        "number": "10.2",
        "html": "<p>守门员或防守队员在 6 米区域内实施任何本可能导致进球的犯规，包括第六部分第 10.4 至 10.7 条所列情形。</p>",
        "text": "守门员或防守队员在 6 米区域内实施任何本可能导致进球的犯规，包括第六部分第 10.4 至 10.7 条所列情形。"
      },
      {
        "number": "10.3",
        "html": "<p>被罚出队员故意干扰比赛，包括影响球门的对位。若被罚出队员未几乎立即开始离开比赛场地，裁判员可视其为本规则所指的故意干扰。</p>",
        "text": "被罚出队员故意干扰比赛，包括影响球门的对位。若被罚出队员未几乎立即开始离开比赛场地，裁判员可视其为本规则所指的故意干扰。"
      },
      {
        "number": "10.4",
        "html": "<p>守门员或防守队员拉拽、拉倒或以其他方式移动球门。</p>",
        "text": "守门员或防守队员拉拽、拉倒或以其他方式移动球门。"
      },
      {
        "number": "10.5",
        "html": "<p>防守队员在 6 米区域内用双手试图封挡传球或射门。</p>",
        "text": "防守队员在 6 米区域内用双手试图封挡传球或射门。"
      },
      {
        "number": "10.6",
        "html": "<p>防守队员在 6 米区域内以握拳处理球。</p>",
        "text": "防守队员在 6 米区域内以握拳处理球。"
      },
      {
        "number": "10.7",
        "html": "<p>守门员或防守队员在 6 米区域内被抢截时将球带入水下。</p>",
        "text": "守门员或防守队员在 6 米区域内被抢截时将球带入水下。"
      },
      {
        "number": "10.8",
        "html": "<p>当时依规则无权参加比赛的队员或替补进入比赛场地。该罚点球应在将违规队员移出比赛场地后（必要时包括立即换人）主罚。</p>",
        "text": "当时依规则无权参加比赛的队员或替补进入比赛场地。该罚点球应在将违规队员移出比赛场地后（必要时包括立即换人）主罚。"
      },
      {
        "number": "10.9",
        "html": "<p>非控球方球队的教练或任何球队官员请求暂停。此违规不记个人犯规。</p>",
        "text": "非控球方球队的教练或任何球队官员请求暂停。此违规不记个人犯规。"
      },
      {
        "number": "10.10",
        "html": "<p>教练、任何球队官员或队员采取任何意图阻止可能进球或拖延比赛的行为，包括：</p>\n        <ol class=\"alpha\">\n          <li>防守队员在进攻方能够主罚任意球之前故意将球掷开；</li>\n          <li>防守队员在 6 米线外的任意球之后，故意将球推入 6 米线内，以避免直接射门。</li>\n        </ol>\n        <p>教练或任何球队官员的此项违规不记个人犯规。</p>",
        "text": "教练、任何球队官员或队员采取任何意图阻止可能进球或拖延比赛的行为，包括： 防守队员在进攻方能够主罚任意球之前故意将球掷开； 防守队员在 6 米线外的任意球之后，故意将球推入 6 米线内，以避免直接射门。 教练或任何球队官员的此项违规不记个人犯规。"
      },
      {
        "number": "10.11",
        "html": "<p>当进攻队员面向球门并做出射门动作时，防守队员在 6 米区域内从其身后阻挡该进攻队员，但防守队员仅触及球者除外。若防守队员本规则所述的犯规致使进攻队员未能进球，则还须判罚点球。裁判员须延迟判罚，直至射门或射门尝试完成；除非进攻队员进球，否则须判罚点球。</p>",
        "text": "当进攻队员面向球门并做出射门动作时，防守队员在 6 米区域内从其身后阻挡该进攻队员，但防守队员仅触及球者除外。若防守队员本规则所述的犯规致使进攻队员未能进球，则还须判罚点球。裁判员须延迟判罚，直至射门或射门尝试完成；除非进攻队员进球，否则须判罚点球。"
      },
      {
        "number": "10.12",
        "html": "<p>被罚出队员不当地重新入场、或替补不当地进入比赛场地，包括未遵守第六部分第 2.6、2.7、9.3、9.13.1、9.14.1、9.14.2、9.14.3 及 9.15 条。该队员仅记一次个人犯规，记录员应将其标记为点球犯规。</p>\n        <p>若此情形发生于排他罚出期未满时的（重新）入场，违规队员须在主罚罚点球前离开比赛场地。该队员或其替补可在排他罚出期届满时、或在被罚出队员的球队重新获得控球权、或获得任意球/球门球/罚点球时（重新）入场；但第六部分第 9.14 条的情形除外，该情形下该队员或其替补只能在排他罚出期届满时方可（重新）入场。</p>",
        "text": "被罚出队员不当地重新入场、或替补不当地进入比赛场地，包括未遵守第六部分第 2.6、2.7、9.3、9.13.1、9.14.1、9.14.2、9.14.3 及 9.15 条。该队员仅记一次个人犯规，记录员应将其标记为点球犯规。 若此情形发生于排他罚出期未满时的（重新）入场，违规队员须在主罚罚点球前离开比赛场地。该队员或其替补可在排他罚出期届满时、或在被罚出队员的球队重新获得控球权、或获得任意球/球门球/罚点球时（重新）入场；但第六部分第 9.14 条的情形除外，该情形下该队员或其替补只能在排他罚出期届满时方可（重新）入场。"
      }
    ]
  },
  {
    "id": "s11",
    "no": "11",
    "title": "任意球",
    "en": "Free Throws",
    "clauses": [
      {
        "number": "11.1",
        "html": "<p>任意球应在球所在位置主罚；但若在防守队员犯规后球位于球门区内，则任意球应在球所在位置对面的 2 米线上主罚。若判罚犯规时球已在球门区之外，则任意球在球所在位置主罚。</p>",
        "text": "任意球应在球所在位置主罚；但若在防守队员犯规后球位于球门区内，则任意球应在球所在位置对面的 2 米线上主罚。若判罚犯规时球已在球门区之外，则任意球在球所在位置主罚。"
      },
      {
        "number": "11.2",
        "html": "<p>获得任意球的队员必须不无故拖延地将球掷入比赛，包括（在规则允许时）通过传球或射门。若明显处于最便于主罚任意球位置的队员未予主罚，则为普通犯规。犯规的防守队员在举臂封挡传球或射门之前，须离开主罚任意球的队员至少 1 米；未做到者将依第六部分第 9.5 条以“干扰”论处、被罚出。</p>",
        "text": "获得任意球的队员必须不无故拖延地将球掷入比赛，包括（在规则允许时）通过传球或射门。若明显处于最便于主罚任意球位置的队员未予主罚，则为普通犯规。犯规的防守队员在举臂封挡传球或射门之前，须离开主罚任意球的队员至少 1 米；未做到者将依第六部分第 9.5 条以“干扰”论处、被罚出。"
      },
      {
        "number": "11.3",
        "html": "<p>任意球应由最靠近球的队员不无故拖延地主罚，方式须使各队员能够明显看到球离开主罚队员之手；主罚队员随后也可在传给另一名队员之前持球或运球，或在允许时射门。球在离开主罚任意球队员之手时即刻成为活球。但在出现反击时，队员无需为前去取球主罚任意球而放弃有利；只要不无故拖延，第二靠近球的队员可主罚该球。</p>",
        "text": "任意球应由最靠近球的队员不无故拖延地主罚，方式须使各队员能够明显看到球离开主罚队员之手；主罚队员随后也可在传给另一名队员之前持球或运球，或在允许时射门。球在离开主罚任意球队员之手时即刻成为活球。但在出现反击时，队员无需为前去取球主罚任意球而放弃有利；只要不无故拖延，第二靠近球的队员可主罚该球。"
      },
      {
        "number": "11.4",
        "html": "<p>当球从比赛场地边线出界时（包括球从场地边线反弹），也判予最后触球一方的对方球队一个任意球；但防守方场上队员将射门球封挡出场地边线的情形除外，此时判予防守方球队一个任意球。</p>",
        "text": "当球从比赛场地边线出界时（包括球从场地边线反弹），也判予最后触球一方的对方球队一个任意球；但防守方场上队员将射门球封挡出场地边线的情形除外，此时判予防守方球队一个任意球。"
      }
    ]
  },
  {
    "id": "s12",
    "no": "12",
    "title": "球门球",
    "en": "Goal Throws",
    "clauses": [
      {
        "number": "12.1",
        "html": "<p>当整个球完全越过球门线（但不在两球门柱之间且横梁之下的范围内通过），且最后触球者为防守方守门员以外的任何队员，或防守队员将射门球封挡越过球门线时，应判予球门球。</p>",
        "text": "当整个球完全越过球门线（但不在两球门柱之间且横梁之下的范围内通过），且最后触球者为防守方守门员以外的任何队员，或防守队员将射门球封挡越过球门线时，应判予球门球。"
      },
      {
        "number": "12.2",
        "html": "<p>球门球应依第六部分第 11.3 条，由该队任一队员不无故拖延地主罚，可在 2 米区域内任意位置主罚；若球在 2 米外，则在球所在位置主罚。未按本规则主罚的球门球须重罚。</p>",
        "text": "球门球应依第六部分第 11.3 条，由该队任一队员不无故拖延地主罚，可在 2 米区域内任意位置主罚；若球在 2 米外，则在球所在位置主罚。未按本规则主罚的球门球须重罚。"
      }
    ]
  },
  {
    "id": "s13",
    "no": "13",
    "title": "角球",
    "en": "Corner Throws",
    "clauses": [
      {
        "number": "13.1",
        "html": "<p>当整个球完全越过球门线（但不在两球门柱之间且横梁之下的范围内通过），且最后触球者为防守方守门员、或为防守队员故意触球时，应判予角球。</p>",
        "text": "当整个球完全越过球门线（但不在两球门柱之间且横梁之下的范围内通过），且最后触球者为防守方守门员、或为防守队员故意触球时，应判予角球。"
      },
      {
        "number": "13.2",
        "html": "<p>角球应依第六部分第 11.3 条，由进攻方队员在球越过球门线一侧最近的 2 米标志处不无故拖延地主罚。该球无需由最近的队员主罚。</p>",
        "text": "角球应依第六部分第 11.3 条，由进攻方队员在球越过球门线一侧最近的 2 米标志处不无故拖延地主罚。该球无需由最近的队员主罚。"
      },
      {
        "number": "13.3",
        "html": "<p>主罚角球时，进攻方任何队员都不得位于球门区内。</p>",
        "text": "主罚角球时，进攻方任何队员都不得位于球门区内。"
      },
      {
        "number": "13.4",
        "html": "<p>从错误位置主罚、或在进攻方队员离开球门区之前主罚的角球，须重罚。</p>",
        "text": "从错误位置主罚、或在进攻方队员离开球门区之前主罚的角球，须重罚。"
      }
    ]
  },
  {
    "id": "s14",
    "no": "14",
    "title": "中立球",
    "en": "Neutral Throws",
    "clauses": [
      {
        "number": "14.1",
        "html": "<p>出现下列情形时应判予中立球：</p>\n        <ol class=\"alpha\">\n          <li>在某节开始时，裁判员认为球落入的位置明显有利于某一队；</li>\n          <li>对阵双方的一名或多名队员在同一瞬间实施普通犯规，致使裁判员无法分辨哪名队员先犯规；</li>\n          <li>两名裁判员在同一瞬间鸣哨、分别判予对阵双方普通犯规；</li>\n          <li>两队均未控球，且对阵双方的一名或多名队员在同一瞬间实施排他犯规。中立球应在违规队员被罚出后主罚；</li>\n          <li>球击中头顶上方的障碍物或卡在其中。</li>\n        </ol>",
        "text": "出现下列情形时应判予中立球： 在某节开始时，裁判员认为球落入的位置明显有利于某一队； 对阵双方的一名或多名队员在同一瞬间实施普通犯规，致使裁判员无法分辨哪名队员先犯规； 两名裁判员在同一瞬间鸣哨、分别判予对阵双方普通犯规； 两队均未控球，且对阵双方的一名或多名队员在同一瞬间实施排他犯规。中立球应在违规队员被罚出后主罚； 球击中头顶上方的障碍物或卡在其中。"
      },
      {
        "number": "14.2",
        "html": "<p>主罚中立球时，裁判员应在与事件发生时大致相同的横向位置将球掷入比赛场地，方式须使两队队员有均等的机会触球。在球门区内判予的中立球应在 2 米线上主罚。</p>",
        "text": "主罚中立球时，裁判员应在与事件发生时大致相同的横向位置将球掷入比赛场地，方式须使两队队员有均等的机会触球。在球门区内判予的中立球应在 2 米线上主罚。"
      },
      {
        "number": "14.3",
        "html": "<p>若主罚中立球时裁判员认为球落入的位置明显有利于某一队，裁判员应叫球并重新主罚。</p>",
        "text": "若主罚中立球时裁判员认为球落入的位置明显有利于某一队，裁判员应叫球并重新主罚。"
      }
    ]
  },
  {
    "id": "s15",
    "no": "15",
    "title": "罚点球",
    "en": "Penalty Throws",
    "clauses": [
      {
        "number": "15.1",
        "html": "<p>罚点球应由获判一方的任一队员，在对方 5 米线上的任意一点主罚。</p>",
        "text": "罚点球应由获判一方的任一队员，在对方 5 米线上的任意一点主罚。"
      },
      {
        "number": "15.2",
        "html": "<p>所有队员都应离开 6 米区域，并距主罚队员至少 3 米。在 6 米线上、主罚队员的两侧，防守方各有一名队员享有优先占位权。防守方守门员应位于两球门柱之间，在水面位置其身体任何部位都不得越过球门线。裁判员可对队员或守门员给予一次警告，要求其占据正确位置；若该人未予照做，则该队员或守门员将被罚出，并依第六部分第 9.3 条重新入场。</p>",
        "text": "所有队员都应离开 6 米区域，并距主罚队员至少 3 米。在 6 米线上、主罚队员的两侧，防守方各有一名队员享有优先占位权。防守方守门员应位于两球门柱之间，在水面位置其身体任何部位都不得越过球门线。裁判员可对队员或守门员给予一次警告，要求其占据正确位置；若该人未予照做，则该队员或守门员将被罚出，并依第六部分第 9.3 条重新入场。"
      },
      {
        "number": "15.3",
        "html": "<p>当控制主罚的裁判员确认队员均处于正确位置后，应以鸣哨并同时将手臂由竖直放下至水平的方式，示意主罚。</p>",
        "text": "当控制主罚的裁判员确认队员均处于正确位置后，应以鸣哨并同时将手臂由竖直放下至水平的方式，示意主罚。"
      },
      {
        "number": "15.4",
        "html": "<p>主罚罚点球的队员应控制球，并立即以连贯不间断的动作直接射向球门。队员可将球从水中举起主罚、或将球握于举起的手中主罚；在为前掷做准备时，球可朝背离球门的方向后引，但在球离开主罚者之手前，动作的连贯性不得中断。</p>",
        "text": "主罚罚点球的队员应控制球，并立即以连贯不间断的动作直接射向球门。队员可将球从水中举起主罚、或将球握于举起的手中主罚；在为前掷做准备时，球可朝背离球门的方向后引，但在球离开主罚者之手前，动作的连贯性不得中断。"
      },
      {
        "number": "15.5",
        "html": "<p>若球从球门柱、横梁或守门员处反弹，则球仍为活球，进球前无需另一名队员触球或处理球。</p>",
        "text": "若球从球门柱、横梁或守门员处反弹，则球仍为活球，进球前无需另一名队员触球或处理球。"
      },
      {
        "number": "15.6",
        "html": "<p>若在裁判员判予罚点球的同一精确时刻，计时员鸣哨示意某节结束，则除主罚队员和防守方守门员外，所有队员都应在主罚罚点球之前离开比赛场地、进入各自的飞行换人区。在此情形下，若球从球门柱、横梁或守门员处反弹回比赛中，球应立即成为死球。</p>",
        "text": "若在裁判员判予罚点球的同一精确时刻，计时员鸣哨示意某节结束，则除主罚队员和防守方守门员外，所有队员都应在主罚罚点球之前离开比赛场地、进入各自的飞行换人区。在此情形下，若球从球门柱、横梁或守门员处反弹回比赛中，球应立即成为死球。"
      },
      {
        "number": "15.7",
        "html": "<p>若在比赛最后一分钟内某队获判罚点球，教练可选择保留控球权、改获一个任意球。记录控球时间的计时员应将计时钟重置为 28 秒，比赛如暂停后一样重新开始。若球队希望依本规则保留控球权，教练有责任不拖延地给出明确信号。</p>",
        "text": "若在比赛最后一分钟内某队获判罚点球，教练可选择保留控球权、改获一个任意球。记录控球时间的计时员应将计时钟重置为 28 秒，比赛如暂停后一样重新开始。若球队希望依本规则保留控球权，教练有责任不拖延地给出明确信号。"
      }
    ]
  },
  {
    "id": "s16",
    "no": "16",
    "title": "个人犯规、黄牌与红牌",
    "en": "Personal Fouls, Yellow and Red Cards",
    "clauses": [
      {
        "number": "16.1",
        "html": "<p>任何实施排他犯规或点球犯规的队员都应被记一次个人犯规。裁判员应向记录员指明违规队员的泳帽号码。</p>",
        "text": "任何实施排他犯规或点球犯规的队员都应被记一次个人犯规。裁判员应向记录员指明违规队员的泳帽号码。"
      },
      {
        "number": "16.2",
        "html": "<p>队员被记第三次个人犯规后，应被罚出、不得参加比赛余下部分，并在第六部分第 9.3 条所述最先发生的情形之后方可换人。若第三次个人犯规为点球犯规，则替补立即入场。</p>",
        "text": "队员被记第三次个人犯规后，应被罚出、不得参加比赛余下部分，并在第六部分第 9.3 条所述最先发生的情形之后方可换人。若第三次个人犯规为点球犯规，则替补立即入场。"
      },
      {
        "number": "16.3",
        "html": "<p>必要时，裁判员必须使用黄牌和红牌来管理替补席上的球队官员与替补队员，以及水中的队员。黄牌和红牌的使用适用于所有 World Aquatics 水球比赛，并按下列方式执行：</p>",
        "text": "必要时，裁判员必须使用黄牌和红牌来管理替补席上的球队官员与替补队员，以及水中的队员。黄牌和红牌的使用适用于所有 World Aquatics 水球比赛，并按下列方式执行："
      },
      {
        "number": "16.3.1",
        "html": "<p>裁判员出示黄牌，是对该队主教练的正式警告。</p>",
        "text": "裁判员出示黄牌，是对该队主教练的正式警告。"
      },
      {
        "number": "16.3.2",
        "html": "<p>裁判员随后出示红牌，即示意主教练及/或其他球队官员及/或替补席上的队员必须立即离开泳池区域。若主教练的行为有此必要，裁判员可不经出示黄牌而直接出示红牌。</p>",
        "text": "裁判员随后出示红牌，即示意主教练及/或其他球队官员及/或替补席上的队员必须立即离开泳池区域。若主教练的行为有此必要，裁判员可不经出示黄牌而直接出示红牌。"
      },
      {
        "number": "16.3.3",
        "html": "<p>当主教练被罚出比赛时，另一名球队官员可接替主教练，但不享有主教练的权利。该球队官员不得起身离开替补席，但可依规则请求暂停。在暂停期间或进球后、比赛重新开始之前，该球队官员可沿池边自由移动至中线，以指导球队。</p>",
        "text": "当主教练被罚出比赛时，另一名球队官员可接替主教练，但不享有主教练的权利。该球队官员不得起身离开替补席，但可依规则请求暂停。在暂停期间或进球后、比赛重新开始之前，该球队官员可沿池边自由移动至中线，以指导球队。"
      },
      {
        "number": "16.3.4",
        "html": "<p>比赛中，当水中的某名队员实施不当行为时，裁判员必须向该队员出示红牌，并施以相应处罚。</p>",
        "text": "比赛中，当水中的某名队员实施不当行为时，裁判员必须向该队员出示红牌，并施以相应处罚。"
      },
      {
        "number": "16.3.5",
        "html": "<p>若裁判员认为某队员持续以非体育精神的方式比赛、或进行假摔（第六部分第 8.14 条），可出示黄牌。裁判员应向违规球队出示黄牌并指向违规队员。若该行为继续，裁判员将向该队员出示红牌（须使球队和记录台均可见），因为此举被视为不当行为（第六部分第 9.13 条）。</p>",
        "text": "若裁判员认为某队员持续以非体育精神的方式比赛、或进行假摔（第六部分第 8.14 条），可出示黄牌。裁判员应向违规球队出示黄牌并指向违规队员。若该行为继续，裁判员将向该队员出示红牌（须使球队和记录台均可见），因为此举被视为不当行为（第六部分第 9.13 条）。"
      },
      {
        "number": "16.3.6",
        "html": "<p>实施不当行为的球队成员将依第六部分第 9.13 条受罚，并必须立即离开泳池区域。</p>",
        "text": "实施不当行为的球队成员将依第六部分第 9.13 条受罚，并必须立即离开泳池区域。"
      },
      {
        "number": "16.3.7",
        "html": "<p>对于任何可能导致队员或球队官员被罚出比赛余下部分的违规，赛事组织委员会（<span class=\"term\">Management Committee</span>）应评估违规的所有情节、尤其是其严重程度，并在比赛结束后 24 小时内决定该队员或球队官员是否被禁止参加本赛事的其他比赛，并通知该队员、球队官员及球队。若组织委员会认为应考虑超出本赛事范围的后果，还应将该事项移交水上运动诚信部门（Aquatics Integrity Unit）。为明确起见，无论该违规在比赛中是否经裁判员判罚，组织委员会均有权调阅本赛事任何比赛的官方录像，以决定该队员或教练是否被禁止参加本赛事的其他比赛。</p>\n        <p>若某球队官员被停赛于某场特定比赛，则该队替补席上的球队官员人数应相应减少；但替补席上至少须保留一名球队官员。</p>\n        <p>若某队员被停赛于某场特定比赛，则该队在随后的比赛中仍可拥有 14 名队员，前提是这些队员已登记于该 World Aquatics 赛事的球队名单，且当时未受任何停赛处罚。</p>",
        "text": "对于任何可能导致队员或球队官员被罚出比赛余下部分的违规，赛事组织委员会（Management Committee）应评估违规的所有情节、尤其是其严重程度，并在比赛结束后 24 小时内决定该队员或球队官员是否被禁止参加本赛事的其他比赛，并通知该队员、球队官员及球队。若组织委员会认为应考虑超出本赛事范围的后果，还应将该事项移交水上运动诚信部门（Aquatics Integrity Unit）。为明确起见，无论该违规在比赛中是否经裁判员判罚，组织委员会均有权调阅本赛事任何比赛的官方录像，以决定该队员或教练是否被禁止参加本赛事的其他比赛。 若某球队官员被停赛于某场特定比赛，则该队替补席上的球队官员人数应相应减少；但替补席上至少须保留一名球队官员。 若某队员被停赛于某场特定比赛，则该队在随后的比赛中仍可拥有 14 名队员，前提是这些队员已登记于该 World Aquatics 赛事的球队名单，且当时未受任何停赛处罚。"
      }
    ]
  },
  {
    "id": "s17",
    "no": "17",
    "title": "事故、受伤与疾病",
    "en": "Accident, Injury and Illness",
    "clauses": [
      {
        "number": "17.1",
        "html": "<p>只有在事故、受伤、疾病或经裁判员许可的情况下，队员才可在比赛中离开水面、或坐/站在池梯或池侧。合法离开水面的队员，可经裁判员许可，在适当的停表时从本队罚出再入场区重新入场。</p>",
        "text": "只有在事故、受伤、疾病或经裁判员许可的情况下，队员才可在比赛中离开水面、或坐/站在池梯或池侧。合法离开水面的队员，可经裁判员许可，在适当的停表时从本队罚出再入场区重新入场。"
      },
      {
        "number": "17.2",
        "html": "<p>若队员流血，裁判员应立即命令其出水、替补立即入场，比赛不间断地继续。流血停止后，该队员可在比赛的正常进程中作为替补。</p>",
        "text": "若队员流血，裁判员应立即命令其出水、替补立即入场，比赛不间断地继续。流血停止后，该队员可在比赛的正常进程中作为替补。"
      },
      {
        "number": "17.3",
        "html": "<p>若发生流血以外的事故、受伤或疾病，裁判员可酌情短暂中止比赛，必要时命令立即替换受伤队员。</p>",
        "text": "若发生流血以外的事故、受伤或疾病，裁判员可酌情短暂中止比赛，必要时命令立即替换受伤队员。"
      },
      {
        "number": "17.4",
        "html": "<p>若比赛因事故、受伤、疾病、流血或其他不可预见的原因而停止，则停止时控球的球队应在比赛恢复时于停止地点将球掷入比赛。</p>",
        "text": "若比赛因事故、受伤、疾病、流血或其他不可预见的原因而停止，则停止时控球的球队应在比赛恢复时于停止地点将球掷入比赛。"
      },
      {
        "number": "17.5",
        "html": "<p>若裁判员、VAR 助理裁判员或监督（delegate）怀疑可能发生了暴力行为，裁判员可依 VAR 规程进行 VAR 回看（第六部分附录 7）。</p>",
        "text": "若裁判员、VAR 助理裁判员或监督（delegate）怀疑可能发生了暴力行为，裁判员可依 VAR 规程进行 VAR 回看（第六部分附录 7）。"
      },
      {
        "number": "17.6",
        "html": "<p><strong>水球专项医疗与安全要求</strong><br>水球是一项身体对抗运动，其创伤性受伤的发生率在 World Aquatics 各运动项目中最高。因此，医疗团队应做好应对若干专项问题的准备。</p>",
        "text": "水球专项医疗与安全要求水球是一项身体对抗运动，其创伤性受伤的发生率在 World Aquatics 各运动项目中最高。因此，医疗团队应做好应对若干专项问题的准备。"
      },
      {
        "number": "17.6.1",
        "html": "<p><strong>创伤性受伤</strong><br>水球中的接触性受伤较多。因此，首席医疗官（CMO）或场馆医疗官（VMO）应配备处理创伤性受伤的适当医疗包，其中应包括缝合材料及/或皮肤胶——因为流血的运动员将不被允许重新下水（第六部分第 17.2 条）。此外，比赛期间应备有冰袋。救生员和场地（FoP）医疗团队应接受创伤识别与深水救援的训练。</p>",
        "text": "创伤性受伤水球中的接触性受伤较多。因此，首席医疗官（CMO）或场馆医疗官（VMO）应配备处理创伤性受伤的适当医疗包，其中应包括缝合材料及/或皮肤胶——因为流血的运动员将不被允许重新下水（第六部分第 17.2 条）。此外，比赛期间应备有冰袋。救生员和场地（FoP）医疗团队应接受创伤识别与深水救援的训练。"
      },
      {
        "number": "17.6.2",
        "html": "<p><strong>牙科项目</strong><br>尽管牙科项目在 World Aquatics 赛事中并非强制，但组委会（OC）在大型赛事中应考虑提供此类医疗服务。牙科项目的目标是：</p>\n        <ul class=\"dash\">\n          <li>提供必要治疗，使口腔颌面受伤的运动员在安全的前提下尽快重返赛场；或</li>\n          <li>在转诊前对伤情进行处理与稳定。</li>\n        </ul>\n        <p>若场馆没有牙医，应指定一名牙医在赛事期间“随叫随到”以备紧急需要。</p>",
        "text": "牙科项目尽管牙科项目在 World Aquatics 赛事中并非强制，但组委会（OC）在大型赛事中应考虑提供此类医疗服务。牙科项目的目标是： 提供必要治疗，使口腔颌面受伤的运动员在安全的前提下尽快重返赛场；或 在转诊前对伤情进行处理与稳定。 若场馆没有牙医，应指定一名牙医在赛事期间“随叫随到”以备紧急需要。"
      },
      {
        "number": "17.6.3",
        "html": "<p><strong>水上救援与救生员</strong><br>赛事期间，救生员应每日演练水中救援。在水球中，须切记比赛场地被分道绳分隔，可能在水上救援时阻碍接近队员。演练时必须考虑这一点，并应调整救援出水点。</p>",
        "text": "水上救援与救生员赛事期间，救生员应每日演练水中救援。在水球中，须切记比赛场地被分道绳分隔，可能在水上救援时阻碍接近队员。演练时必须考虑这一点，并应调整救援出水点。"
      }
    ]
  },
  {
    "id": "s18",
    "no": "18",
    "title": "水球设施",
    "en": "Water Polo Facilities",
    "clauses": [
      {
        "number": "18.1",
        "html": "<p><strong>一般要求</strong></p>",
        "text": "一般要求"
      },
      {
        "number": "18.1.1",
        "html": "<p>水球场地尺寸与器材详见场地示意图。参见水球示意图 1（Water Polo Diagram 1）。</p>",
        "text": "水球场地尺寸与器材详见场地示意图。参见水球示意图 1（Water Polo Diagram 1）。"
      },
      {
        "number": "18.1.2",
        "html": "<p>整个比赛场地为 25.00 米 × 20.00 米，其中 25 米为两条球门线之间的距离。该尺寸适用于男子和女子比赛。比赛场地边缘的锚固点应设于球门线正面后方 30 厘米处。</p>",
        "text": "整个比赛场地为 25.00 米 × 20.00 米，其中 25 米为两条球门线之间的距离。该尺寸适用于男子和女子比赛。比赛场地边缘的锚固点应设于球门线正面后方 30 厘米处。"
      },
      {
        "number": "18.1.3",
        "html": "<p>水深应始终不少于 1.80 米。</p>",
        "text": "水深应始终不少于 1.80 米。"
      },
      {
        "number": "18.1.4",
        "html": "<p>水温应为 26℃ 上下 1℃（即 25℃–27℃）。</p>",
        "text": "水温应为 26℃ 上下 1℃（即 25℃–27℃）。"
      },
      {
        "number": "18.1.5",
        "html": "<p>照度应不低于 600 勒克斯（lux）。</p>",
        "text": "照度应不低于 600 勒克斯（lux）。"
      },
      {
        "number": "18.1.6",
        "html": "<p>不要求最低天花板高度。</p>",
        "text": "不要求最低天花板高度。"
      },
      {
        "number": "18.1.7",
        "html": "<p><strong>分道绳</strong><br>每条分道绳的直径最小为 0.06 米、最大为 0.12 米。分道绳应在每侧池壁固定于嵌入壁内的锚固支架上。若锚固点设于池岸，则应配备坚固、无弹性的延长件。安装后的分道绳应保持在池水中。锚固件（含延长件）伸入池内不得超过 10 毫米。锚固件对分道绳长度的影响，每端不得超过 ±10 毫米。锚固件的安装应能承受 20 千牛（kN）。分道绳应配备张力弹簧以吸收突发的高点载荷，并配备可承受 12 千牛拉力的钢丝。</p>",
        "text": "分道绳每条分道绳的直径最小为 0.06 米、最大为 0.12 米。分道绳应在每侧池壁固定于嵌入壁内的锚固支架上。若锚固点设于池岸，则应配备坚固、无弹性的延长件。安装后的分道绳应保持在池水中。锚固件（含延长件）伸入池内不得超过 10 毫米。锚固件对分道绳长度的影响，每端不得超过 ±10 毫米。锚固件的安装应能承受 20 千牛（kN）。分道绳应配备张力弹簧以吸收突发的高点载荷，并配备可承受 12 千牛拉力的钢丝。"
      },
      {
        "number": "18.1.8",
        "html": "<p><strong>飞行换人区</strong><br>在比赛场地的横向外侧、即球队替补席所在的一侧，必须设有飞行换人区。该区域宽度应不少于 0.50 米。每队的指定飞行换人区位于本队替补席前方的球门线与比赛场地中线之间。</p>",
        "text": "飞行换人区在比赛场地的横向外侧、即球队替补席所在的一侧，必须设有飞行换人区。该区域宽度应不少于 0.50 米。每队的指定飞行换人区位于本队替补席前方的球门线与比赛场地中线之间。"
      },
      {
        "number": "18.2",
        "html": "<p><strong>奥运会与世界锦标赛的水球设施</strong></p>",
        "text": "奥运会与世界锦标赛的水球设施"
      },
      {
        "number": "18.2.1",
        "html": "<p><strong>一般要求</strong><br>水球场地尺寸与器材详见奥运会与世界锦标赛用场地示意图。参见水球示意图（第六部分附录 2）。</p>",
        "text": "一般要求水球场地尺寸与器材详见奥运会与世界锦标赛用场地示意图。参见水球示意图（第六部分附录 2）。"
      },
      {
        "number": "18.2.2",
        "html": "<p>水深应始终不少于 2.00 米。</p>",
        "text": "水深应始终不少于 2.00 米。"
      },
      {
        "number": "18.2.3",
        "html": "<p>水温应为 26℃ 上下 1℃（25℃–27℃）。</p>",
        "text": "水温应为 26℃ 上下 1℃（25℃–27℃）。"
      },
      {
        "number": "18.2.4",
        "html": "<p>照度应不低于 1500 勒克斯。</p>",
        "text": "照度应不低于 1500 勒克斯。"
      },
      {
        "number": "18.2.5",
        "html": "<p>室内泳池中，比赛场地上方的高度应不少于 7.00 米。</p>",
        "text": "室内泳池中，比赛场地上方的高度应不少于 7.00 米。"
      },
      {
        "number": "18.2.6",
        "html": "<p><strong>分道绳</strong><br>每条分道绳直径为 0.10 米。分道绳应在每侧池壁固定于嵌入壁内的锚固支架上。若锚固点设于池岸，则应配备坚固、无弹性的延长件。安装后的分道绳应保持在池水中。锚固件（含延长件）伸入池内不得超过 10 毫米。锚固件对分道绳长度的影响，每端不得超过 ±10 毫米。锚固件的安装应能承受 20 千牛。分道绳应配备张力弹簧以吸收突发的高点载荷，并配备可承受 12 千牛拉力的钢丝。</p>",
        "text": "分道绳每条分道绳直径为 0.10 米。分道绳应在每侧池壁固定于嵌入壁内的锚固支架上。若锚固点设于池岸，则应配备坚固、无弹性的延长件。安装后的分道绳应保持在池水中。锚固件（含延长件）伸入池内不得超过 10 毫米。锚固件对分道绳长度的影响，每端不得超过 ±10 毫米。锚固件的安装应能承受 20 千牛。分道绳应配备张力弹簧以吸收突发的高点载荷，并配备可承受 12 千牛拉力的钢丝。"
      },
      {
        "number": "18.2.7",
        "html": "<p><strong>飞行换人区</strong><br>在比赛场地的横向外侧、即球队替补席所在的一侧，必须设有飞行换人区。该区域宽度应不少于 0.50 米。每队的指定飞行换人区位于本队替补席前方的球门线与比赛场地中线之间。</p>",
        "text": "飞行换人区在比赛场地的横向外侧、即球队替补席所在的一侧，必须设有飞行换人区。该区域宽度应不少于 0.50 米。每队的指定飞行换人区位于本队替补席前方的球门线与比赛场地中线之间。"
      },
      {
        "number": "18.3",
        "html": "<p><strong>水球设施的器材</strong></p>",
        "text": "水球设施的器材"
      },
      {
        "number": "18.3.1",
        "html": "<p><strong>标志线</strong><br>应在比赛场地两侧设置醒目标志，以标示球门线、距该线 2.0 米和 6.0 米处的线，以及两球门线间距的中线。这些标志在整场比赛中都应清晰可见。白色标志自锚固点起测量、为 0.3 米，以对齐球门线边缘正面；两端应一致。2 米红色标志自球门线正面起、伸入比赛场地测量；两端应一致。黄色标志随后自 2 米标志起伸入场地 4 米。距球门线正面 5 米处设一红色标志；两端应一致。场地中段为绿色，长度应为 13 米；绿色区中部设一白色标志以标示场地中心。罚出区（exclusion zones）设于记录台对侧池角的两处，长度为 2 米、沿球门线延伸。在水球比赛场地中，分道绳的颜色应遵循上述配色（附录 1、2、4 中亦同）；经 World Aquatics 批准，也可采用配色方案的变体。</p>",
        "text": "标志线应在比赛场地两侧设置醒目标志，以标示球门线、距该线 2.0 米和 6.0 米处的线，以及两球门线间距的中线。这些标志在整场比赛中都应清晰可见。白色标志自锚固点起测量、为 0.3 米，以对齐球门线边缘正面；两端应一致。2 米红色标志自球门线正面起、伸入比赛场地测量；两端应一致。黄色标志随后自 2 米标志起伸入场地 4 米。距球门线正面 5 米处设一红色标志；两端应一致。场地中段为绿色，长度应为 13 米；绿色区中部设一白色标志以标示场地中心。罚出区（exclusion zones）设于记录台对侧池角的两处，长度为 2 米、沿球门线延伸。在水球比赛场地中，分道绳的颜色应遵循上述配色（附录 1、2、4 中亦同）；经 World Aquatics 批准，也可采用配色方案的变体。"
      },
      {
        "number": "18.3.2",
        "html": "<p><strong>裁判通道平台</strong><br>比赛场地两侧都必须设置平台，宽 1 米、高出水面 70 厘米。这些平台使裁判员能在场地两端之间自由通行。球门线处还应为球门裁判提供足够空间。平台必须按分道绳的规格进行颜色编码（见 18.2.7），如场地示意图所示。参见水球示意图（第六部分附录 2）。若分道绳配色已更改，裁判平台也必须遵循相同的颜色编码。</p>",
        "text": "裁判通道平台比赛场地两侧都必须设置平台，宽 1 米、高出水面 70 厘米。这些平台使裁判员能在场地两端之间自由通行。球门线处还应为球门裁判提供足够空间。平台必须按分道绳的规格进行颜色编码（见 18.2.7），如场地示意图所示。参见水球示意图（第六部分附录 2）。若分道绳配色已更改，裁判平台也必须遵循相同的颜色编码。"
      },
      {
        "number": "18.3.3",
        "html": "<p><strong>球门</strong><br>球门柱和横梁必须为木质、金属或合成（塑料）材料，截面为 80.0 毫米的矩形，与球门线成方正角度并漆成白色。球门柱必须固定、刚性、垂直地设于比赛区域两端，距两侧等距，且至少位于场地两端或任何障碍物前方 0.3 米处。不允许为守门员提供池底以外的任何站立或停靠处。两球门柱内侧之间距离须为 3.0 米。横梁下沿须高出水面 0.9 米。</p>",
        "text": "球门球门柱和横梁必须为木质、金属或合成（塑料）材料，截面为 80.0 毫米的矩形，与球门线成方正角度并漆成白色。球门柱必须固定、刚性、垂直地设于比赛区域两端，距两侧等距，且至少位于场地两端或任何障碍物前方 0.3 米处。不允许为守门员提供池底以外的任何站立或停靠处。两球门柱内侧之间距离须为 3.0 米。横梁下沿须高出水面 0.9 米。"
      },
      {
        "number": "18.3.4",
        "html": "<p><strong>再入场区</strong><br>被罚出队员的矩形再入场区尺寸为：2.0 米 × 1.08 米。</p>",
        "text": "再入场区被罚出队员的矩形再入场区尺寸为：2.0 米 × 1.08 米。"
      },
      {
        "number": "18.3.5",
        "html": "<p><strong>球网</strong><br>必须将柔软的球网固定于球门装置上，以牢固封闭整个球门空间，固定于球门柱和横梁，并在球门区范围内的球门线后方处处保留不少于 0.3 米的净空。</p>",
        "text": "球网必须将柔软的球网固定于球门装置上，以牢固封闭整个球门空间，固定于球门柱和横梁，并在球门区范围内的球门线后方处处保留不少于 0.3 米的净空。"
      },
      {
        "number": "18.3.6",
        "html": "<p><strong>记录台</strong><br>比赛记录处应设于裁判员后方的桌子处，并与……<em>（注：英文原文此处文字中断，疑为“与赛场处于同一水平／同一高度”之意，以官方完整文本为准。）</em></p>",
        "text": "记录台比赛记录处应设于裁判员后方的桌子处，并与……（注：英文原文此处文字中断，疑为“与赛场处于同一水平／同一高度”之意，以官方完整文本为准。）"
      }
    ]
  },
  {
    "id": "s19",
    "no": "19",
    "title": "沙滩水球规则",
    "en": "Beach Water Polo Rules",
    "clauses": [
      {
        "number": "19.1",
        "html": "<p><strong>比赛场地</strong></p>",
        "text": "比赛场地"
      },
      {
        "number": "19.1.1",
        "html": "<p>比赛场地两端球门线之间的距离应为 15 米。场地宽度应为 10.0–12.5 米。</p>",
        "text": "比赛场地两端球门线之间的距离应为 15 米。场地宽度应为 10.0–12.5 米。"
      },
      {
        "number": "19.1.2",
        "html": "<p>比赛区域的水深不得少于 2 米。</p>",
        "text": "比赛区域的水深不得少于 2 米。"
      },
      {
        "number": "19.1.3",
        "html": "<p>比赛区域两侧应设置醒目的浮标：2 米区为红色浮标；5 米区为黄色浮标；其余比赛区域为绿色浮标；中线为白色浮标。</p>",
        "text": "比赛区域两侧应设置醒目的浮标：2 米区为红色浮标；5 米区为黄色浮标；其余比赛区域为绿色浮标；中线为白色浮标。"
      },
      {
        "number": "19.1.4",
        "html": "<p>红色浮标应设于每端、距记录台对侧比赛区域池角 2 米处，以标示“触角”（touching corner，换人触角）。</p>",
        "text": "红色浮标应设于每端、距记录台对侧比赛区域池角 2 米处，以标示“触角”（touching corner，换人触角）。"
      },
      {
        "number": "19.1.5",
        "html": "<p>每端比赛场地的边界应与球门柱正面齐平。</p>",
        "text": "每端比赛场地的边界应与球门柱正面齐平。"
      },
      {
        "number": "19.1.6",
        "html": "<p>应为记录员配备各自独立的白、蓝、红、黄旗各一面，每面尺寸为 0.35 米 × 0.20 米。</p>",
        "text": "应为记录员配备各自独立的白、蓝、红、黄旗各一面，每面尺寸为 0.35 米 × 0.20 米。"
      },
      {
        "number": "19.1.7",
        "html": "<p>在比赛场地横向外侧、球队替补席所在一侧，必须设有飞行换人区。若以分道绳分隔，该区域宽度须介于 0.5–1 米之间。每队的指定飞行换人区位于本队替补席前方的球门线与场地中线之间。</p>",
        "text": "在比赛场地横向外侧、球队替补席所在一侧，必须设有飞行换人区。若以分道绳分隔，该区域宽度须介于 0.5–1 米之间。每队的指定飞行换人区位于本队替补席前方的球门线与场地中线之间。"
      },
      {
        "number": "19.1.8",
        "html": "<p>沙滩水球球门区由两球门柱之间、并延伸至 2 米线的空间界定（参见规则 19.16.1、19.17.3h 和 19.19.2）。</p>",
        "text": "沙滩水球球门区由两球门柱之间、并延伸至 2 米线的空间界定（参见规则 19.16.1、19.17.3h 和 19.19.2）。"
      },
      {
        "number": "19.2",
        "html": "<p><strong>球门柱</strong></p>",
        "text": "球门柱"
      },
      {
        "number": "19.2.1",
        "html": "<p>两根球门柱与横梁须刚性构造，朝向比赛场地的面为 0.080 米的矩形，可漆成任意颜色。球门应设于场地两端的球门线上，距两侧等距。World Aquatics 赛事首选刚性球门柱，但地方性赛事允许使用充气球门柱。</p>",
        "text": "两根球门柱与横梁须刚性构造，朝向比赛场地的面为 0.080 米的矩形，可漆成任意颜色。球门应设于场地两端的球门线上，距两侧等距。World Aquatics 赛事首选刚性球门柱，但地方性赛事允许使用充气球门柱。"
      },
      {
        "number": "19.2.2",
        "html": "<p>两球门柱内侧之间距离为 2.5 米，横梁须高出水面 0.80 米。</p>",
        "text": "两球门柱内侧之间距离为 2.5 米，横梁须高出水面 0.80 米。"
      },
      {
        "number": "19.2.3",
        "html": "<p>柔软的球网须牢固固定于球门柱，以防球从网下或网侧穿过。球门深度不得少于 0.30 米。</p>",
        "text": "柔软的球网须牢固固定于球门柱，以防球从网下或网侧穿过。球门深度不得少于 0.30 米。"
      },
      {
        "number": "19.3",
        "html": "<p><strong>球</strong></p>",
        "text": "球"
      },
      {
        "number": "19.3.1",
        "html": "<p>球应为圆形，内有带自封气阀的气室。须防水，外部无绑带，也不得涂覆油脂或类似物质。</p>",
        "text": "球应为圆形，内有带自封气阀的气室。须防水，外部无绑带，也不得涂覆油脂或类似物质。"
      },
      {
        "number": "19.3.2",
        "html": "<p>球重不得少于 400 克、不得多于 450 克。</p>",
        "text": "球重不得少于 400 克、不得多于 450 克。"
      },
      {
        "number": "19.3.3",
        "html": "<p>男子比赛用球，圆周不得小于 0.68 米、不得大于 0.71 米，气压为 7.5–8.5 psi（磅/平方英寸，表压）。</p>",
        "text": "男子比赛用球，圆周不得小于 0.68 米、不得大于 0.71 米，气压为 7.5–8.5 psi（磅/平方英寸，表压）。"
      },
      {
        "number": "19.3.4",
        "html": "<p>女子比赛用球，圆周不得小于 0.65 米、不得大于 0.67 米，气压为 6.5–7.5 psi。</p>",
        "text": "女子比赛用球，圆周不得小于 0.65 米、不得大于 0.67 米，气压为 6.5–7.5 psi。"
      },
      {
        "number": "19.4",
        "html": "<p><strong>泳帽</strong></p>",
        "text": "泳帽"
      },
      {
        "number": "19.4.1",
        "html": "<p>泳帽应为经裁判员批准的对比色（不得为纯红色），且须与球的颜色形成对比。裁判员可要求球队佩戴白色或蓝色泳帽。守门员应戴红色泳帽。泳帽须在下颌处系紧，并配有可塑形的护耳；护耳颜色应与本队泳帽相同，但守门员可用红色护耳。</p>",
        "text": "泳帽应为经裁判员批准的对比色（不得为纯红色），且须与球的颜色形成对比。裁判员可要求球队佩戴白色或蓝色泳帽。守门员应戴红色泳帽。泳帽须在下颌处系紧，并配有可塑形的护耳；护耳颜色应与本队泳帽相同，但守门员可用红色护耳。"
      },
      {
        "number": "19.4.2",
        "html": "<p>泳帽两侧应有高 0.10 米的号码。守门员戴 1 号，其余泳帽编号为 2 至 7 号。</p>",
        "text": "泳帽两侧应有高 0.10 米的号码。守门员戴 1 号，其余泳帽编号为 2 至 7 号。"
      },
      {
        "number": "19.4.3",
        "html": "<p>替补守门员的队员应戴红色泳帽，号码与其作为场上队员时所戴号码相同。除经裁判员许可并通知记录员外，队员不得在比赛中更换泳帽号码。整场比赛都须佩戴泳帽。若队员在比赛中丢失泳帽，应在本队控球时的下一适当停表时补戴。被替换的守门员应戴本队颜色的 1 号帽。各队应备一套 1–7 号红色泳帽，以及一顶本队颜色的 1 号帽。</p>",
        "text": "替补守门员的队员应戴红色泳帽，号码与其作为场上队员时所戴号码相同。除经裁判员许可并通知记录员外，队员不得在比赛中更换泳帽号码。整场比赛都须佩戴泳帽。若队员在比赛中丢失泳帽，应在本队控球时的下一适当停表时补戴。被替换的守门员应戴本队颜色的 1 号帽。各队应备一套 1–7 号红色泳帽，以及一顶本队颜色的 1 号帽。"
      },
      {
        "number": "19.4.4",
        "html": "<p>国际比赛中，泳帽正面应显示三字母国家代码，并可显示国旗。</p>",
        "text": "国际比赛中，泳帽正面应显示三字母国家代码，并可显示国旗。"
      },
      {
        "number": "19.5",
        "html": "<p><strong>球队与替补</strong></p>",
        "text": "球队与替补"
      },
      {
        "number": "19.5.1",
        "html": "<p>每队由四名队员组成，其中一名为守门员；另有不超过三名可用作替补的替补队员。</p>",
        "text": "每队由四名队员组成，其中一名为守门员；另有不超过三名可用作替补的替补队员。"
      },
      {
        "number": "19.5.2",
        "html": "<p>允许两名官员（主教练或另一名官员——助理教练或领队）坐在浮台或类似指定区域，比赛中不得离开该处。另允许至多两名医务人员在远离替补席的单独位置。</p>",
        "text": "允许两名官员（主教练或另一名官员——助理教练或领队）坐在浮台或类似指定区域，比赛中不得离开该处。另允许至多两名医务人员在远离替补席的单独位置。"
      },
      {
        "number": "19.5.3",
        "html": "<p>各队应在中场休息时交换场地。</p>",
        "text": "各队应在中场休息时交换场地。"
      },
      {
        "number": "19.5.4",
        "html": "<p>沙滩水球的替补席可为浮台，且必须设在与裁判员及比赛官员相对的另一侧场地。</p>",
        "text": "沙滩水球的替补席可为浮台，且必须设在与裁判员及比赛官员相对的另一侧场地。"
      },
      {
        "number": "19.5.5",
        "html": "<p>每队应设一名队长，负责本队的行为。</p>",
        "text": "每队应设一名队长，负责本队的行为。"
      },
      {
        "number": "19.5.6",
        "html": "<p>队员参赛时须修剪好指甲，并摘除任何可能造成伤害的物品。队员身体或手上不得有油脂、油类或任何类似或外来物质。若裁判员在比赛开始前查明使用了此类物质，应命令立即清除。若在比赛开始后才发现该违规，违规队员应被罚出比赛余下部分，并立即换人。</p>",
        "text": "队员参赛时须修剪好指甲，并摘除任何可能造成伤害的物品。队员身体或手上不得有油脂、油类或任何类似或外来物质。若裁判员在比赛开始前查明使用了此类物质，应命令立即清除。若在比赛开始后才发现该违规，违规队员应被罚出比赛余下部分，并立即换人。"
      },
      {
        "number": "19.5.7",
        "html": "<p>每队应有三名替补，可替换队员参加比赛。一旦离场队员在“触角”处明显浮出水面、并与位于场地外的替补在水面以上击掌，替补即可从触角进入比赛。当替补从延长球门线后方进入指定飞行换人区，且离场队员与替补二人均在水中、位于场地外并在水面以上击掌时，亦允许从飞行换人区换人。</p>",
        "text": "每队应有三名替补，可替换队员参加比赛。一旦离场队员在“触角”处明显浮出水面、并与位于场地外的替补在水面以上击掌，替补即可从触角进入比赛。当替补从延长球门线后方进入指定飞行换人区，且离场队员与替补二人均在水中、位于场地外并在水面以上击掌时，亦允许从飞行换人区换人。"
      },
      {
        "number": "19.5.8",
        "html": "<p>被替补替换的守门员可在任何位置比赛。</p>",
        "text": "被替补替换的守门员可在任何位置比赛。"
      },
      {
        "number": "19.5.9",
        "html": "<p>进球后，可在守门员将球重新掷入比赛后，从触角或飞行换人区换人。换人时，两名队员都须位于场地外，并在进入场地前明显地高位击掌。</p>",
        "text": "进球后，可在守门员将球重新掷入比赛后，从触角或飞行换人区换人。换人时，两名队员都须位于场地外，并在进入场地前明显地高位击掌。"
      },
      {
        "number": "19.5.10",
        "html": "<p>守门员可在本队 5 米区域内用双手触球。</p>",
        "text": "守门员可在本队 5 米区域内用双手触球。"
      },
      {
        "number": "19.5.11",
        "html": "<p>判罚点球犯规时、且在罚点球掷出之前，不得换人。</p>",
        "text": "判罚点球犯规时、且在罚点球掷出之前，不得换人。"
      },
      {
        "number": "19.6",
        "html": "<p><strong>官员</strong></p>",
        "text": "官员"
      },
      {
        "number": "19.6.1",
        "html": "<p>在所有正式比赛中，比赛官员如下：</p><ul class=\"dash\"><li>一名裁判员；</li><li>两名记录员；</li><li>两名计时员。</li></ul>",
        "text": "在所有正式比赛中，比赛官员如下：一名裁判员；两名记录员；两名计时员。"
      },
      {
        "number": "19.6.2",
        "html": "<p>记录员的职责为：</p><ul class=\"dash\"><li>保持比赛记录，包括队员、比分、暂停、对每名队员判罚的排他犯规和点球犯规；</li><li>对被罚出队员或替补的任何不当再入场，以红旗和哨声示意；</li><li>在 3 分钟后，升起黄旗连同相应颜色的旗帜，示意可替换实施粗暴行为（brutality）的队员；</li><li>记录个人犯规、球队犯规，并在判予附加点球犯规（bonus penalty foul）时以适当的声响信号（如哨声或电子信号）示意；在守门员被替换时记录时间和该队员的泳帽号码；</li><li>控制“轮换控球制”（Alternating Possession System），用于在中立球情形下判予任意球（见 19.15.1）。</li></ul>",
        "text": "记录员的职责为：保持比赛记录，包括队员、比分、暂停、对每名队员判罚的排他犯规和点球犯规；对被罚出队员或替补的任何不当再入场，以红旗和哨声示意；在 3 分钟后，升起黄旗连同相应颜色的旗帜，示意可替换实施粗暴行为（brutality）的队员；记录个人犯规、球队犯规，并在判予附加点球犯规（bonus penalty foul）时以适当的声响信号（如哨声或电子信号）示意；在守门员被替换时记录时间和该队员的泳帽号码；控制“轮换控球制”（Alternating Possession System），用于在中立球情形下判予任意球（见 19.15.1）。"
      },
      {
        "number": "19.6.3",
        "html": "<p>计时员的职责为：</p><ul class=\"dash\"><li>准确记录实际比赛时间、暂停以及节间间歇；</li><li>记录每队连续控球的时间段；</li><li>宣布比赛最后一分钟的开始；</li><li>在 45 秒后及每次暂停结束时鸣哨示意。</li></ul>",
        "text": "计时员的职责为：准确记录实际比赛时间、暂停以及节间间歇；记录每队连续控球的时间段；宣布比赛最后一分钟的开始；在 45 秒后及每次暂停结束时鸣哨示意。"
      },
      {
        "number": "19.6.4",
        "html": "<p>计时员应独立于裁判员，以鸣哨（声音清晰、易于理解）示意每节结束；该信号立即生效并停止比赛，但下列情形除外：</p><ul class=\"dash\"><li>裁判员同时判予罚点球，此时该罚点球应予执行；</li><li>球正在飞行中并越过球门线，此时由此产生的进球应予有效。</li></ul>",
        "text": "计时员应独立于裁判员，以鸣哨（声音清晰、易于理解）示意每节结束；该信号立即生效并停止比赛，但下列情形除外：裁判员同时判予罚点球，此时该罚点球应予执行；球正在飞行中并越过球门线，此时由此产生的进球应予有效。"
      },
      {
        "number": "19.7",
        "html": "<p><strong>裁判员</strong></p>",
        "text": "裁判员"
      },
      {
        "number": "19.7.1",
        "html": "<p>自两队进入比赛区域起至离开止，裁判员对比赛拥有绝对管辖权。所有判罚均为最终决定，所有队员和教练都须接受。只要在球重新进入比赛之前，裁判员可更改判罚。</p>",
        "text": "自两队进入比赛区域起至离开止，裁判员对比赛拥有绝对管辖权。所有判罚均为最终决定，所有队员和教练都须接受。只要在球重新进入比赛之前，裁判员可更改判罚。"
      },
      {
        "number": "19.7.2",
        "html": "<p>裁判员应鸣哨开始比赛，并鸣哨宣告进球、球门球、角球、中立球及违规。</p>",
        "text": "裁判员应鸣哨开始比赛，并鸣哨宣告进球、球门球、角球、中立球及违规。"
      },
      {
        "number": "19.7.3",
        "html": "<p>裁判员可运用有利原则，以免使犯规一方获益；除非绝对必要，否则不应停止比赛。</p>",
        "text": "裁判员可运用有利原则，以免使犯规一方获益；除非绝对必要，否则不应停止比赛。"
      },
      {
        "number": "19.7.4",
        "html": "<p>裁判员有权依规则命令任何队员出水。若队员拒不服从裁判员的指示，比赛应终止，并判对方球队以 5∶0 获胜。</p>",
        "text": "裁判员有权依规则命令任何队员出水。若队员拒不服从裁判员的指示，比赛应终止，并判对方球队以 5∶0 获胜。"
      },
      {
        "number": "19.7.5",
        "html": "<p>裁判员有权命令任何行为妨碍其公正履职的队员、替补、观众或官员离开泳池范围。</p>",
        "text": "裁判员有权命令任何行为妨碍其公正履职的队员、替补、观众或官员离开泳池范围。"
      },
      {
        "number": "19.7.6",
        "html": "<p>若裁判员认为队员或观众的行为、或任何其他情形致使比赛无法以公平、正确的方式进行，其有权在任何时刻终止比赛。若比赛必须终止，裁判员应将其处置情况报告主管机构。</p>",
        "text": "若裁判员认为队员或观众的行为、或任何其他情形致使比赛无法以公平、正确的方式进行，其有权在任何时刻终止比赛。若比赛必须终止，裁判员应将其处置情况报告主管机构。"
      },
      {
        "number": "19.8",
        "html": "<p><strong>比赛时长</strong></p>",
        "text": "比赛时长"
      },
      {
        "number": "19.8.1",
        "html": "<p>比赛时长为四节，每节 5 分钟实际比赛时间。每节计时自队员触球时开始。在每次停表信号时，记录表计时应停止，直至主罚相应掷球的队员将球脱手使球重新进入比赛、或中立球后球被队员触及为止。</p>",
        "text": "比赛时长为四节，每节 5 分钟实际比赛时间。每节计时自队员触球时开始。在每次停表信号时，记录表计时应停止，直至主罚相应掷球的队员将球脱手使球重新进入比赛、或中立球后球被队员触及为止。"
      },
      {
        "number": "19.8.2",
        "html": "<p>第一/二节、第三/四节之间各有 2 分钟间歇，中场休息为 3 分钟。各队（含队员、教练和官员）应在中场休息时交换场地（第六部分第 19.5.3 条）。</p>",
        "text": "第一/二节、第三/四节之间各有 2 分钟间歇，中场休息为 3 分钟。各队（含队员、教练和官员）应在中场休息时交换场地（第六部分第 19.5.3 条）。"
      },
      {
        "number": "19.8.3",
        "html": "<p>凡在四节比赛结束时打平的比赛，将以与水球规则相同的方式进行点球大战决出胜负。守门员可作为主罚者之一。守门员仅在因不当行为、暴力行为或受伤被罚出比赛余下部分时方可被替换；守门员被罚出后，替补守门员在该违规之后的第一个罚点球中不享有守门员的权利。</p>\n        <p>提名的三名队员须按顺序列出，该顺序决定主罚次序且不得更改。被罚出比赛余下部分的队员无资格列入主罚队员名单。</p>\n        <p>点球将在泳池两端交替主罚，除非某一端场地条件对某队有利或不利，此时所有点球可在同一端主罚。所有主罚队员将留在各自浮台前的水中，其余队员须坐在本队浮台上。若守门员在点球大战中被罚出，可由提名的三名队员之一替补守门员，但不享有守门员的权利。</p>\n        <p>主罚点球后，该队员可被另一名队员或守门员替换。若某场上队员在点球大战中被罚出，则其位置从参加点球大战的三名队员名单中移除，并将一名替补队员置于名单末位。</p>\n        <p>先罚一方以掷币决定。若在最初三轮点球结束后两队仍战平，则由同样的三名队员轮流主罚，直至一队罚失而另一队罚中为止。</p>",
        "text": "凡在四节比赛结束时打平的比赛，将以与水球规则相同的方式进行点球大战决出胜负。守门员可作为主罚者之一。守门员仅在因不当行为、暴力行为或受伤被罚出比赛余下部分时方可被替换；守门员被罚出后，替补守门员在该违规之后的第一个罚点球中不享有守门员的权利。 提名的三名队员须按顺序列出，该顺序决定主罚次序且不得更改。被罚出比赛余下部分的队员无资格列入主罚队员名单。 点球将在泳池两端交替主罚，除非某一端场地条件对某队有利或不利，此时所有点球可在同一端主罚。所有主罚队员将留在各自浮台前的水中，其余队员须坐在本队浮台上。若守门员在点球大战中被罚出，可由提名的三名队员之一替补守门员，但不享有守门员的权利。 主罚点球后，该队员可被另一名队员或守门员替换。若某场上队员在点球大战中被罚出，则其位置从参加点球大战的三名队员名单中移除，并将一名替补队员置于名单末位。 先罚一方以掷币决定。若在最初三轮点球结束后两队仍战平，则由同样的三名队员轮流主罚，直至一队罚失而另一队罚中为止。"
      },
      {
        "number": "19.8.4",
        "html": "<p>任何可视计时钟应以递减方式显示时间。</p>",
        "text": "任何可视计时钟应以递减方式显示时间。"
      },
      {
        "number": "19.8.5",
        "html": "<p>若某场比赛（或其一部分）必须重赛，则在须重赛时段内发生的进球、个人犯规和暂停应从比赛记录表中删除；但粗暴行为、不当行为及任何红牌罚出均须记录于比赛记录表中。</p>",
        "text": "若某场比赛（或其一部分）必须重赛，则在须重赛时段内发生的进球、个人犯规和暂停应从比赛记录表中删除；但粗暴行为、不当行为及任何红牌罚出均须记录于比赛记录表中。"
      },
      {
        "number": "19.8.6",
        "html": "<p>（悬殊规则，Mercy Rule）中场休息之后，若两队净胜球达到 10 分或以上，比赛即宣告结束，领先一方获胜。</p>",
        "text": "（悬殊规则，Mercy Rule）中场休息之后，若两队净胜球达到 10 分或以上，比赛即宣告结束，领先一方获胜。"
      },
      {
        "number": "19.9",
        "html": "<p><strong>暂停</strong></p>",
        "text": "暂停"
      },
      {
        "number": "19.9.1",
        "html": "<p>每队每场比赛可请求两次暂停。</p>",
        "text": "每队每场比赛可请求两次暂停。"
      },
      {
        "number": "19.9.2",
        "html": "<p>控球方球队的教练可在任何时刻请求暂停，但判罚点球犯规时除外。教练应高呼“暂停”并以双手做出 T 形手势向裁判员或记录员示意。一旦请求暂停，记录员或裁判员应立即鸣哨停止比赛，队员应返回各自半场。</p>",
        "text": "控球方球队的教练可在任何时刻请求暂停，但判罚点球犯规时除外。教练应高呼“暂停”并以双手做出 T 形手势向裁判员或记录员示意。一旦请求暂停，记录员或裁判员应立即鸣哨停止比赛，队员应返回各自半场。"
      },
      {
        "number": "19.9.3",
        "html": "<p>比赛应在裁判员鸣哨后、由控球方球队在中线上或中线后将球掷入比赛而重新开始。</p>",
        "text": "比赛应在裁判员鸣哨后、由控球方球队在中线上或中线后将球掷入比赛而重新开始。"
      },
      {
        "number": "19.9.4",
        "html": "<p>控球计时钟自暂停后比赛重新开始时继续计时。</p>",
        "text": "控球计时钟自暂停后比赛重新开始时继续计时。"
      },
      {
        "number": "19.9.5",
        "html": "<p>若控球方教练请求一次该队无权享有的额外暂停，比赛应停止，随后由对方球队的一名队员在中线处将球掷入比赛而重新开始。若非控球方球队的教练请求暂停，比赛应停止，并判予对方球队一个罚点球。</p>",
        "text": "若控球方教练请求一次该队无权享有的额外暂停，比赛应停止，随后由对方球队的一名队员在中线处将球掷入比赛而重新开始。若非控球方球队的教练请求暂停，比赛应停止，并判予对方球队一个罚点球。"
      },
      {
        "number": "19.10",
        "html": "<p><strong>比赛的开始</strong></p>",
        "text": "比赛的开始"
      },
      {
        "number": "19.10.1",
        "html": "<p>正式秩序册中列于前者的球队佩戴白色或浅色泳帽、或反映其国家颜色的泳帽，并在记录台左侧开始比赛。另一队佩戴蓝色或深色泳帽、或对比色泳帽，在记录台右侧开始比赛。</p>",
        "text": "正式秩序册中列于前者的球队佩戴白色或浅色泳帽、或反映其国家颜色的泳帽，并在记录台左侧开始比赛。另一队佩戴蓝色或深色泳帽、或对比色泳帽，在记录台右侧开始比赛。"
      },
      {
        "number": "19.10.2",
        "html": "<p>每节开始时，两队在各自一侧的比赛区域列队。当裁判员确认两队均已准备就绪后，应鸣哨开始，并在中线上将球掷入比赛。</p>",
        "text": "每节开始时，两队在各自一侧的比赛区域列队。当裁判员确认两队均已准备就绪后，应鸣哨开始，并在中线上将球掷入比赛。"
      },
      {
        "number": "19.10.3",
        "html": "<p>若掷球使某队获得明显有利，裁判员应叫球，并在中线上判予中立球。</p>",
        "text": "若掷球使某队获得明显有利，裁判员应叫球，并在中线上判予中立球。"
      },
      {
        "number": "19.11",
        "html": "<p><strong>得分</strong></p>",
        "text": "得分"
      },
      {
        "number": "19.11.1",
        "html": "<p>当整个球完全越过球门线、在两球门柱之间且横梁之下通过时，即为进球。</p>",
        "text": "当整个球完全越过球门线、在两球门柱之间且横梁之下通过时，即为进球。"
      },
      {
        "number": "19.11.2",
        "html": "<p>进球可用除握拳之外的身体任何部位完成。</p>",
        "text": "进球可用除握拳之外的身体任何部位完成。"
      },
      {
        "number": "19.11.3",
        "html": "<p>只有在比赛开始后两名队员（任一方均可）有意触球或触及球之后，方可在 5 米线以内进球。</p>",
        "text": "只有在比赛开始后两名队员（任一方均可）有意触球或触及球之后，方可在 5 米线以内进球。"
      },
      {
        "number": "19.11.4",
        "html": "<p>队员在 5 米区域外获判并主罚任意球后，经假动作、运球或将球置于水面后射门，可得分。<em>（注：当队员并非直接射门时，须先按规则将球掷入比赛，方可做假动作和运球。）</em></p>",
        "text": "队员在 5 米区域外获判并主罚任意球后，经假动作、运球或将球置于水面后射门，可得分。（注：当队员并非直接射门时，须先按规则将球掷入比赛，方可做假动作和运球。）"
      },
      {
        "number": "19.11.5",
        "html": "<p>当犯规在 5 米线外被判罚时，队员在 5 米线外明显将球掷入比赛后可得分；球门球（直接、或将球掷入比赛后）亦可得分；或队员主罚任意球将球掷入本方球门也算进球。</p>",
        "text": "当犯规在 5 米线外被判罚时，队员在 5 米线外明显将球掷入比赛后可得分；球门球（直接、或将球掷入比赛后）亦可得分；或队员主罚任意球将球掷入本方球门也算进球。"
      },
      {
        "number": "19.11.6",
        "html": "<p>若在 20 秒控球时间届满时或某节结束时，球正在飞行中并进入球门，应计为进球。</p>",
        "text": "若在 20 秒控球时间届满时或某节结束时，球正在飞行中并进入球门，应计为进球。"
      },
      {
        "number": "19.12",
        "html": "<p><strong>进球后的重新开始</strong></p>",
        "text": "进球后的重新开始"
      },
      {
        "number": "19.12.1",
        "html": "<p>进球后，守门员应立即在 2 米线上或其后将球掷入比赛。计时员应在进球后停止比赛计时钟，并在球被掷入比赛重新开始时重新启动。</p>",
        "text": "进球后，守门员应立即在 2 米线上或其后将球掷入比赛。计时员应在进球后停止比赛计时钟，并在球被掷入比赛重新开始时重新启动。"
      },
      {
        "number": "19.13",
        "html": "<p><strong>球门球</strong></p>",
        "text": "球门球"
      },
      {
        "number": "19.13.1",
        "html": "<p>当整个球完全越过球门线（不在两球门柱之间且横梁之下的范围内通过），且最后触球者为任一队员时，应判予球门球。</p>",
        "text": "当整个球完全越过球门线（不在两球门柱之间且横梁之下的范围内通过），且最后触球者为任一队员时，应判予球门球。"
      },
      {
        "number": "19.13.2",
        "html": "<p>球门球应由该队任一队员在 2 米区域内任意位置主罚。</p>",
        "text": "球门球应由该队任一队员在 2 米区域内任意位置主罚。"
      },
      {
        "number": "19.14",
        "html": "<p><strong>角球</strong></p>",
        "text": "角球"
      },
      {
        "number": "19.14.1",
        "html": "<p>沙滩水球中不设角球。</p>",
        "text": "沙滩水球中不设角球。"
      },
      {
        "number": "19.15",
        "html": "<p><strong>中立球</strong></p>\n        <p>不主罚中立球；若出现中立球情形，应按下列方式适用“轮换控球制”（Alternating Possession System）：</p>\n        <p>赢得第一节开球（swim-up）的球队失去第一次中立球。此后每遇中立球情形，将交替判予两队任意球。下一个有权获得任意球的球队，由指向对方球门的“轮换控球箭头”标示；一旦主罚了轮换控球任意球，箭头方向立即反转。</p>",
        "text": "中立球 不主罚中立球；若出现中立球情形，应按下列方式适用“轮换控球制”（Alternating Possession System）： 赢得第一节开球（swim-up）的球队失去第一次中立球。此后每遇中立球情形，将交替判予两队任意球。下一个有权获得任意球的球队，由指向对方球门的“轮换控球箭头”标示；一旦主罚了轮换控球任意球，箭头方向立即反转。"
      },
      {
        "number": "19.16",
        "html": "<p><strong>任意球</strong></p>",
        "text": "任意球"
      },
      {
        "number": "19.16.1",
        "html": "<p>任意球表示已发生犯规。任意球应在球所在位置主罚，但下列情形除外：a) 若防守队员在本方沙滩水球球门区内犯规，则任意球应在犯规地点对面的 2 米线上主罚；b) 规则另有规定的其他情形。</p>",
        "text": "任意球表示已发生犯规。任意球应在球所在位置主罚，但下列情形除外：a) 若防守队员在本方沙滩水球球门区内犯规，则任意球应在犯规地点对面的 2 米线上主罚；b) 规则另有规定的其他情形。"
      },
      {
        "number": "19.16.2",
        "html": "<p>任意球应在球所在位置由该队最靠近球的队员主罚。出现反击时，占有利的队员无需为前去取球主罚任意球或球门球而放弃有利；只要不无故拖延，该队另一名队员可主罚该球。</p>",
        "text": "任意球应在球所在位置由该队最靠近球的队员主罚。出现反击时，占有利的队员无需为前去取球主罚任意球或球门球而放弃有利；只要不无故拖延，该队另一名队员可主罚该球。"
      },
      {
        "number": "19.16.3",
        "html": "<p>任意球的主罚方式须使所有其他队员都能看到该球已被主罚。队员可将球向上抛入空中，或让其落于水面。</p>",
        "text": "任意球的主罚方式须使所有其他队员都能看到该球已被主罚。队员可将球向上抛入空中，或让其落于水面。"
      },
      {
        "number": "19.16.4",
        "html": "<p>队员主罚任意球的允许时间由裁判员酌定。该时间应合理、不无故拖延，但不必立即主罚。若明显处于最便于主罚任意球位置的队员未予主罚，则为违规。</p>",
        "text": "队员主罚任意球的允许时间由裁判员酌定。该时间应合理、不无故拖延，但不必立即主罚。若明显处于最便于主罚任意球位置的队员未予主罚，则为违规。"
      },
      {
        "number": "19.17",
        "html": "<p><strong>普通犯规</strong></p>",
        "text": "普通犯规"
      },
      {
        "number": "19.17.1",
        "html": "<p>普通犯规的处罚为判予对方球队一个任意球。</p>",
        "text": "普通犯规的处罚为判予对方球队一个任意球。"
      },
      {
        "number": "19.17.2",
        "html": "<p>裁判员必须依规则判予普通犯规，以使进攻方得以发展有利局面。</p>",
        "text": "裁判员必须依规则判予普通犯规，以使进攻方得以发展有利局面。"
      },
      {
        "number": "19.17.3",
        "html": "<p>实施下列任一行为即为普通犯规：</p>\n        <ol class=\"alpha\">\n          <li>在裁判员鸣哨前抢先开始开球游泳（swim off）；</li>\n          <li>在某节开始时或比赛中任何时刻协助或推顶某名队员；</li>\n          <li>抓扶或借力于场地周围或球门柱的器材或结构；</li>\n          <li>被抢截时将整个球压入或抓在水下，或故意将球藏匿以躲避对方球队；</li>\n          <li>同时用双手触球，但在本方 5 米区域内的守门员除外；</li>\n          <li>推搡未持球的对手、或从其身上借力；</li>\n          <li>获判任意球一方的另一名队员，在该任意球掷出之前再次实施普通犯规；</li>\n          <li>比赛中，队员可在场地内任取位置，但任何进攻队员不得（无论持球与否）进入两球门柱之间、且距球门线 2 米以内的空间（即沙滩水球球门区）；</li>\n          <li>以不符合第六部分第 19.20.5 条规定方式主罚罚点球；</li>\n          <li>将球击出标示场地两侧的浮标之外（若球仅触及场地边缘，球仍为活球）；</li>\n          <li>守门员在本方 5 米区域外同时用双手触球；</li>\n          <li>球队保持控球超过 20 秒实际比赛时间而不射向对方球门。记录控球时间的计时员应重置计时钟：在射门队员将球脱手时。若球从球门、横梁或守门员处反弹回比赛中，则控球时间不得——</li>\n          <li>（续上）在球被任一球队控制之前重新计时；</li>\n          <li>当球被对方球队控制时（仅被对方队员在飞行中触及不构成控球）；</li>\n          <li>当因排他犯规、点球犯规、球门球、角球或中立球的判予而将球掷入比赛时：</li>\n          <li>可视计时钟应以递减方式显示时间（显示剩余控球时间）。</li>\n          <li>假摔（模拟被犯规）。<em>【注：模拟指队员意图使裁判员错误地判罚对方队员的行为。裁判员可因反复模拟向球队出示黄牌，并可适用第六部分第 9.13 条（持续犯规）处罚违规队员。】</em></li>\n          <li>潜入水下以获取位置优势。</li>\n        </ol>",
        "text": "实施下列任一行为即为普通犯规： 在裁判员鸣哨前抢先开始开球游泳（swim off）； 在某节开始时或比赛中任何时刻协助或推顶某名队员； 抓扶或借力于场地周围或球门柱的器材或结构； 被抢截时将整个球压入或抓在水下，或故意将球藏匿以躲避对方球队； 同时用双手触球，但在本方 5 米区域内的守门员除外； 推搡未持球的对手、或从其身上借力； 获判任意球一方的另一名队员，在该任意球掷出之前再次实施普通犯规； 比赛中，队员可在场地内任取位置，但任何进攻队员不得（无论持球与否）进入两球门柱之间、且距球门线 2 米以内的空间（即沙滩水球球门区）； 以不符合第六部分第 19.20.5 条规定方式主罚罚点球； 将球击出标示场地两侧的浮标之外（若球仅触及场地边缘，球仍为活球）； 守门员在本方 5 米区域外同时用双手触球； 球队保持控球超过 20 秒实际比赛时间而不射向对方球门。记录控球时间的计时员应重置计时钟：在射门队员将球脱手时。若球从球门、横梁或守门员处反弹回比赛中，则控球时间不得—— （续上）在球被任一球队控制之前重新计时； 当球被对方球队控制时（仅被对方队员在飞行中触及不构成控球）； 当因排他犯规、点球犯规、球门球、角球或中立球的判予而将球掷入比赛时： 可视计时钟应以递减方式显示时间（显示剩余控球时间）。 假摔（模拟被犯规）。【注：模拟指队员意图使裁判员错误地判罚对方队员的行为。裁判员可因反复模拟向球队出示黄牌，并可适用第六部分第 9.13 条（持续犯规）处罚违规队员。】 潜入水下以获取位置优势。"
      },
      {
        "number": "19.18",
        "html": "<p><strong>排他犯规</strong></p>",
        "text": "排他犯规"
      },
      {
        "number": "19.18.1",
        "html": "<p>实施下列任一行为即为排他犯规，除罚点球的情形外，应判予对方球队一个任意球。被罚出队员应触及红色浮标所标示的那段球门线，并立即重新参加比赛。若被罚出队员在被罚出后离开比赛区域时干扰比赛，将判罚其所在球队（罚点球）。被罚出队员可在红色浮标标示的那段球门线处（即触角）离开场地而被替换；一旦离场队员在触角区域内明显浮出水面、并与替补在水面以上击掌，替补即可从触角进入比赛场地。</p>",
        "text": "实施下列任一行为即为排他犯规，除罚点球的情形外，应判予对方球队一个任意球。被罚出队员应触及红色浮标所标示的那段球门线，并立即重新参加比赛。若被罚出队员在被罚出后离开比赛区域时干扰比赛，将判罚其所在球队（罚点球）。被罚出队员可在红色浮标标示的那段球门线处（即触角）离开场地而被替换；一旦离场队员在触角区域内明显浮出水面、并与替补在水面以上击掌，替补即可从触角进入比赛场地。"
      },
      {
        "number": "19.18.2",
        "html": "<p>比赛中离开水面，但事故、受伤或经裁判员许可的情形除外。</p>",
        "text": "比赛中离开水面，但事故、受伤或经裁判员许可的情形除外。"
      },
      {
        "number": "19.18.3",
        "html": "<p>干扰任意球或球门球的主罚：故意将球推开以拖延掷球；在球离开主罚队员之手前任何试图触球的行为。</p>",
        "text": "干扰任意球或球门球的主罚：故意将球推开以拖延掷球；在球离开主罚队员之手前任何试图触球的行为。"
      },
      {
        "number": "19.18.4",
        "html": "<p>在 5 米线外故意向对手脸部泼水。故意向对手泼水的处罚为依 19.18.1 罚出。</p>",
        "text": "在 5 米线外故意向对手脸部泼水。故意向对手泼水的处罚为依 19.18.1 罚出。"
      },
      {
        "number": "19.18.5",
        "html": "<p>抓拉、按沉或回拽未持球的对手。</p>",
        "text": "抓拉、按沉或回拽未持球的对手。"
      },
      {
        "number": "19.18.6",
        "html": "<p>妨碍未控球对手的移动。</p>",
        "text": "妨碍未控球对手的移动。"
      },
      {
        "number": "19.18.7",
        "html": "<p>故意踢打对手，或怀此意图做出不成比例的动作。</p>",
        "text": "故意踢打对手，或怀此意图做出不成比例的动作。"
      },
      {
        "number": "19.18.8",
        "html": "<p>在控球权转换之际，防守队员在场地任何位置对控球方任一队员实施犯规、意图中断进攻节奏。此类犯规称为战术犯规。</p>",
        "text": "在控球权转换之际，防守队员在场地任何位置对控球方任一队员实施犯规、意图中断进攻节奏。此类犯规称为战术犯规。"
      },
      {
        "number": "19.18.9",
        "html": "<p>有不当行为，包括使用不可接受的言语、暴力或持续的犯规动作、拒不服从或不尊重裁判员或官员、或违背规则精神且可能损害比赛声誉的行为。在沙滩水球规则中，因不当行为被罚出比赛余下部分的队员虽可立即换人，但该被罚出队员须先从触角离开比赛场地，替补方可随即进入。</p>",
        "text": "有不当行为，包括使用不可接受的言语、暴力或持续的犯规动作、拒不服从或不尊重裁判员或官员、或违背规则精神且可能损害比赛声誉的行为。在沙滩水球规则中，因不当行为被罚出比赛余下部分的队员虽可立即换人，但该被罚出队员须先从触角离开比赛场地，替补方可随即进入。"
      },
      {
        "number": "19.18.10",
        "html": "<p>比赛中对对手或官员实施暴力行为。违规队员应被罚出比赛余下部分，3 分钟后方可换人，并判予对方球队一个罚点球。对在间歇或停表期间实施的暴力行为，不判予罚点球。</p>",
        "text": "比赛中对对手或官员实施暴力行为。违规队员应被罚出比赛余下部分，3 分钟后方可换人，并判予对方球队一个罚点球。对在间歇或停表期间实施的暴力行为，不判予罚点球。"
      },
      {
        "number": "19.18.11",
        "html": "<p>被罚出队员不当地重新入场、或替补不当地进入比赛区域，包括：从本方再入场区以外的任何地点入场；影响球门的对位；在被替换队员离开场地之前进入场地。</p>",
        "text": "被罚出队员不当地重新入场、或替补不当地进入比赛区域，包括：从本方再入场区以外的任何地点入场；影响球门的对位；在被替换队员离开场地之前进入场地。"
      },
      {
        "number": "19.18.12",
        "html": "<p>干扰罚点球的主罚，此时被罚出队员只能在罚点球掷出后方可重新入场。队员须距主罚罚点球的队员至少 3 米。</p>",
        "text": "干扰罚点球的主罚，此时被罚出队员只能在罚点球掷出后方可重新入场。队员须距主罚罚点球的队员至少 3 米。"
      },
      {
        "number": "19.18.13",
        "html": "<p>防守方守门员经裁判员警告后，在主罚罚点球前仍未在球门线上正确占位。可由另一名防守队员占据守门员位置，但不享有守门员权利。在罚点球前被罚出的守门员，触及触角区域后不得立即返回场地，而须离开场地、在触角处等候；只有在罚点球掷出（即球离开主罚者之手）后，守门员方可返回比赛。</p>",
        "text": "防守方守门员经裁判员警告后，在主罚罚点球前仍未在球门线上正确占位。可由另一名防守队员占据守门员位置，但不享有守门员权利。在罚点球前被罚出的守门员，触及触角区域后不得立即返回场地，而须离开场地、在触角处等候；只有在罚点球掷出（即球离开主罚者之手）后，守门员方可返回比赛。"
      },
      {
        "number": "19.18.14",
        "html": "<p>若对阵双方两名队员同时实施排他犯规，则两名队员均被罚出。控球权予以保留，进攻方应以任意球重新开始比赛；控球时间予以保留、不重置。比赛在两名被罚出队员均返回各自触角后重新开始。两名队员或其替补此后可在控球权转换时、或进球后返回场地。若被罚出队员被替换，换人须在场地外的触角处、与两名队员击掌后进行。</p>",
        "text": "若对阵双方两名队员同时实施排他犯规，则两名队员均被罚出。控球权予以保留，进攻方应以任意球重新开始比赛；控球时间予以保留、不重置。比赛在两名被罚出队员均返回各自触角后重新开始。两名队员或其替补此后可在控球权转换时、或进球后返回场地。若被罚出队员被替换，换人须在场地外的触角处、与两名队员击掌后进行。"
      },
      {
        "number": "19.18.15",
        "html": "<p>累计五次个人犯规的队员应被罚出比赛余下部分。</p>",
        "text": "累计五次个人犯规的队员应被罚出比赛余下部分。"
      },
      {
        "number": "19.19",
        "html": "<p><strong>点球犯规</strong></p>",
        "text": "点球犯规"
      },
      {
        "number": "19.19.1",
        "html": "<p>实施下列任一行为即为点球犯规，应判予对方球队一个罚点球。裁判员将以鸣哨并举臂张开五指来示意已判予罚点球。裁判员须延迟判罚，直至射门或射门尝试完成；此时裁判员可举臂示意可能判罚点球。</p>",
        "text": "实施下列任一行为即为点球犯规，应判予对方球队一个罚点球。裁判员将以鸣哨并举臂张开五指来示意已判予罚点球。裁判员须延迟判罚，直至射门或射门尝试完成；此时裁判员可举臂示意可能判罚点球。"
      },
      {
        "number": "19.19.2",
        "html": "<p>防守队员在 5 米区域内实施任何本可能导致进球的犯规，包括：按沉或移动球门；以握拳处理球；守门员或其他队员在 5 米区域内但在沙滩水球球门区外被抢截时将球带入水下；故意向位于 5 米区域内且正试图射门的对手脸部泼水。</p>",
        "text": "防守队员在 5 米区域内实施任何本可能导致进球的犯规，包括：按沉或移动球门；以握拳处理球；守门员或其他队员在 5 米区域内但在沙滩水球球门区外被抢截时将球带入水下；故意向位于 5 米区域内且正试图射门的对手脸部泼水。"
      },
      {
        "number": "19.19.3",
        "html": "<p>防守队员在 5 米区域内踢打对手或实施暴力行为。属暴力行为的，违规队员还应被罚出比赛余下部分，3 分钟后方可换人。</p>",
        "text": "防守队员在 5 米区域内踢打对手或实施暴力行为。属暴力行为的，违规队员还应被罚出比赛余下部分，3 分钟后方可换人。"
      },
      {
        "number": "19.19.4",
        "html": "<p>被罚出队员故意干扰比赛，包括影响球门的对位。</p>",
        "text": "被罚出队员故意干扰比赛，包括影响球门的对位。"
      },
      {
        "number": "19.19.5",
        "html": "<p>当时依规则无权参加比赛的队员或替补进入比赛场地。违规队员还应被罚出比赛余下部分并换人。</p>",
        "text": "当时依规则无权参加比赛的队员或替补进入比赛场地。违规队员还应被罚出比赛余下部分并换人。"
      },
      {
        "number": "19.19.6",
        "html": "<p>教练、任何球队官员或队员采取任何意图阻止可能进球或拖延比赛的行为，包括：</p><ul class=\"dash\"><li>防守队员在进攻方能够主罚任意球之前故意将球掷开；</li><li>防守队员在 5 米线外的任意球之后，故意将球推入 5 米线内，以避免直接射门。</li></ul><p>教练或任何球队官员的此项违规不记个人犯规。</p>",
        "text": "教练、任何球队官员或队员采取任何意图阻止可能进球或拖延比赛的行为，包括：防守队员在进攻方能够主罚任意球之前故意将球掷开；防守队员在 5 米线外的任意球之后，故意将球推入 5 米线内，以避免直接射门。教练或任何球队官员的此项违规不记个人犯规。"
      },
      {
        "number": "19.19.7",
        "html": "<p>非控球方球队的队员或替补不当地进入比赛场地。</p>",
        "text": "非控球方球队的队员或替补不当地进入比赛场地。"
      },
      {
        "number": "19.19.8",
        "html": "<p>若在比赛最后一分钟内某队获判罚点球，教练可选择保留控球权、改获一个任意球。记录控球时间的计时员应重置计时钟。</p>",
        "text": "若在比赛最后一分钟内某队获判罚点球，教练可选择保留控球权、改获一个任意球。记录控球时间的计时员应重置计时钟。"
      },
      {
        "number": "19.19.9",
        "html": "<p>在 5 米区域内，当队员处于“可能进球的情形”、带球及/或持球并在试图射门时从身后被阻挡（攻击），必须判予点球犯规。<em>【注：防守方仅触及球者除外】</em></p>",
        "text": "在 5 米区域内，当队员处于“可能进球的情形”、带球及/或持球并在试图射门时从身后被阻挡（攻击），必须判予点球犯规。【注：防守方仅触及球者除外】"
      },
      {
        "number": "19.19.10",
        "html": "<p>每节每第 4 次个人犯规（球队犯规）应判予附加罚点球（bonus penalty throw）。某队在一节内第 4 次个人犯规时，应判予对方球队一个附加罚点球，犯规队员须移至本队触角、位于场地外，直至罚点球掷出；此时在罚点球掷出前不得换人。若该第 4 次个人犯规本身为点球犯规，则只判予对方球队 1 个罚点球。若罚点球得分，主罚一方可获得新的连续控球，并以暂停后重新开始的方式（19.9.3）开始；若罚点球未得分，比赛继续。</p>",
        "text": "每节每第 4 次个人犯规（球队犯规）应判予附加罚点球（bonus penalty throw）。某队在一节内第 4 次个人犯规时，应判予对方球队一个附加罚点球，犯规队员须移至本队触角、位于场地外，直至罚点球掷出；此时在罚点球掷出前不得换人。若该第 4 次个人犯规本身为点球犯规，则只判予对方球队 1 个罚点球。若罚点球得分，主罚一方可获得新的连续控球，并以暂停后重新开始的方式（19.9.3）开始；若罚点球未得分，比赛继续。"
      },
      {
        "number": "19.20",
        "html": "<p><strong>罚点球</strong></p>",
        "text": "罚点球"
      },
      {
        "number": "19.20.1",
        "html": "<p>罚点球可由获判一方的任一队员主罚，从 5 米线主罚。</p>",
        "text": "罚点球可由获判一方的任一队员主罚，从 5 米线主罚。"
      },
      {
        "number": "19.20.2",
        "html": "<p>防守方守门员应位于两球门柱之间，在水面位置其身体任何部位都不得越过球门线。</p>",
        "text": "防守方守门员应位于两球门柱之间，在水面位置其身体任何部位都不得越过球门线。"
      },
      {
        "number": "19.20.3",
        "html": "<p>除实施点球犯规的队员外，所有队员都应离开 5 米区域，并距主罚队员至少 3 米。实施点球犯规的队员应移至本队触角、位于场地内，直至罚点球掷出。</p>",
        "text": "除实施点球犯规的队员外，所有队员都应离开 5 米区域，并距主罚队员至少 3 米。实施点球犯规的队员应移至本队触角、位于场地内，直至罚点球掷出。"
      },
      {
        "number": "19.20.4",
        "html": "<p>裁判员在确认所有队员都处于正确位置后，将以下列方式命令主罚罚点球：举臂表示准备射门，随后将手臂由竖直放至水平、同时鸣哨。手臂放下与哨声同时发出，使罚点球得以在任何条件下依规则执行。</p>",
        "text": "裁判员在确认所有队员都处于正确位置后，将以下列方式命令主罚罚点球：举臂表示准备射门，随后将手臂由竖直放至水平、同时鸣哨。手臂放下与哨声同时发出，使罚点球得以在任何条件下依规则执行。"
      },
      {
        "number": "19.20.5",
        "html": "<p>主罚罚点球的队员应控制球，并立即以连贯不间断的动作直接射向球门。队员可将球从水中举起主罚、或将球握于举起的手中主罚；在为前掷做准备时，球可朝背离球门的方向后引，但在球离开主罚者之手前，动作的连贯性不得中断。</p>",
        "text": "主罚罚点球的队员应控制球，并立即以连贯不间断的动作直接射向球门。队员可将球从水中举起主罚、或将球握于举起的手中主罚；在为前掷做准备时，球可朝背离球门的方向后引，但在球离开主罚者之手前，动作的连贯性不得中断。"
      },
      {
        "number": "19.20.6",
        "html": "<p>若球从球门柱、横梁或守门员处反弹，则球仍为活球，进球前无需另一名队员触球或处理球。</p>",
        "text": "若球从球门柱、横梁或守门员处反弹，则球仍为活球，进球前无需另一名队员触球或处理球。"
      },
      {
        "number": "19.20.7",
        "html": "<p>若在裁判员判予罚点球的同一精确时刻，计时员鸣哨示意某节结束，则除主罚队员和防守方守门员外，所有队员都应在主罚罚点球之前离开水面。在此情形下，若球反弹回比赛场地，球应立即成为死球。</p>",
        "text": "若在裁判员判予罚点球的同一精确时刻，计时员鸣哨示意某节结束，则除主罚队员和防守方守门员外，所有队员都应在主罚罚点球之前离开水面。在此情形下，若球反弹回比赛场地，球应立即成为死球。"
      },
      {
        "number": "19.21",
        "html": "<p><strong>事故与受伤</strong></p>",
        "text": "事故与受伤"
      },
      {
        "number": "19.21.1",
        "html": "<p>只有在事故、受伤或经裁判员许可的情况下，队员才可在比赛中离开水面。合法离开水面的队员，可经裁判员许可，在适当的停表时从距本方球门线最近的再入场区重新入场。</p>",
        "text": "只有在事故、受伤或经裁判员许可的情况下，队员才可在比赛中离开水面。合法离开水面的队员，可经裁判员许可，在适当的停表时从距本方球门线最近的再入场区重新入场。"
      },
      {
        "number": "19.21.2",
        "html": "<p>若队员流血，裁判员应立即命令其出水、替补立即入场。流血停止后，该队员可在比赛的正常进程中作为替补。</p>",
        "text": "若队员流血，裁判员应立即命令其出水、替补立即入场。流血停止后，该队员可在比赛的正常进程中作为替补。"
      },
      {
        "number": "19.21.3",
        "html": "<p>若发生流血以外的事故或受伤，裁判员可酌情中止比赛、但不超过 3 分钟；此时裁判员应指示计时员停表期从何时开始。除第六部分第 19.21.2 条（流血）的情形外，若已有替补入场，则该队员不得再参加该场比赛。</p>",
        "text": "若发生流血以外的事故或受伤，裁判员可酌情中止比赛、但不超过 3 分钟；此时裁判员应指示计时员停表期从何时开始。除第六部分第 19.21.2 条（流血）的情形外，若已有替补入场，则该队员不得再参加该场比赛。"
      },
      {
        "number": "19.22",
        "html": "<p><strong>个人犯规</strong></p>",
        "text": "个人犯规"
      },
      {
        "number": "19.22.1",
        "html": "<p>任何实施排他犯规或点球犯规的队员都应被记一次个人犯规。裁判员应向记录员指明违规队员的泳帽号码。</p>",
        "text": "任何实施排他犯规或点球犯规的队员都应被记一次个人犯规。裁判员应向记录员指明违规队员的泳帽号码。"
      },
      {
        "number": "19.22.2",
        "html": "<p>队员被记第五次个人犯规后，应被罚出比赛余下部分，并在其到达场地外的触角、双方击掌后换人。</p>",
        "text": "队员被记第五次个人犯规后，应被罚出比赛余下部分，并在其到达场地外的触角、双方击掌后换人。"
      },
      {
        "number": "19.22.3",
        "html": "<p>当某队在比赛任一节内累计四次个人犯规时，应判予一个罚点球，随后累计的球队犯规予以清零并重新计数（依第六部分第 19.19.10 条规定）。</p>",
        "text": "当某队在比赛任一节内累计四次个人犯规时，应判予一个罚点球，随后累计的球队犯规予以清零并重新计数（依第六部分第 19.19.10 条规定）。"
      },
      {
        "number": "19.23",
        "html": "<p><strong>黄牌与红牌</strong></p>",
        "text": "黄牌与红牌"
      },
      {
        "number": "19.23.1",
        "html": "<p>必要时，裁判员必须使用黄牌和红牌来管理替补席上的球队官员与替补队员，以及水中的队员。黄牌和红牌的使用适用于所有 World Aquatics 水球比赛，并按下列方式执行：</p>\n        <p>裁判员出示黄牌，是对该队主教练的正式警告。</p>\n        <p>裁判员随后出示红牌，即示意主教练及/或其他球队官员及/或替补席上的队员必须立即离开泳池区域。若主教练的行为有此必要，裁判员可不经出示黄牌而直接出示红牌。</p>\n        <p>当主教练被罚出比赛时，另一名球队官员可接替此位置，但不享有主教练的权利。该球队官员不得起身离开替补席，但可依规则请求暂停。在暂停期间或进球后、比赛重新开始之前，该球队官员可沿池边自由移动至中点以指导球队。</p>\n        <p>比赛中，当水中的某名队员实施不当行为时，裁判员必须向该队员出示红牌，并施以相应处罚。</p>\n        <p>若裁判员认为某队员持续以非体育精神的方式比赛、或进行模拟（第六部分第 8.14 条），可出示黄牌。裁判员应向违规球队出示黄牌并指向违规队员。若该行为继续，裁判员将向该队员出示红牌（须使球队和记录台均可见），因为此举被视为不当行为（依第六部分第 9.13 条）。</p>\n        <p>实施不当行为的球队成员将依第六部分第 9.13 条受罚，并必须立即离开泳池区域。</p>",
        "text": "必要时，裁判员必须使用黄牌和红牌来管理替补席上的球队官员与替补队员，以及水中的队员。黄牌和红牌的使用适用于所有 World Aquatics 水球比赛，并按下列方式执行： 裁判员出示黄牌，是对该队主教练的正式警告。 裁判员随后出示红牌，即示意主教练及/或其他球队官员及/或替补席上的队员必须立即离开泳池区域。若主教练的行为有此必要，裁判员可不经出示黄牌而直接出示红牌。 当主教练被罚出比赛时，另一名球队官员可接替此位置，但不享有主教练的权利。该球队官员不得起身离开替补席，但可依规则请求暂停。在暂停期间或进球后、比赛重新开始之前，该球队官员可沿池边自由移动至中点以指导球队。 比赛中，当水中的某名队员实施不当行为时，裁判员必须向该队员出示红牌，并施以相应处罚。 若裁判员认为某队员持续以非体育精神的方式比赛、或进行模拟（第六部分第 8.14 条），可出示黄牌。裁判员应向违规球队出示黄牌并指向违规队员。若该行为继续，裁判员将向该队员出示红牌（须使球队和记录台均可见），因为此举被视为不当行为（依第六部分第 9.13 条）。 实施不当行为的球队成员将依第六部分第 9.13 条受罚，并必须立即离开泳池区域。"
      }
    ]
  },
  {
    "id": "a3",
    "no": "附3",
    "title": "定义术语",
    "en": "Appendix 3 — Definitions",
    "clauses": [
      {
        "number": "比赛场地与器材 · Field of Play & Equipment",
        "html": "<p class=\"cat\">比赛场地与器材 · Field of Play &amp; Equipment</p>\n<p><b class=\"term\">比赛场地（Field of Play）</b>：水域中按附录 4 所述、正式标示为水球比赛进行场所的部分。</p>\n<p><b class=\"term\">记录台（Official table）</b>：指定地点，供其他必要官员和获授权人员在比赛中履行职责。</p>\n<p><b class=\"term\">飞行换人（Flying Substitution）</b>：球队在比赛进行中从飞行换人区换人的方式。</p>\n<p><b class=\"term\">飞行换人区（Flying Substitution Area）</b>：规则指定的、位于比赛场地一侧、可进行飞行换人的区域。</p>\n<p><b class=\"term\">进球（定义 A，Goal）</b>：球完全越过球门线、越过球门柱正面线且在横梁之下的结果。</p>\n<p><b class=\"term\">球门线（Goal line）</b>：比赛场地的端线，由球门柱正面构成（VI 7.1）。</p>\n<p><b class=\"term\">球门区（Goal area）</b>：自球门柱两侧外缘延伸 2 米、至球门线对面 2 米线的矩形区域。进攻队员未持球时不得进入该区，除非位于球的位置线之后。</p>\n<p><b class=\"term\">5 米线（5 metre line）</b>：罚点球的主罚位置线。</p>\n<p><b class=\"term\">6 米区域（6 metre area）</b>：距球门线 6 米以内的区域；依点球规则，某些犯规在此区域内构成点球犯规。</p>\n<p><b class=\"term\">中线（Half distance line）</b>：在中点处将比赛场地长度等分为两半的线。</p>\n<p><b class=\"term\">球门（Goal）</b>：球必须完全进入方能得分的结构（附录 4.2）。</p>",
        "text": "比赛场地与器材 · Field of Play & Equipment 比赛场地（Field of Play）：水域中按附录 4 所述、正式标示为水球比赛进行场所的部分。 记录台（Official table）：指定地点，供其他必要官员和获授权人员在比赛中履行职责。 飞行换人（Flying Substitution）：球队在比赛进行中从飞行换人区换人的方式。 飞行换人区（Flying Substitution Area）：规则指定的、位于比赛场地一侧、可进行飞行换人的区域。 进球（定义 A，Goal）：球完全越过球门线、越过球门柱正面线且在横梁之下的结果。 球门线（Goal line）：比赛场地的端线，由球门柱正面构成（VI 7.1）。 球门区（Goal area）：自球门柱两侧外缘延伸 2 米、至球门线对面 2 米线的矩形区域。进攻队员未持球时不得进入该区，除非位于球的位置线之后。 5 米线（5 metre line）：罚点球的主罚位置线。 6 米区域（6 metre area）：距球门线 6 米以内的区域；依点球规则，某些犯规在此区域内构成点球犯规。 中线（Half distance line）：在中点处将比赛场地长度等分为两半的线。 球门（Goal）：球必须完全进入方能得分的结构（附录 4.2）。"
      },
      {
        "number": "球队与替补 · Teams and Substitutes",
        "html": "<p class=\"cat\">球队与替补 · Teams and Substitutes</p>\n<p><b class=\"term\">球队（Team）</b>：第六部分第 2.1 条所述的水球队。</p>\n<p><b class=\"term\">队员（Player）</b>：水球队的个体成员。</p>\n<p><b class=\"term\">守门员（Goalkeeper）</b>：球队的个体成员，戴红色 1 号帽，主要职责是阻止球进入球门。替补守门员应戴 2 至 14 号中任一红色泳帽。在允许球队名单 15 人或以上的特定赛事中提名第三守门员时，15 号帽应为红色、专供第三守门员使用。</p>\n<p><b class=\"term\">替补（Substitute）</b>：进入场地替换场上队员或被罚出队员的队员。</p>\n<p><b class=\"term\">后备（Reserve）</b>：当时未在比赛中的球队成员。</p>\n<p><b class=\"term\">指定横向换人区（Designated lateral substitution area）</b>：即“飞行换人区”。</p>\n<p><b class=\"term\">罚出再入场区（Exclusion Re-entry area）</b>：队员或替补在罚出后返回比赛场地的位置。</p>\n<p><b class=\"term\">有利（Advantage）</b>：进攻队员及/或进攻方继续控制球以创造得分机会的机会。裁判员执裁须使进攻方能保持其有利。</p>\n<p><b class=\"term\">红牌（Red Card）</b>：裁判员示意将队员、教练或任何球队官员罚出比赛余下部分的信号。</p>\n<p><b class=\"term\">黄牌（Yellow Card）</b>：裁判员就不当行为、替补席体育精神不足、或球队反复模拟与持续犯规，向教练发出的警告信号。</p>\n<p><b class=\"term\">违规队员（Offending player）</b>：依规则犯规的队员。</p>",
        "text": "球队与替补 · Teams and Substitutes 球队（Team）：第六部分第 2.1 条所述的水球队。 队员（Player）：水球队的个体成员。 守门员（Goalkeeper）：球队的个体成员，戴红色 1 号帽，主要职责是阻止球进入球门。替补守门员应戴 2 至 14 号中任一红色泳帽。在允许球队名单 15 人或以上的特定赛事中提名第三守门员时，15 号帽应为红色、专供第三守门员使用。 替补（Substitute）：进入场地替换场上队员或被罚出队员的队员。 后备（Reserve）：当时未在比赛中的球队成员。 指定横向换人区（Designated lateral substitution area）：即“飞行换人区”。 罚出再入场区（Exclusion Re-entry area）：队员或替补在罚出后返回比赛场地的位置。 有利（Advantage）：进攻队员及/或进攻方继续控制球以创造得分机会的机会。裁判员执裁须使进攻方能保持其有利。 红牌（Red Card）：裁判员示意将队员、教练或任何球队官员罚出比赛余下部分的信号。 黄牌（Yellow Card）：裁判员就不当行为、替补席体育精神不足、或球队反复模拟与持续犯规，向教练发出的警告信号。 违规队员（Offending player）：依规则犯规的队员。"
      },
      {
        "number": "裁判员与技术官员 · Referees and Technical Officials",
        "html": "<p class=\"cat\">裁判员与技术官员 · Referees and Technical Officials</p>\n<p><b class=\"term\">视频助理裁判 VAR（Video assistant referee）</b>：视频技术与助理裁判；裁判员可在附录 7（VAR 规程）所述情形回看后、或在附录 10（教练挑战规程）所述情形下经教练挑战后，用以作出最终判罚。</p>\n<p><b class=\"term\">裁判员（Referee）</b>：负责主持比赛、行使规则规定职能的官员。</p>\n<p><b class=\"term\">处理球的可能（Possibility to play the ball）</b>：持球队员能够通过将球投入行动而继续比赛的情形。</p>\n<p><b class=\"term\">中锋（Centre forward）</b>：主要位置在对方 2 米线附近、通常处于两球门柱宽度之间的进攻队员。</p>\n<p><b class=\"term\">中卫（Centre back）</b>：主要职责为盯防对方中锋的防守队员（参见“中锋”）。</p>\n<p><b class=\"term\">球门裁判或助理裁判（Goal Judge / assistant referee）</b>：坐在球门线上的官员，协助裁判员判定球是否进入球门或越过球门线（含最后触球者），并按裁判员指示投放新球。</p>\n<p><b class=\"term\">开始或重新开始（Start or restart）</b>：在某节开始时、进球后、或裁判员叫球并停止比赛后开始比赛。</p>",
        "text": "裁判员与技术官员 · Referees and Technical Officials 视频助理裁判 VAR（Video assistant referee）：视频技术与助理裁判；裁判员可在附录 7（VAR 规程）所述情形回看后、或在附录 10（教练挑战规程）所述情形下经教练挑战后，用以作出最终判罚。 裁判员（Referee）：负责主持比赛、行使规则规定职能的官员。 处理球的可能（Possibility to play the ball）：持球队员能够通过将球投入行动而继续比赛的情形。 中锋（Centre forward）：主要位置在对方 2 米线附近、通常处于两球门柱宽度之间的进攻队员。 中卫（Centre back）：主要职责为盯防对方中锋的防守队员（参见“中锋”）。 球门裁判或助理裁判（Goal Judge / assistant referee）：坐在球门线上的官员，协助裁判员判定球是否进入球门或越过球门线（含最后触球者），并按裁判员指示投放新球。 开始或重新开始（Start or restart）：在某节开始时、进球后、或裁判员叫球并停止比赛后开始比赛。"
      },
      {
        "number": "比赛时长 · Duration of the Game",
        "html": "<p class=\"cat\">比赛时长 · Duration of the Game</p>\n<p><b class=\"term\">实际比赛时间（Actual play）</b>：两队进行四节，每节 8 分钟实际比赛时间，共 32 分钟。实际比赛时间自每节开始、队员触球时开始，在裁判员或进攻计时钟示意的每次停顿时停止，并在队员依规则将球投入比赛、射门或传球时于每次停顿后继续。</p>\n<p><b class=\"term\">点球大战（Penalty Shoot-out）</b>：在常规时间结束比分相同时，用以决出明确结果的方法，由附录 6 规范。</p>\n<p><b class=\"term\">进攻端裁判（Attacking Referee）</b>：主要关注其右侧球门前进攻局面的裁判员。</p>\n<p><b class=\"term\">防守端裁判（Defensive Referee）</b>：控制其左侧进攻局面的裁判员，通常保持在距球门最远的最后一名进攻队员位置之后。</p>",
        "text": "比赛时长 · Duration of the Game 实际比赛时间（Actual play）：两队进行四节，每节 8 分钟实际比赛时间，共 32 分钟。实际比赛时间自每节开始、队员触球时开始，在裁判员或进攻计时钟示意的每次停顿时停止，并在队员依规则将球投入比赛、射门或传球时于每次停顿后继续。 点球大战（Penalty Shoot-out）：在常规时间结束比分相同时，用以决出明确结果的方法，由附录 6 规范。 进攻端裁判（Attacking Referee）：主要关注其右侧球门前进攻局面的裁判员。 防守端裁判（Defensive Referee）：控制其左侧进攻局面的裁判员，通常保持在距球门最远的最后一名进攻队员位置之后。"
      },
      {
        "number": "暂停 · Timeouts",
        "html": "<p class=\"cat\">暂停 · Timeouts</p>\n<p><b class=\"term\">暂停（Timeout）</b>：进攻方可在任何时刻（VAR 回看期间除外）使用的 1 分钟比赛停顿。每队每场比赛有两次暂停权利。</p>\n<p><b class=\"term\">违例暂停（Illegal Timeout）</b>：球队无权享有却请求的暂停。</p>\n<p><b class=\"term\">控球（Possession）</b>：当某队的一名队员持球或带球游动时，即为控球。</p>",
        "text": "暂停 · Timeouts 暂停（Timeout）：进攻方可在任何时刻（VAR 回看期间除外）使用的 1 分钟比赛停顿。每队每场比赛有两次暂停权利。 违例暂停（Illegal Timeout）：球队无权享有却请求的暂停。 控球（Possession）：当某队的一名队员持球或带球游动时，即为控球。"
      },
      {
        "number": "得分方式 · Method of Scoring",
        "html": "<p class=\"cat\">得分方式 · Method of Scoring</p>\n<p><b class=\"term\">明显将球投入比赛（Visibly putting the ball into play）</b>：指球必须离开持球队员之手。将球从左手抛到右手也视为将球投入比赛。</p>\n<p><b class=\"term\">假动作（Fake）</b>：模拟射门。</p>\n<p><b class=\"term\">开球游泳（Swim up）</b>：每节开始时球置于场地中央，鸣哨示意比赛开始后，两队冲向池中央争夺控球。</p>",
        "text": "得分方式 · Method of Scoring 明显将球投入比赛（Visibly putting the ball into play）：指球必须离开持球队员之手。将球从左手抛到右手也视为将球投入比赛。 假动作（Fake）：模拟射门。 开球游泳（Swim up）：每节开始时球置于场地中央，鸣哨示意比赛开始后，两队冲向池中央争夺控球。"
      },
      {
        "number": "普通犯规 · Ordinary Fouls",
        "html": "<p class=\"cat\">普通犯规 · Ordinary Fouls</p>\n<p><b class=\"term\">错误开始（False Start）</b>：不正当地开始比赛，即在裁判员发出信号之前开始，或从球门借力/影响球门对位。</p>\n<p><b class=\"term\">犯规（Foul）</b>：违反规则、导致比赛计时钟停止并判予任意球。犯规分两类——身体犯规（队员的身体接触阻止对手继续移动）；技术犯规（违反规则，如错误开始或重启、以握拳或双手击球等）。</p>\n<p><b class=\"term\">球压水下（Ball under）</b>：因被对手抢截时将球压入水下、或意图向对手藏球而被判的普通犯规。</p>\n<p><b class=\"term\">同时罚出（Simultaneous exclusion）</b>：对阵双方两名队员被同时罚出。</p>\n<p><b class=\"term\">比赛精神（Spirit of the Game）</b>：本运动的定义性特征。秉持比赛精神比赛，意味着在尊重队友、对手和比赛本身的前提下力争取胜，以理解规则、正直诚实的态度比赛。</p>\n<p><b class=\"term\">借力推顶（Push-off）</b>：用手、臂、脚或其他身体部位推顶对手以获取优势。</p>\n<p><b class=\"term\">踢踹（Kicking）</b>：用脚对对手身体或脸部的击打、打击或猛力冲撞，属个人犯规。</p>\n<p><b class=\"term\">模拟（Simulation）</b>：假装被犯规。</p>\n<p><b class=\"term\">突破驱进（To drive）</b>：面对对手的进攻队员，试图强行游过该对手、抵达更靠近球门的有利位置的进攻动作。</p>\n<p><b class=\"term\">突破者（Driver）</b>：朝球门突破的队员，通常从面对对手的静止位置开始，试图强行游过对手抵达更靠近球门的有利位置。</p>\n<p><b class=\"term\">抢截（To tackle）</b>：抓拉、按沉、回拽或阻碍持球队员。</p>\n<p><b class=\"term\">进攻方犯规（Offensive Foul）</b>：进攻队员所犯、导致判予防守方任意球的犯规。</p>\n<p><b class=\"term\">持球（Holding the ball）</b>：举球、托球或触球，但不包括运球。</p>",
        "text": "普通犯规 · Ordinary Fouls 错误开始（False Start）：不正当地开始比赛，即在裁判员发出信号之前开始，或从球门借力/影响球门对位。 犯规（Foul）：违反规则、导致比赛计时钟停止并判予任意球。犯规分两类——身体犯规（队员的身体接触阻止对手继续移动）；技术犯规（违反规则，如错误开始或重启、以握拳或双手击球等）。 球压水下（Ball under）：因被对手抢截时将球压入水下、或意图向对手藏球而被判的普通犯规。 同时罚出（Simultaneous exclusion）：对阵双方两名队员被同时罚出。 比赛精神（Spirit of the Game）：本运动的定义性特征。秉持比赛精神比赛，意味着在尊重队友、对手和比赛本身的前提下力争取胜，以理解规则、正直诚实的态度比赛。 借力推顶（Push-off）：用手、臂、脚或其他身体部位推顶对手以获取优势。 踢踹（Kicking）：用脚对对手身体或脸部的击打、打击或猛力冲撞，属个人犯规。 模拟（Simulation）：假装被犯规。 突破驱进（To drive）：面对对手的进攻队员，试图强行游过该对手、抵达更靠近球门的有利位置的进攻动作。 突破者（Driver）：朝球门突破的队员，通常从面对对手的静止位置开始，试图强行游过对手抵达更靠近球门的有利位置。 抢截（To tackle）：抓拉、按沉、回拽或阻碍持球队员。 进攻方犯规（Offensive Foul）：进攻队员所犯、导致判予防守方任意球的犯规。 持球（Holding the ball）：举球、托球或触球，但不包括运球。"
      },
      {
        "number": "排他犯规 · Exclusion Fouls",
        "html": "<p class=\"cat\">排他犯规 · Exclusion Fouls</p>\n<p><b class=\"term\">不当入场（Improper Entry）</b>：队员在比赛进行中不按规则进入比赛。</p>\n<p><b class=\"term\">不当再入场（Improper Re-entry）</b>：替补在比赛进行中不按规则进入比赛。</p>\n<p><b class=\"term\">排他犯规（Exclusion Foul）</b>：队员被罚出、按规则规定时段不得参加比赛的犯规。</p>\n<p><b class=\"term\">不当行为（Misconduct）</b>：任何不正当行为，包括对裁判员或对手不敬，以及无视裁判员的指示。</p>\n<p><b class=\"term\">暴力行为（Violent action）</b>：队员意图伤害另一名队员或官员的行为，无论是否发生接触。</p>\n<p><b class=\"term\">侵略性犯规动作（Aggressive foul play）</b>：可能导致对手受伤的行为。此类犯规意在彻底破坏、完全中止比赛或队员的有利或进程，或激怒对手。属危险动作，虽无明确伤人意图，但通常由情绪导致。</p>\n<p><b class=\"term\">持续犯规（Persistent foul play）</b>：防守队员阻止进攻的违规犯规。此类犯规意不在伤人，而在破坏比赛的流畅、有利与速度，并恐吓对手。</p>\n<p><b class=\"term\">阻碍（To Impede）</b>：以抓握或封堵对手等违规身体动作阻碍其移动。</p>\n<p><b class=\"term\">抓握对手（To hold an opponent）</b>：用手、臂或腿抓住对手、意图限制其移动。</p>\n<p><b class=\"term\">按沉（To sink）</b>：将对手按入水下。</p>\n<p><b class=\"term\">回拽（To Pull back）</b>：拉拽对方队员。</p>\n<p><b class=\"term\">干扰任意球、球门球或罚点球（To interfere with a free/goal/penalty throw）</b>：扰乱或干扰上述任一掷球的主罚。</p>\n<p><b class=\"term\">不成比例的动作（Disproportionate movements）</b>：意图踢打的任何动作，即使未发生接触。</p>\n<p><b class=\"term\">击打（To strike）</b>：即“打击”。</p>\n<p><b class=\"term\">战术犯规（Tactical foul）</b>：防守方意图中断比赛流畅、剥夺对方有利（尤指反击）的任何犯规。</p>\n<p><b class=\"term\">反击（Counterattack）</b>：进攻方的转换，将球迅速由场地一端推进至另一端，试图在防守方就位前得分。</p>",
        "text": "排他犯规 · Exclusion Fouls 不当入场（Improper Entry）：队员在比赛进行中不按规则进入比赛。 不当再入场（Improper Re-entry）：替补在比赛进行中不按规则进入比赛。 排他犯规（Exclusion Foul）：队员被罚出、按规则规定时段不得参加比赛的犯规。 不当行为（Misconduct）：任何不正当行为，包括对裁判员或对手不敬，以及无视裁判员的指示。 暴力行为（Violent action）：队员意图伤害另一名队员或官员的行为，无论是否发生接触。 侵略性犯规动作（Aggressive foul play）：可能导致对手受伤的行为。此类犯规意在彻底破坏、完全中止比赛或队员的有利或进程，或激怒对手。属危险动作，虽无明确伤人意图，但通常由情绪导致。 持续犯规（Persistent foul play）：防守队员阻止进攻的违规犯规。此类犯规意不在伤人，而在破坏比赛的流畅、有利与速度，并恐吓对手。 阻碍（To Impede）：以抓握或封堵对手等违规身体动作阻碍其移动。 抓握对手（To hold an opponent）：用手、臂或腿抓住对手、意图限制其移动。 按沉（To sink）：将对手按入水下。 回拽（To Pull back）：拉拽对方队员。 干扰任意球、球门球或罚点球（To interfere with a free/goal/penalty throw）：扰乱或干扰上述任一掷球的主罚。 不成比例的动作（Disproportionate movements）：意图踢打的任何动作，即使未发生接触。 击打（To strike）：即“打击”。 战术犯规（Tactical foul）：防守方意图中断比赛流畅、剥夺对方有利（尤指反击）的任何犯规。 反击（Counterattack）：进攻方的转换，将球迅速由场地一端推进至另一端，试图在防守方就位前得分。"
      },
      {
        "number": "点球犯规 · Penalty Fouls",
        "html": "<p class=\"cat\">点球犯规 · Penalty Fouls</p>\n<p><b class=\"term\">点球犯规（Penalty Foul）</b>：在 6 米内实施、阻止可能进球的任何犯规（第六部分第 10.2 至 10.11 条）。此外，暴力行为（第 9.14 条）和拖延比赛（第 10.10 条）也可能导致点球（第 10.9 条）。</p>\n<p><b class=\"term\">可能进球的情形（Probable goal situation）</b>：进攻队员面向球门、其与守门员之间无防守队员，若无犯规则极可能进球的情形。球门空虚且球在附近时也属此类情形，另见手册所述示例。</p>\n<p><b class=\"term\">坏传球（Bad pass）</b>：进攻方无法够到的传球，无论队员是否被犯规。坏传球情形下不处罚防守队员。</p>\n<p><b class=\"term\">防守者前位（Front position on a defender）</b>：进攻队员取得有利位置，即处于防守队员与对方球门之间的位置。</p>\n<p><b class=\"term\">拖延比赛（Delaying the game）</b>：故意阻止进攻队员推进动作，或任何违背比赛精神、意图阻止可能进球的干扰。</p>\n<p><b class=\"term\">无资格队员（Illegal Player）</b>：无权参加比赛的队员。</p>",
        "text": "点球犯规 · Penalty Fouls 点球犯规（Penalty Foul）：在 6 米内实施、阻止可能进球的任何犯规（第六部分第 10.2 至 10.11 条）。此外，暴力行为（第 9.14 条）和拖延比赛（第 10.10 条）也可能导致点球（第 10.9 条）。 可能进球的情形（Probable goal situation）：进攻队员面向球门、其与守门员之间无防守队员，若无犯规则极可能进球的情形。球门空虚且球在附近时也属此类情形，另见手册所述示例。 坏传球（Bad pass）：进攻方无法够到的传球，无论队员是否被犯规。坏传球情形下不处罚防守队员。 防守者前位（Front position on a defender）：进攻队员取得有利位置，即处于防守队员与对方球门之间的位置。 拖延比赛（Delaying the game）：故意阻止进攻队员推进动作，或任何违背比赛精神、意图阻止可能进球的干扰。 无资格队员（Illegal Player）：无权参加比赛的队员。"
      },
      {
        "number": "任意球 · Free Throws",
        "html": "<p class=\"cat\">任意球 · Free Throws</p>\n<p><b class=\"term\">任意球（Free Throw）</b>：在普通犯规、排他犯规之后，或在暂停、进球、受伤（含流血）、换帽、裁判员叫球、球从场地边线出界或任何其他延误之后重新开始时，将球投入比赛的方式。</p>\n<p><b class=\"term\">封挡射门或传球（To block a shot or pass）</b>：用手、臂或身体阻止球的飞行。</p>\n<p><b class=\"term\">射门（Shot）</b>：有意将球射向对方球门以图得分的尝试。</p>",
        "text": "任意球 · Free Throws 任意球（Free Throw）：在普通犯规、排他犯规之后，或在暂停、进球、受伤（含流血）、换帽、裁判员叫球、球从场地边线出界或任何其他延误之后重新开始时，将球投入比赛的方式。 封挡射门或传球（To block a shot or pass）：用手、臂或身体阻止球的飞行。 射门（Shot）：有意将球射向对方球门以图得分的尝试。"
      },
      {
        "number": "球门球 · Goal Throws",
        "html": "<p class=\"cat\">球门球 · Goal Throws</p>\n<p><b class=\"term\">掷球（Throw）</b>：用手放球、意图将球投入比赛、传球或得分的任何动作。</p>\n<p><b class=\"term\">球门球（Goal Throw）</b>：依第六部分第 12 条判予防守方的掷球。</p>\n<p><b class=\"term\">运球（Dribble the ball）</b>：带球游动或以游动推进球。运球的队员处于控球状态，但不属“持球”。</p>\n<p><b class=\"term\">传球（Pass the ball）</b>：将球从一名队员掷给队友、或掷向队友控制的区域。意在保持控球（而非意在射门得分）地将球掷向队友（或自己）。</p>",
        "text": "球门球 · Goal Throws 掷球（Throw）：用手放球、意图将球投入比赛、传球或得分的任何动作。 球门球（Goal Throw）：依第六部分第 12 条判予防守方的掷球。 运球（Dribble the ball）：带球游动或以游动推进球。运球的队员处于控球状态，但不属“持球”。 传球（Pass the ball）：将球从一名队员掷给队友、或掷向队友控制的区域。意在保持控球（而非意在射门得分）地将球掷向队友（或自己）。"
      },
      {
        "number": "角球 · Corner Throws",
        "html": "<p class=\"cat\">角球 · Corner Throws</p>\n<p><b class=\"term\">角球（Corner Throw）</b>：依第六部分第 13.2 条，在防守方 2 米线判予进攻方的掷球。</p>\n<p><b class=\"term\">直接射门（Direct shot）</b>：球可在下列情形直接射向球门——队员、球与犯规均在 6 米线外的任意球之后；罚点球；角球（见第六部分第 7.2 条）。</p>",
        "text": "角球 · Corner Throws 角球（Corner Throw）：依第六部分第 13.2 条，在防守方 2 米线判予进攻方的掷球。 直接射门（Direct shot）：球可在下列情形直接射向球门——队员、球与犯规均在 6 米线外的任意球之后；罚点球；角球（见第六部分第 7.2 条）。"
      },
      {
        "number": "中立球 · Neutral Throws",
        "html": "<p class=\"cat\">中立球 · Neutral Throws</p>\n<p><b class=\"term\">中立球（Neutral Throw）</b>：两队均未控球时将球投入比赛的方式。裁判员将球掷入两名对阵队员之间的池中重新开始比赛，使各方有均等机会获得球。</p>",
        "text": "中立球 · Neutral Throws 中立球（Neutral Throw）：两队均未控球时将球投入比赛的方式。裁判员将球掷入两名对阵队员之间的池中重新开始比赛，使各方有均等机会获得球。"
      },
      {
        "number": "罚点球 · Penalty Throws",
        "html": "<p class=\"cat\">罚点球 · Penalty Throws</p>\n<p><b class=\"term\">罚点球（Penalty Throw）</b>：从 5 米线、仅由守门员防守的自由射门。防守方守门员应位于球门线上两球门柱之间，在裁判员发出射门信号后方可前移。防守队员只能在球离开射门队员之手后进入 6 米区域。</p>",
        "text": "罚点球 · Penalty Throws 罚点球（Penalty Throw）：从 5 米线、仅由守门员防守的自由射门。防守方守门员应位于球门线上两球门柱之间，在裁判员发出射门信号后方可前移。防守队员只能在球离开射门队员之手后进入 6 米区域。"
      },
      {
        "number": "个人犯规 · Personal Fouls",
        "html": "<p class=\"cat\">个人犯规 · Personal Fouls</p>\n<p><b class=\"term\">个人犯规（Personal Foul）</b>：当裁判员判予排他犯规或点球犯规时、记于队员名下的个人化犯规。</p>",
        "text": "个人犯规 · Personal Fouls 个人犯规（Personal Foul）：当裁判员判予排他犯规或点球犯规时、记于队员名下的个人化犯规。"
      },
      {
        "number": "其他说明与澄清 · Addendum",
        "html": "<p class=\"cat\">其他说明与澄清 · Addendum</p>\n<p><b class=\"term\">转换（Transition）</b>：球队由攻转守或由守转攻的比赛阶段。</p>\n<p><b class=\"term\">进攻队员（Attacking player）</b>：所在球队控球的队员；该队控制球并有机会得分。</p>\n<p><b class=\"term\">防守队员（Defending player）</b>：所在球队不控制、不持有球的队员；试图防守本队球门的队员。</p>",
        "text": "其他说明与澄清 · Addendum 转换（Transition）：球队由攻转守或由守转攻的比赛阶段。 进攻队员（Attacking player）：所在球队控球的队员；该队控制球并有机会得分。 防守队员（Defending player）：所在球队不控制、不持有球的队员；试图防守本队球门的队员。"
      }
    ]
  },
  {
    "id": "a5",
    "no": "附5",
    "title": "官员",
    "en": "Appendix 5 — Officials",
    "clauses": [
      {
        "number": "20.5.1",
        "html": "<p><strong>World Aquatics 赛事的官员</strong></p>",
        "text": "World Aquatics 赛事的官员"
      },
      {
        "number": "20.5.1.1",
        "html": "<p>在 World Aquatics 赛事中，官员应包括两名裁判员、两名助理裁判员、计时员与记录员，以及一名视频助理裁判员，各自拥有以下权力与职责。在可能的情况下，其他赛事也应配备这些官员；但在由两名裁判员、无助理裁判员执裁的比赛中，裁判员应承担分配给助理裁判员的职责（但不做规定的手势信号）。</p>\n        <p>视赛事重要程度，比赛可由 4 至 9 名官员组成的团队控制，如下：</p>\n        <ol class=\"alpha\">\n          <li><strong>裁判员与助理裁判员</strong>：两名裁判员加两名助理裁判员；或两名裁判员、无助理裁判员；或一名裁判员加两名助理裁判员。</li>\n          <li><strong>计时员与记录员</strong>：\n            <ul class=\"dash\">\n              <li>一名计时员加一名记录员：计时员依第 8.12 条记录每队连续控球时间；记录员记录实际比赛时间、暂停及节间间歇的准确时段，按第 20.5.5 条保持比赛记录，并记录依规则被命令出水队员各自的罚出时段。</li>\n              <li>两名计时员加一名记录员：1 号计时员记录实际比赛时间、暂停及节间间歇；2 号计时员依第 8.12 条记录每队连续控球时间；记录员保持比赛记录并履行规则规定的其他职责。</li>\n              <li>两名计时员加两名记录员：1 号计时员记录实际比赛时间、暂停及节间间歇；2 号计时员依第 8.12 条记录控球时间；1 号记录员保持比赛记录；2 号记录员负责被罚出队员的不当再入场、替补不当入场、罚出队员及第三次个人犯规相关事务。</li>\n            </ul>\n          </li>\n          <li><strong>视频助理裁判员</strong>：按规则要求协助两名裁判员。</li>\n        </ol>",
        "text": "在 World Aquatics 赛事中，官员应包括两名裁判员、两名助理裁判员、计时员与记录员，以及一名视频助理裁判员，各自拥有以下权力与职责。在可能的情况下，其他赛事也应配备这些官员；但在由两名裁判员、无助理裁判员执裁的比赛中，裁判员应承担分配给助理裁判员的职责（但不做规定的手势信号）。 视赛事重要程度，比赛可由 4 至 9 名官员组成的团队控制，如下： 裁判员与助理裁判员：两名裁判员加两名助理裁判员；或两名裁判员、无助理裁判员；或一名裁判员加两名助理裁判员。 计时员与记录员： 一名计时员加一名记录员：计时员依第 8.12 条记录每队连续控球时间；记录员记录实际比赛时间、暂停及节间间歇的准确时段，按第 20.5.5 条保持比赛记录，并记录依规则被命令出水队员各自的罚出时段。 两名计时员加一名记录员：1 号计时员记录实际比赛时间、暂停及节间间歇；2 号计时员依第 8.12 条记录每队连续控球时间；记录员保持比赛记录并履行规则规定的其他职责。 两名计时员加两名记录员：1 号计时员记录实际比赛时间、暂停及节间间歇；2 号计时员依第 8.12 条记录控球时间；1 号记录员保持比赛记录；2 号记录员负责被罚出队员的不当再入场、替补不当入场、罚出队员及第三次个人犯规相关事务。 视频助理裁判员：按规则要求协助两名裁判员。"
      },
      {
        "number": "20.5.2",
        "html": "<p><strong>裁判员</strong></p>",
        "text": "裁判员"
      },
      {
        "number": "20.5.2.1",
        "html": "<p>裁判员在比赛中使用音频设备。比赛中，两名裁判员应配备音频耳机以便彼此沟通。监督和 VAR 助理裁判员也将配备耳机，但仅用于接收记录台信息并确保清晰。</p>",
        "text": "裁判员在比赛中使用音频设备。比赛中，两名裁判员应配备音频耳机以便彼此沟通。监督和 VAR 助理裁判员也将配备耳机，但仅用于接收记录台信息并确保清晰。"
      },
      {
        "number": "20.5.2.2",
        "html": "<p>裁判员对事实问题的所有判定均为最终决定，其对规则的解释在整场比赛中都须被遵从。裁判员不得对比赛中任何情形的事实作出臆断，而应尽其所能解释其所观察到的情况。</p>",
        "text": "裁判员对事实问题的所有判定均为最终决定，其对规则的解释在整场比赛中都须被遵从。裁判员不得对比赛中任何情形的事实作出臆断，而应尽其所能解释其所观察到的情况。"
      },
      {
        "number": "20.5.2.3",
        "html": "<p>裁判员应鸣哨开始和重新开始比赛，并宣告进球、球门球、角球（无论助理裁判员是否示意）、中立球及违规。裁判员可更改判罚，但须在球重新投入比赛之前作出。</p>",
        "text": "裁判员应鸣哨开始和重新开始比赛，并宣告进球、球门球、角球（无论助理裁判员是否示意）、中立球及违规。裁判员可更改判罚，但须在球重新投入比赛之前作出。"
      },
      {
        "number": "20.5.2.4",
        "html": "<p>裁判员有权依相应规则命令任何队员出水；若队员经命令后拒不出水，有权终止比赛。</p>",
        "text": "裁判员有权依相应规则命令任何队员出水；若队员经命令后拒不出水，有权终止比赛。"
      },
      {
        "number": "20.5.3",
        "html": "<p><strong>助理裁判员</strong></p>",
        "text": "助理裁判员"
      },
      {
        "number": "20.5.3.1",
        "html": "<p>助理裁判员应位于记录台同侧，各自在比赛场地一端的球门线上。</p>",
        "text": "助理裁判员应位于记录台同侧，各自在比赛场地一端的球门线上。"
      },
      {
        "number": "20.5.3.2",
        "html": "<p>助理裁判员的职责为：</p><ol class=\"alpha\"><li>每节开始时，当队员在各自球门线上正确就位，举一臂竖直示意；</li><li>对不当的开始或重新开始，举双臂竖直示意；</li><li>对球门球，以手臂指向进攻方向示意；</li><li>对角球，以手臂指向进攻方向示意；</li><li>对进球，举起并交叉双臂示意；</li><li>对被罚出队员的不当再入场或替补的不当入场，举双臂竖直示意。</li></ol>",
        "text": "助理裁判员的职责为：每节开始时，当队员在各自球门线上正确就位，举一臂竖直示意；对不当的开始或重新开始，举双臂竖直示意；对球门球，以手臂指向进攻方向示意；对角球，以手臂指向进攻方向示意；对进球，举起并交叉双臂示意；对被罚出队员的不当再入场或替补的不当入场，举双臂竖直示意。"
      },
      {
        "number": "20.5.3.3",
        "html": "<p>每名助理裁判员应备有若干备用球；当原球出场地时，应立即将新球投给守门员（球门球）、投给进攻方最近的队员（角球），或按裁判员指示处理。</p>",
        "text": "每名助理裁判员应备有若干备用球；当原球出场地时，应立即将新球投给守门员（球门球）、投给进攻方最近的队员（角球），或按裁判员指示处理。"
      },
      {
        "number": "20.5.4",
        "html": "<p><strong>计时员</strong></p>",
        "text": "计时员"
      },
      {
        "number": "20.5.4.1",
        "html": "<p>计时员的职责为：</p><ol class=\"alpha\"><li>记录实际比赛时间、暂停及节间间歇的准确时段；</li><li>记录每队连续控球的时段；</li><li>记录依规则被命令出水队员的罚出时间，以及该队员或其替补的再入场时间；</li><li>以声音宣布比赛最后一分钟的开始；</li><li>在 45 秒后及每次暂停结束时鸣哨示意。</li></ol>",
        "text": "计时员的职责为：记录实际比赛时间、暂停及节间间歇的准确时段；记录每队连续控球的时段；记录依规则被命令出水队员的罚出时间，以及该队员或其替补的再入场时间；以声音宣布比赛最后一分钟的开始；在 45 秒后及每次暂停结束时鸣哨示意。"
      },
      {
        "number": "20.5.4.2",
        "html": "<p>计时员应独立于裁判员，以鸣哨（或任何独特、声音有效且易于理解的方式）示意每节结束，该信号立即生效，但下列情形除外：</p><ol class=\"alpha\"><li>裁判员同时判予罚点球，此时该罚点球应依规则执行；</li><li>球正在飞行中并越过球门线，此时由此产生的进球应予有效。</li></ol>",
        "text": "计时员应独立于裁判员，以鸣哨（或任何独特、声音有效且易于理解的方式）示意每节结束，该信号立即生效，但下列情形除外：裁判员同时判予罚点球，此时该罚点球应依规则执行；球正在飞行中并越过球门线，此时由此产生的进球应予有效。"
      },
      {
        "number": "20.5.5",
        "html": "<p><strong>记录员</strong></p>",
        "text": "记录员"
      },
      {
        "number": "20.5.5.1",
        "html": "<p>记录员的职责为：</p><ol class=\"alpha\"><li>保持比赛记录，包括队员、比分、暂停、排他犯规、点球犯规以及对每名队员判罚的个人犯规；</li><li>控制队员的罚出时段，并以升起相应旗帜或其他经批准的方式示意罚出时段届满；但当被罚出队员的球队重新获得控球时，应由裁判员示意该队员或替补再入场。4 分钟后，记录员应升起黄旗连同相应颜色的旗帜（或以其他经批准方式），示意可替换因暴力行为被罚出的队员；</li><li>对被罚出队员的任何不当再入场或替补的不当入场（包括助理裁判员示意之后），以红旗加哨声或其他经批准方式示意，该信号应立即停止比赛；</li><li>不拖延地示意对任何队员判予第三次个人犯规：若为排他犯规，以红旗（或其他经批准方式）示意；若为点球犯规，以红旗加哨声（或其他经批准方式）示意。</li></ol>",
        "text": "记录员的职责为：保持比赛记录，包括队员、比分、暂停、排他犯规、点球犯规以及对每名队员判罚的个人犯规；控制队员的罚出时段，并以升起相应旗帜或其他经批准的方式示意罚出时段届满；但当被罚出队员的球队重新获得控球时，应由裁判员示意该队员或替补再入场。4 分钟后，记录员应升起黄旗连同相应颜色的旗帜（或以其他经批准方式），示意可替换因暴力行为被罚出的队员；对被罚出队员的任何不当再入场或替补的不当入场（包括助理裁判员示意之后），以红旗加哨声或其他经批准方式示意，该信号应立即停止比赛；不拖延地示意对任何队员判予第三次个人犯规：若为排他犯规，以红旗（或其他经批准方式）示意；若为点球犯规，以红旗加哨声（或其他经批准方式）示意。"
      },
      {
        "number": "20.5.6",
        "html": "<p><strong>视频助理裁判员（VAR）</strong></p>",
        "text": "视频助理裁判员（VAR）"
      },
      {
        "number": "20.5.6.1",
        "html": "<p>视频助理裁判员的职责为：</p><ol class=\"alpha\"><li>在“进球/未进球”存疑或暴力行为情形下，于适当时刻提供视频画面，提醒并协助当值裁判员；</li><li>必要时，在其他情形下以视频画面协助裁判员；</li><li>应要求向当值裁判员展示其他事件的回放。</li></ol>",
        "text": "视频助理裁判员的职责为：在“进球/未进球”存疑或暴力行为情形下，于适当时刻提供视频画面，提醒并协助当值裁判员；必要时，在其他情形下以视频画面协助裁判员；应要求向当值裁判员展示其他事件的回放。"
      },
      {
        "number": "20.5.7",
        "html": "<p><strong>两名裁判员执裁须知</strong></p>",
        "text": "两名裁判员执裁须知"
      },
      {
        "number": "20.5.7.1",
        "html": "<p>裁判员对比赛拥有绝对控制权，在宣判犯规和处罚方面权力相等。裁判员之间的意见分歧不得作为抗议或申诉的依据。</p>",
        "text": "裁判员对比赛拥有绝对控制权，在宣判犯规和处罚方面权力相等。裁判员之间的意见分歧不得作为抗议或申诉的依据。"
      },
      {
        "number": "20.5.7.2",
        "html": "<p>任命裁判员的委员会或组织有权指定每名裁判员执裁的池侧。当两队不交换场地时，裁判员应在任一节开始前交换池侧。</p>",
        "text": "任命裁判员的委员会或组织有权指定每名裁判员执裁的池侧。当两队不交换场地时，裁判员应在任一节开始前交换池侧。"
      },
      {
        "number": "20.5.7.3",
        "html": "<p>在比赛及每节开始时，裁判员各自位于相应的 6 米线上。开始信号由记录台同侧的裁判员发出。</p>",
        "text": "在比赛及每节开始时，裁判员各自位于相应的 6 米线上。开始信号由记录台同侧的裁判员发出。"
      },
      {
        "number": "20.5.7.4",
        "html": "<p>进球后，重新开始信号由进球时控制该进攻局面的裁判员发出。重新开始前，裁判员应确认任何换人均已完成。</p>",
        "text": "进球后，重新开始信号由进球时控制该进攻局面的裁判员发出。重新开始前，裁判员应确认任何换人均已完成。"
      },
      {
        "number": "20.5.7.5",
        "html": "<p>每名裁判员都有权在比赛场地任何部分宣判犯规，但应主要关注其右侧攻向球门的进攻局面。不控制该进攻局面的裁判员（防守端裁判）通常应保持在不比距被攻球门最远的进攻队员更靠近球门的位置。</p>",
        "text": "每名裁判员都有权在比赛场地任何部分宣判犯规，但应主要关注其右侧攻向球门的进攻局面。不控制该进攻局面的裁判员（防守端裁判）通常应保持在不比距被攻球门最远的进攻队员更靠近球门的位置。"
      },
      {
        "number": "20.5.7.6",
        "html": "<p>在判予任意球、球门球或角球时，作出判罚的裁判员应鸣哨，两名裁判员都应指明进攻方向，以便池中不同位置的队员迅速看清哪队获得掷球。裁判员应使用 20.5.8 所列手势，以指明所判罚犯规的性质。</p>",
        "text": "在判予任意球、球门球或角球时，作出判罚的裁判员应鸣哨，两名裁判员都应指明进攻方向，以便池中不同位置的队员迅速看清哪队获得掷球。裁判员应使用 20.5.8 所列手势，以指明所判罚犯规的性质。"
      },
      {
        "number": "20.5.7.7",
        "html": "<p>主罚罚点球的信号应由进攻端裁判发出；但欲用左手主罚的队员可请求防守端裁判发出信号。</p>",
        "text": "主罚罚点球的信号应由进攻端裁判发出；但欲用左手主罚的队员可请求防守端裁判发出信号。"
      },
      {
        "number": "20.5.7.8",
        "html": "<p>当同时判予对阵双方普通犯规时，应由进攻端裁判判中立球。当两名裁判员同时判罚、一个为球门球、另一个为角球时，应执行角球判罚，除非经 VAR 回看（适用时）另有判定。</p>",
        "text": "当同时判予对阵双方普通犯规时，应由进攻端裁判判中立球。当两名裁判员同时判罚、一个为球门球、另一个为角球时，应执行角球判罚，除非经 VAR 回看（适用时）另有判定。"
      },
      {
        "number": "20.5.7.9",
        "html": "<p>当两名裁判员同时判罚、一个为普通犯规、另一个为排他犯规或点球犯规时，应执行排他犯规或点球犯规的判罚。</p>",
        "text": "当两名裁判员同时判罚、一个为普通犯规、另一个为排他犯规或点球犯规时，应执行排他犯规或点球犯规的判罚。"
      },
      {
        "number": "20.5.7.10",
        "html": "<p>当对阵双方队员在比赛中同时实施排他犯规时，裁判员应从水中叫球，并确保两队和记录员都知道谁被罚出。控球计时钟不重置，比赛由原控球方球队以任意球重新开始。若判罚同时罚出时两队均未控球，则控球计时钟重置为 28 秒，比赛以中立球重新开始。</p>",
        "text": "当对阵双方队员在比赛中同时实施排他犯规时，裁判员应从水中叫球，并确保两队和记录员都知道谁被罚出。控球计时钟不重置，比赛由原控球方球队以任意球重新开始。若判罚同时罚出时两队均未控球，则控球计时钟重置为 28 秒，比赛以中立球重新开始。"
      },
      {
        "number": "20.5.7.11",
        "html": "<p>当同时判予两队罚点球时，第一个球由最后控球的球队主罚。第二个罚点球主罚后，由原控球方球队在中线上或中线后获任意球重新开始比赛；控球计时钟重置为 28 秒。</p>",
        "text": "当同时判予两队罚点球时，第一个球由最后控球的球队主罚。第二个罚点球主罚后，由原控球方球队在中线上或中线后获任意球重新开始比赛；控球计时钟重置为 28 秒。"
      },
      {
        "number": "泳帽号码",
        "html": "<p>为便于裁判员与队员、记录员沟通，号码超过 5 时酌情用双手示意——一只手张开五指，另一只手伸出其余手指凑足队员号码之和。数字 10 用握拳表示；号码超过 10 时，一只手握拳、另一只手伸出其余手指凑足号码之和。</p>",
        "text": "为便于裁判员与队员、记录员沟通，号码超过 5 时酌情用双手示意——一只手张开五指，另一只手伸出其余手指凑足队员号码之和。数字 10 用握拳表示；号码超过 10 时，一只手握拳、另一只手伸出其余手指凑足号码之和。"
      }
    ]
  },
  {
    "id": "a6",
    "no": "附6",
    "title": "点球大战",
    "en": "Appendix 6 — Penalty Shoot Out",
    "clauses": [
      {
        "number": "20.6.1",
        "html": "<p><strong>涉及的官员</strong></p>",
        "text": "涉及的官员"
      },
      {
        "number": "20.6.1.1",
        "html": "<p><strong>监督（Delegates）</strong>：优先核查主罚队员是否有资格参加点球大战（无累计三次个人犯规、未领红牌、未因伤无法继续的队员），并在第一轮点球结束后控制主罚顺序保持一致（五名主罚队员）。</p>",
        "text": "监督（Delegates）：优先核查主罚队员是否有资格参加点球大战（无累计三次个人犯规、未领红牌、未因伤无法继续的队员），并在第一轮点球结束后控制主罚顺序保持一致（五名主罚队员）。"
      },
      {
        "number": "20.6.1.2",
        "html": "<p><strong>裁判员</strong>：优先控制比赛场地、替补席、守门员及主罚队员在场地中的位置。</p>",
        "text": "裁判员：优先控制比赛场地、替补席、守门员及主罚队员在场地中的位置。"
      },
      {
        "number": "20.6.1.3",
        "html": "<p><strong>视频助理裁判员</strong>：必要时担任“进球/未进球”的协助。</p>",
        "text": "视频助理裁判员：必要时担任“进球/未进球”的协助。"
      },
      {
        "number": "20.6.2",
        "html": "<p><strong>程序</strong></p>",
        "text": "程序"
      },
      {
        "number": "20.6.2.1",
        "html": "<p>若须以点球大战（PSO）决定比赛结果（依 VI 4.3），必须遵循下列程序与规程。</p>",
        "text": "若须以点球大战（PSO）决定比赛结果（依 VI 4.3），必须遵循下列程序与规程。"
      },
      {
        "number": "20.6.2.2",
        "html": "<p>第 4 节结束后立即有 3 分钟休息，期间须完成下列动作：</p><ol class=\"alpha\"><li>队员出水、坐于各自替补席，但每队五名主罚队员留在场内本方半场、6 米线外，守门员亦留场。主罚队员不得攀附分道绳。</li><li>守门员交换场端，在对方半场的球门内就位。替补守门员可留在替补席，或在点球大战开始前于替补席对侧、场地外、6 米外的指定区域就位。</li><li>最后在替补席一侧执裁的裁判员将召集两队队长，以掷币决定哪队先罚第一个点球。掷币获胜方可决定由哪队开始点球大战。</li><li>助理裁判员不参与点球大战。</li></ol>",
        "text": "第 4 节结束后立即有 3 分钟休息，期间须完成下列动作：队员出水、坐于各自替补席，但每队五名主罚队员留在场内本方半场、6 米线外，守门员亦留场。主罚队员不得攀附分道绳。守门员交换场端，在对方半场的球门内就位。替补守门员可留在替补席，或在点球大战开始前于替补席对侧、场地外、6 米外的指定区域就位。最后在替补席一侧执裁的裁判员将召集两队队长，以掷币决定哪队先罚第一个点球。掷币获胜方可决定由哪队开始点球大战。助理裁判员不参与点球大战。"
      },
      {
        "number": "20.6.2.3",
        "html": "<p>3 分钟休息结束后，点球大战立即开始。若两队在 3 分钟前已准备就绪，裁判员可停止递减计时、提前开始。若某队未能按时准备就绪，应向该队教练出示黄牌警告；若该教练已被黄牌警告，则因拖延点球大战出示红牌；若主教练已被罚出，则其他任何替补席官员仅因拖延点球大战可被出示红牌。</p>",
        "text": "3 分钟休息结束后，点球大战立即开始。若两队在 3 分钟前已准备就绪，裁判员可停止递减计时、提前开始。若某队未能按时准备就绪，应向该队教练出示黄牌警告；若该教练已被黄牌警告，则因拖延点球大战出示红牌；若主教练已被罚出，则其他任何替补席官员仅因拖延点球大战可被出示红牌。"
      },
      {
        "number": "20.6.2.4",
        "html": "<p>两端球门交替主罚时，每个点球仅由一名裁判员控制。裁判员位于场地两端的 5 米线上，使右手主罚者便于观察裁判员的信号。仅当左手主罚者准备主罚下一个点球时，裁判员才走到场地另一端。</p>",
        "text": "两端球门交替主罚时，每个点球仅由一名裁判员控制。裁判员位于场地两端的 5 米线上，使右手主罚者便于观察裁判员的信号。仅当左手主罚者准备主罚下一个点球时，裁判员才走到场地另一端。"
      },
      {
        "number": "20.6.2.5",
        "html": "<p>点球大战可使用多个球。球不得从场地一端掷向另一端。每方使用各自的一套球。</p>",
        "text": "点球大战可使用多个球。球不得从场地一端掷向另一端。每方使用各自的一套球。"
      },
      {
        "number": "20.6.2.6",
        "html": "<p>每队主罚顺序即其第一轮五个点球的主罚顺序（点球大战开始前无需书面列出主罚名单）。记录员应记录主罚队员的号码，并与监督一起核查主罚队员是否有资格参加（无三次个人犯规、未被红牌罚出、未因伤退出）。若第一轮五个点球后两队战平，则同样的队员按第一轮确立的相同顺序继续。</p>",
        "text": "每队主罚顺序即其第一轮五个点球的主罚顺序（点球大战开始前无需书面列出主罚名单）。记录员应记录主罚队员的号码，并与监督一起核查主罚队员是否有资格参加（无三次个人犯规、未被红牌罚出、未因伤退出）。若第一轮五个点球后两队战平，则同样的队员按第一轮确立的相同顺序继续。"
      },
      {
        "number": "20.6.2.7",
        "html": "<p>点球在场地两端交替主罚，除非某一端场地条件对某队有利及/或不利，此时所有点球可在同一端主罚。</p>",
        "text": "点球在场地两端交替主罚，除非某一端场地条件对某队有利及/或不利，此时所有点球可在同一端主罚。"
      },
      {
        "number": "20.6.2.8",
        "html": "<p>若点球大战过程中，防守方守门员经裁判员命令一次后仍未在球门线上正确占位，则该守门员被罚出，可由参加点球大战的五名队员之一占据守门员位置、但不享有守门员权利。主罚该点球后，守门员或替补可（重新）入场，但第六部分第 16.2 条情形除外。</p>",
        "text": "若点球大战过程中，防守方守门员经裁判员命令一次后仍未在球门线上正确占位，则该守门员被罚出，可由参加点球大战的五名队员之一占据守门员位置、但不享有守门员权利。主罚该点球后，守门员或替补可（重新）入场，但第六部分第 16.2 条情形除外。"
      },
      {
        "number": "20.6.2.9",
        "html": "<p>若主罚点球时守门员在裁判员鸣哨前向前移动、而主罚队员射门未进，则守门员被罚出，并依第六部分第 20.6.2.8 条重罚该点球。守门员或替补可依第 20.6.2.8 条（重新）入场。</p>",
        "text": "若主罚点球时守门员在裁判员鸣哨前向前移动、而主罚队员射门未进，则守门员被罚出，并依第六部分第 20.6.2.8 条重罚该点球。守门员或替补可依第 20.6.2.8 条（重新）入场。"
      },
      {
        "number": "20.6.3",
        "html": "<p><strong>更换守门员</strong></p>",
        "text": "更换守门员"
      },
      {
        "number": "20.6.3.1",
        "html": "<p>点球大战中允许按下列程序更换守门员（参见英文原文绿色箭头示意图）：</p><ol class=\"alpha\"><li>替补守门员须走到中线，然后游向球门、接替第一名守门员的位置。</li><li>被替换的守门员须游向记录台一侧，在 6 米外、场地外等候（以备再次替换或直至点球大战结束）。</li></ol>",
        "text": "点球大战中允许按下列程序更换守门员（参见英文原文绿色箭头示意图）：替补守门员须走到中线，然后游向球门、接替第一名守门员的位置。被替换的守门员须游向记录台一侧，在 6 米外、场地外等候（以备再次替换或直至点球大战结束）。"
      },
      {
        "number": "20.6.4",
        "html": "<p><strong>再次更换守门员</strong></p>",
        "text": "再次更换守门员"
      },
      {
        "number": "20.6.4.1",
        "html": "<p>点球大战中可再次更换守门员，按英文原文下方的绿色箭头游动（见原文示意图）。</p>",
        "text": "点球大战中可再次更换守门员，按英文原文下方的绿色箭头游动（见原文示意图）。"
      },
      {
        "number": "20.6.5",
        "html": "<p><strong>点球大战中守门员与队员的罚出</strong></p>",
        "text": "点球大战中守门员与队员的罚出"
      },
      {
        "number": "20.6.5.1",
        "html": "<p>若守门员在点球大战中被罚出比赛余下部分（第六部分第 16.2 条情形除外），可由参加点球大战的五名队员之一占据守门员位置、但不享有守门员权利；主罚该点球后，被罚出的守门员可再次参加点球大战。被罚出的守门员也可由替补守门员替换；若替补守门员无资格或无法参加，则由一名替代守门员替换，该替代者须佩戴守门员泳帽。</p>",
        "text": "若守门员在点球大战中被罚出比赛余下部分（第六部分第 16.2 条情形除外），可由参加点球大战的五名队员之一占据守门员位置、但不享有守门员权利；主罚该点球后，被罚出的守门员可再次参加点球大战。被罚出的守门员也可由替补守门员替换；若替补守门员无资格或无法参加，则由一名替代守门员替换，该替代者须佩戴守门员泳帽。"
      },
      {
        "number": "20.6.5.2",
        "html": "<p>若场上队员在点球大战中被罚出比赛余下部分，则其位置从参加点球大战的五名队员序列中移除，并将一名替补队员置于序列末位。</p>",
        "text": "若场上队员在点球大战中被罚出比赛余下部分，则其位置从参加点球大战的五名队员序列中移除，并将一名替补队员置于序列末位。"
      },
      {
        "number": "20.6.6",
        "html": "<p><strong>小结</strong>　点球大战期间：</p><ul class=\"dash\"><li>记录员和监督控制主罚的正确顺序与比分；</li><li>裁判员管理球队；</li><li>点球大战期间不允许热身；</li><li>所有未参加点球大战的队员必须与球队官员一起坐在替补席；</li><li>任何队员都不得攀附分道绳；</li><li>守门员可按点球大战规程游向球门进行更换；</li><li>被替换的守门员留在水中、6 米线外、场地外；</li><li>此后每次更换守门员均以类似方式进行。</li></ul>",
        "text": "小结 点球大战期间：记录员和监督控制主罚的正确顺序与比分；裁判员管理球队；点球大战期间不允许热身；所有未参加点球大战的队员必须与球队官员一起坐在替补席；任何队员都不得攀附分道绳；守门员可按点球大战规程游向球门进行更换；被替换的守门员留在水中、6 米线外、场地外；此后每次更换守门员均以类似方式进行。"
      }
    ]
  },
  {
    "id": "a7",
    "no": "附7",
    "title": "VAR（视频助理裁判）规程",
    "en": "Appendix 7 — VAR Protocol",
    "clauses": [
      {
        "number": "20.7.1",
        "html": "<p><strong>原则</strong></p><ul class=\"dash\"><li>最终判罚始终由裁判员作出。裁判员可根据 VAR 回看得出的事实更改其原判。</li><li>只有当值裁判员可请求回看。视频助理裁判员和监督只能提醒裁判员进行回看。</li><li>裁判员应尽快在适当时刻停止比赛。</li><li>VAR 回看过程中，裁判员应全程保持可见。</li><li>准确比速度更重要，因此不存在尽快完成回看的时间压力。</li><li>比赛不会因 VAR 技术故障、涉及 VAR 的错误判罚、不回看某事件的决定、或对不可回看情形的回看而判为无效。</li></ul>",
        "text": "原则最终判罚始终由裁判员作出。裁判员可根据 VAR 回看得出的事实更改其原判。只有当值裁判员可请求回看。视频助理裁判员和监督只能提醒裁判员进行回看。裁判员应尽快在适当时刻停止比赛。VAR 回看过程中，裁判员应全程保持可见。准确比速度更重要，因此不存在尽快完成回看的时间压力。比赛不会因 VAR 技术故障、涉及 VAR 的错误判罚、不回看某事件的决定、或对不可回看情形的回看而判为无效。"
      },
      {
        "number": "20.7.1.1",
        "html": "<p><strong>“适当时刻”的定义</strong></p><ul class=\"dash\"><li>两队均未控球；</li><li>间歇时间；</li><li>角球；</li><li>控球方球队无明显有利；</li><li>最迟应在本附录第 20.7.2 条所述情形之后的第一次进攻之前完成回看。第一次进攻完成后即不能再回看。</li></ul>",
        "text": "“适当时刻”的定义两队均未控球；间歇时间；角球；控球方球队无明显有利；最迟应在本附录第 20.7.2 条所述情形之后的第一次进攻之前完成回看。第一次进攻完成后即不能再回看。"
      },
      {
        "number": "20.7.2",
        "html": "<p><strong>比赛中可回看的情形</strong>　VAR 的使用仅限于下列各类判罚：</p><ol><li>进球/未进球；</li><li>在进攻时限届满时或某节结束时的进球；</li><li>记录台错误及/或电子系统（含暂停按钮）故障；</li><li>在某节结束时有射门、且有被罚出队员的情形；</li><li>暴力行为情形的回看；</li><li>干扰罚点球主罚；</li><li>队员的不当或违规入场、再入场；</li><li>角球或球门球。</li></ol>",
        "text": "比赛中可回看的情形 VAR 的使用仅限于下列各类判罚：进球/未进球；在进攻时限届满时或某节结束时的进球；记录台错误及/或电子系统（含暂停按钮）故障；在某节结束时有射门、且有被罚出队员的情形；暴力行为情形的回看；干扰罚点球主罚；队员的不当或违规入场、再入场；角球或球门球。"
      },
      {
        "number": "20.7.2.1",
        "html": "<p><strong>进球/未进球情形</strong><br>若裁判员或 VAR 官员对进球/未进球情形有疑问，裁判员应回看该情形，以判定球是否完全越过球门线。</p>",
        "text": "进球/未进球情形若裁判员或 VAR 官员对进球/未进球情形有疑问，裁判员应回看该情形，以判定球是否完全越过球门线。"
      },
      {
        "number": "20.7.2.1.1",
        "html": "<p>若已判进球：</p><ul class=\"dash\"><li>由当值裁判员之一示意该进球须经回看；</li><li>一名裁判员将球取出水面；</li><li>最靠近 VAR 监视器的一名裁判员回看该情形，并作出有效或无效的判定；</li><li>若进球被取消，由原防守方守门员以任意球重新开始比赛，队员可在各自半场内任意位置就位；</li><li>若进球有效，比赛按第六部分第 6.4 条重新开始。</li></ul>",
        "text": "若已判进球：由当值裁判员之一示意该进球须经回看；一名裁判员将球取出水面；最靠近 VAR 监视器的一名裁判员回看该情形，并作出有效或无效的判定；若进球被取消，由原防守方守门员以任意球重新开始比赛，队员可在各自半场内任意位置就位；若进球有效，比赛按第六部分第 6.4 条重新开始。"
      },
      {
        "number": "20.7.2.1.2",
        "html": "<p>若未判进球：当值裁判员须在该情形之后尽快找到适当时刻进行回看，最迟不晚于存疑情形之后第一次进攻结束之时。</p><ul class=\"dash\"><li>回看后若判进球：比赛按第 6.4 条重新开始，时间重置至进球时刻；该时段内所有进球、暂停和个人犯规均作废，但所有黄牌、红牌、暴力行为和不当行为仍保留于比赛记录中。</li><li>回看后若不判进球：由最后控球的球队以任意球重新开始，时间不重置，队员可在各自半场内任意位置就位。</li></ul>",
        "text": "若未判进球：当值裁判员须在该情形之后尽快找到适当时刻进行回看，最迟不晚于存疑情形之后第一次进攻结束之时。回看后若判进球：比赛按第 6.4 条重新开始，时间重置至进球时刻；该时段内所有进球、暂停和个人犯规均作废，但所有黄牌、红牌、暴力行为和不当行为仍保留于比赛记录中。回看后若不判进球：由最后控球的球队以任意球重新开始，时间不重置，队员可在各自半场内任意位置就位。"
      },
      {
        "number": "20.7.2.2",
        "html": "<p><strong>进攻时限届满时或某节结束时的进球</strong><br>当进球非常接近进攻时限届满、或在某节结束的时间届满期间发生时，裁判员应核查球是否在时间届满前离开进攻队员之手。仅在由该次射门进球后立即进行视频回看。若该次射门的结果是角球、球门球、或进攻方未续接进球的反弹，则不进行视频回看。若反弹后进攻方由另一次射门进球，则应回看核查第一次射门（产生反弹）时球是否在时间届满前离手。若此情形发生在某节或比赛结束时，该节/比赛不立即结束；待裁判员完成回看并公布判定后再结束。</p>",
        "text": "进攻时限届满时或某节结束时的进球当进球非常接近进攻时限届满、或在某节结束的时间届满期间发生时，裁判员应核查球是否在时间届满前离开进攻队员之手。仅在由该次射门进球后立即进行视频回看。若该次射门的结果是角球、球门球、或进攻方未续接进球的反弹，则不进行视频回看。若反弹后进攻方由另一次射门进球，则应回看核查第一次射门（产生反弹）时球是否在时间届满前离手。若此情形发生在某节或比赛结束时，该节/比赛不立即结束；待裁判员完成回看并公布判定后再结束。"
      },
      {
        "number": "20.7.2.3",
        "html": "<p><strong>某节结束时的被罚出队员</strong><br>当队员在某节结束时被罚出、且在时间届满时进攻方射门，必须使用 VAR 设备判定是否发生控球权转换，以确定下一节是两队均势重新开始、还是仍有一名队员处于罚出状态。时间届满后，除第 20.7.2.2、20.7.2.3 条所述情形外，不得考虑其他情形的 VAR 回看。</p>",
        "text": "某节结束时的被罚出队员当队员在某节结束时被罚出、且在时间届满时进攻方射门，必须使用 VAR 设备判定是否发生控球权转换，以确定下一节是两队均势重新开始、还是仍有一名队员处于罚出状态。时间届满后，除第 20.7.2.2、20.7.2.3 条所述情形外，不得考虑其他情形的 VAR 回看。"
      },
      {
        "number": "20.7.2.4",
        "html": "<p><strong>记录台官员技术错误及/或电子设备（比赛/进攻计时钟、暂停设备）故障</strong><br>当出现此类技术错误或设备故障时，裁判员可使用 VAR 系统确定正确处理方案。该情形的判定与解决应在比赛重新开始前完成。</p>",
        "text": "记录台官员技术错误及/或电子设备（比赛/进攻计时钟、暂停设备）故障当出现此类技术错误或设备故障时，裁判员可使用 VAR 系统确定正确处理方案。该情形的判定与解决应在比赛重新开始前完成。"
      },
      {
        "number": "20.7.2.5",
        "html": "<p><strong>疑似暴力事件</strong><br>若裁判员、VAR 裁判员或监督怀疑可能发生暴力行为，裁判员可使用 VAR 回看。此时裁判员的判定可为：① 暴力行为；② 不当行为；③ 不予判罚；④ 模拟（假摔）。</p><p>若在怀疑暴力的当下停止了比赛：</p><ul class=\"dash\"><li>判定为暴力行为：依规则处罚，比赛从事件发生时刻恢复；</li><li>判定非暴力而是不当行为：依规则处罚，比赛从事件发生时刻恢复；</li><li>判定为模拟：向模拟队员所在球队出示黄牌（视情况红牌），比赛由对方球队主罚任意球开始；</li><li>三者皆非：比赛按规则继续。</li></ul><p>若比赛是在适当时刻停止、且判定为暴力或不当行为，则事件发生至停止之间的所有进球、暂停和个人犯规均作废，但所有黄牌、红牌、暴力与不当行为仍保留于比赛记录。疑似暴力情形下，可使用场馆视频屏回放、转播视频片段（含水下画面）进行回看。</p>",
        "text": "疑似暴力事件若裁判员、VAR 裁判员或监督怀疑可能发生暴力行为，裁判员可使用 VAR 回看。此时裁判员的判定可为：① 暴力行为；② 不当行为；③ 不予判罚；④ 模拟（假摔）。若在怀疑暴力的当下停止了比赛：判定为暴力行为：依规则处罚，比赛从事件发生时刻恢复；判定非暴力而是不当行为：依规则处罚，比赛从事件发生时刻恢复；判定为模拟：向模拟队员所在球队出示黄牌（视情况红牌），比赛由对方球队主罚任意球开始；三者皆非：比赛按规则继续。若比赛是在适当时刻停止、且判定为暴力或不当行为，则事件发生至停止之间的所有进球、暂停和个人犯规均作废，但所有黄牌、红牌、暴力与不当行为仍保留于比赛记录。疑似暴力情形下，可使用场馆视频屏回放、转播视频片段（含水下画面）进行回看。"
      },
      {
        "number": "20.7.2.6",
        "html": "<p><strong>罚点球主罚时的干扰</strong><br>当裁判员或 VAR 裁判员怀疑罚点球主罚时存在干扰，可使用 VAR 设备核查。依判定结果，比赛从规则所述适当时刻继续。</p>",
        "text": "罚点球主罚时的干扰当裁判员或 VAR 裁判员怀疑罚点球主罚时存在干扰，可使用 VAR 设备核查。依判定结果，比赛从规则所述适当时刻继续。"
      },
      {
        "number": "20.7.2.7",
        "html": "<p><strong>队员的不当或违规入场、再入场</strong><br>当裁判员或 VAR 裁判员怀疑队员不当或违规入场、再入场，可使用 VAR 设备核查。依判定结果，比赛从规则所述适当时刻继续。</p>",
        "text": "队员的不当或违规入场、再入场当裁判员或 VAR 裁判员怀疑队员不当或违规入场、再入场，可使用 VAR 设备核查。依判定结果，比赛从规则所述适当时刻继续。"
      },
      {
        "number": "20.7.2.8",
        "html": "<p><strong>角球或球门球</strong><br>在进攻队员射门未中后，当值裁判员与 VAR 专职裁判员可使用 VAR 设备判定比赛应以角球还是球门球恢复。</p>",
        "text": "角球或球门球在进攻队员射门未中后，当值裁判员与 VAR 专职裁判员可使用 VAR 设备判定比赛应以角球还是球门球恢复。"
      },
      {
        "number": "20.7.3",
        "html": "<p><strong>回看流程</strong></p>\n        <p><b>步骤 1：</b>a) 裁判员告知 VAR 某判罚/事件应予回看（check）；b) VAR 官员或监督向裁判员建议某判罚/事件应予回看。</p>\n        <p><b>步骤 2：</b>裁判员必要时决定在适当时刻停止比赛以回看视频（见 20.7.1.1）。</p>\n        <p><b>步骤 3：</b>在 VAR 监视器上回看存疑情形。</p>\n        <p><b>步骤 4：</b>裁判员走到比赛场地中央，清晰表明判定结果及比赛如何继续。播报员必须播报“为回看而停赛”以及回看后的判定；记分牌上也可显示相应信息。</p>\n        <p><b>步骤 5：</b>在最终判罚后重新开始比赛。</p>",
        "text": "回看流程 步骤 1：a) 裁判员告知 VAR 某判罚/事件应予回看（check）；b) VAR 官员或监督向裁判员建议某判罚/事件应予回看。 步骤 2：裁判员必要时决定在适当时刻停止比赛以回看视频（见 20.7.1.1）。 步骤 3：在 VAR 监视器上回看存疑情形。 步骤 4：裁判员走到比赛场地中央，清晰表明判定结果及比赛如何继续。播报员必须播报“为回看而停赛”以及回看后的判定；记分牌上也可显示相应信息。 步骤 5：在最终判罚后重新开始比赛。"
      },
      {
        "number": "20.7.4",
        "html": "<p><strong>VAR 回看期间队员的位置</strong><br>回看期间，队员必须留在各自半场。在任何视频回看期间、于裁判员公布判定之前，允许从任一再入场区换人。未进行回看的裁判员应管理两队队员，使其在场内占据正确位置。</p>",
        "text": "VAR 回看期间队员的位置回看期间，队员必须留在各自半场。在任何视频回看期间、于裁判员公布判定之前，允许从任一再入场区换人。未进行回看的裁判员应管理两队队员，使其在场内占据正确位置。"
      },
      {
        "number": "20.7.5",
        "html": "<p><strong>不构成抗议理由</strong><br>比赛结果不应因 VAR 技术故障、涉及 VAR 的错误判罚、不回看某事件的决定、或对不可回看情形的回看而判为无效。</p>",
        "text": "不构成抗议理由比赛结果不应因 VAR 技术故障、涉及 VAR 的错误判罚、不回看某事件的决定、或对不可回看情形的回看而判为无效。"
      }
    ]
  },
  {
    "id": "a10",
    "no": "附10",
    "title": "教练挑战规程",
    "en": "Appendix 10 — Protocol for Coach’s Challenge",
    "clauses": [
      {
        "number": "程序 · Procedures",
        "html": "<p class=\"cat\">程序 · Procedures</p>\n<p>每名教练每场比赛有权对裁判员的一次判罚提出挑战（“教练挑战”），但挑战须为下列之一：</p>\n<ol>\n          <li>裁判员疑似漏判暴力行为；</li>\n          <li>裁判员疑似漏判点球犯规；</li>\n          <li>裁判员疑似错误判罚点球犯规；或</li>\n          <li>下列未经 VAR 技术回看的场上情形之一：\n            <ol class=\"alpha\">\n              <li>角球或球门球（含边线）；</li>\n              <li>进球；</li>\n              <li>宣告未进球；</li>\n              <li>对队员罚点球的干扰；</li>\n              <li>在进攻时限届满时或某节结束时记录的进球；</li>\n              <li>队员不当或违规入场、再入场；</li>\n              <li>某节结束时的射门，其间有队员被错误地罚出场地；</li>\n              <li>记录台疑似出现的任何错误；或</li>\n              <li>任何未经 VAR 回看的疑似电子错误。</li>\n            </ol>\n          </li>\n        </ol>\n<p>为明确起见，对于裁判员已咨询 VAR 回看的判罚，教练不得挑战。若教练挑战成功，其有权在同一场比赛中、依上述相同标准提出第二次挑战。</p>\n<p>若球队在比赛进行中提出不符合上述准则的挑战，主教练应被处以黄牌（若此前已给黄牌则红牌），且若仍有剩余挑战次数则该队丧失之。若球队在停表期间（暂停、进球、节间间歇、罚点球主罚前或任何其他停表）提出不符合准则的挑战，教练应被处以黄牌（若此前已给黄牌则红牌）；若主教练已被罚出，则其他任何替补席官员只能领红牌。</p>",
        "text": "程序 · Procedures 每名教练每场比赛有权对裁判员的一次判罚提出挑战（“教练挑战”），但挑战须为下列之一： 裁判员疑似漏判暴力行为； 裁判员疑似漏判点球犯规； 裁判员疑似错误判罚点球犯规；或 下列未经 VAR 技术回看的场上情形之一： 角球或球门球（含边线）； 进球； 宣告未进球； 对队员罚点球的干扰； 在进攻时限届满时或某节结束时记录的进球； 队员不当或违规入场、再入场； 某节结束时的射门，其间有队员被错误地罚出场地； 记录台疑似出现的任何错误；或 任何未经 VAR 回看的疑似电子错误。 为明确起见，对于裁判员已咨询 VAR 回看的判罚，教练不得挑战。若教练挑战成功，其有权在同一场比赛中、依上述相同标准提出第二次挑战。 若球队在比赛进行中提出不符合上述准则的挑战，主教练应被处以黄牌（若此前已给黄牌则红牌），且若仍有剩余挑战次数则该队丧失之。若球队在停表期间（暂停、进球、节间间歇、罚点球主罚前或任何其他停表）提出不符合准则的挑战，教练应被处以黄牌（若此前已给黄牌则红牌）；若主教练已被罚出，则其他任何替补席官员只能领红牌。"
      },
      {
        "number": "时机 · Timing",
        "html": "<p class=\"cat\">时机 · Timing</p>\n<p>教练挑战的时机须符合下列标准：</p>\n<p><b class=\"term\">1. 对漏判暴力行为的挑战</b>：必须在挑战方获得控球时立即提出，不得在此之后。</p>\n<p><b class=\"term\">2. 对点球犯规的挑战</b>：必须由被判点球犯规的一方在罚点球掷出前提出。</p>\n<p><b class=\"term\">3. 对漏判点球犯规的挑战</b>：必须在下列时刻中最先发生者提出：</p>\n<ul class=\"dash\">\n          <li>挑战方下一次立即控球时，不得在此之后；</li>\n          <li>在挑战方下一次立即控球之前，非挑战方请求暂停时；</li>\n          <li>在挑战方下一次立即控球之前，判予非挑战方角球时；</li>\n          <li>在挑战方下一次控球之前且罚点球掷出之前，判予非挑战方点球犯规时；</li>\n          <li>非挑战方在其紧接的控球中得分时；</li>\n          <li>裁判员在非挑战方下一次立即控球期间因任何原因停止比赛、取走球时。</li>\n        </ul>\n<p><b class=\"term\">对“进攻时限届满／某节结束时进球”的挑战</b>：必须在该次射门后立即提出。</p>\n<p><b class=\"term\">对其他所有情形的挑战</b>：必须在下列时刻中最先发生者提出——挑战方下一次立即控球时；非挑战方在此前请求暂停时；非挑战方在此前获判角球时；非挑战方在此前且掷出前获判点球犯规时；非挑战方对挑战方得分、于挑战方控球时立即；或裁判员在非挑战方下一次立即控球期间因任何原因停球时。</p>\n<p>为明确起见，若教练挑战失败，挑战方将丧失本场比赛余下部分提出任何进一步挑战的权利。</p>",
        "text": "时机 · Timing 教练挑战的时机须符合下列标准： 1. 对漏判暴力行为的挑战：必须在挑战方获得控球时立即提出，不得在此之后。 2. 对点球犯规的挑战：必须由被判点球犯规的一方在罚点球掷出前提出。 3. 对漏判点球犯规的挑战：必须在下列时刻中最先发生者提出： 挑战方下一次立即控球时，不得在此之后； 在挑战方下一次立即控球之前，非挑战方请求暂停时； 在挑战方下一次立即控球之前，判予非挑战方角球时； 在挑战方下一次控球之前且罚点球掷出之前，判予非挑战方点球犯规时； 非挑战方在其紧接的控球中得分时； 裁判员在非挑战方下一次立即控球期间因任何原因停止比赛、取走球时。 对“进攻时限届满／某节结束时进球”的挑战：必须在该次射门后立即提出。 对其他所有情形的挑战：必须在下列时刻中最先发生者提出——挑战方下一次立即控球时；非挑战方在此前请求暂停时；非挑战方在此前获判角球时；非挑战方在此前且掷出前获判点球犯规时；非挑战方对挑战方得分、于挑战方控球时立即；或裁判员在非挑战方下一次立即控球期间因任何原因停球时。 为明确起见，若教练挑战失败，挑战方将丧失本场比赛余下部分提出任何进一步挑战的权利。"
      },
      {
        "number": "示意教练挑战 · Signaling",
        "html": "<p class=\"cat\">示意教练挑战 · Signaling</p>\n<ul class=\"dash\">\n          <li>教练必须以绿旗并做出 VAR 方框手势（用两根食指比划出一个方框）来示意“回看”其挑战。裁判员在适当时刻（不必在绿旗掷入场地时立即）、在对任何一队均无有利/不利时停止比赛。</li>\n          <li>提出教练挑战后，裁判员必须前往 VAR 核查屏回看挑战所涉事项。记录台一侧的裁判员在作出最终判定后，应走到比赛场地中线宣布判定。</li>\n        </ul>",
        "text": "示意教练挑战 · Signaling 教练必须以绿旗并做出 VAR 方框手势（用两根食指比划出一个方框）来示意“回看”其挑战。裁判员在适当时刻（不必在绿旗掷入场地时立即）、在对任何一队均无有利/不利时停止比赛。 提出教练挑战后，裁判员必须前往 VAR 核查屏回看挑战所涉事项。记录台一侧的裁判员在作出最终判定后，应走到比赛场地中线宣布判定。"
      },
      {
        "number": "若挑战被驳回 · If rejected",
        "html": "<p class=\"cat\">若挑战被驳回 · If rejected</p>\n<ul class=\"dash\">\n          <li>比赛从因挑战而停止的时刻继续；若对暴力行为的挑战导致挑战方因模拟被出示黄牌，两队均无其他后果。</li>\n          <li>若因对疑似暴力行为提出挑战、经判定属《竞赛规则》第 19.17 条所定义的模拟，裁判员应采用模拟处理规程，比赛在停止时刻由非挑战方主罚任意球重新开始。</li>\n        </ul>",
        "text": "若挑战被驳回 · If rejected 比赛从因挑战而停止的时刻继续；若对暴力行为的挑战导致挑战方因模拟被出示黄牌，两队均无其他后果。 若因对疑似暴力行为提出挑战、经判定属《竞赛规则》第 19.17 条所定义的模拟，裁判员应采用模拟处理规程，比赛在停止时刻由非挑战方主罚任意球重新开始。"
      },
      {
        "number": "若挑战被接受 · If accepted",
        "html": "<p class=\"cat\">若挑战被接受 · If accepted</p>\n<ul class=\"dash\">\n          <li>属暴力行为的：比赛时间重置至暴力或不当行为发生时刻，裁判员视情况执行暴力行为或不当行为处理规程。</li>\n          <li>属因挑战而被取消的点球犯规：比赛从判罚该点球犯规时刻重新开始；该次点球犯规作废，裁判员依水球规则改判。</li>\n          <li>若判定发生了点球犯规以外的犯规，裁判员依水球规则处理。</li>\n          <li>属经回看判定为点球犯规的漏判：比赛时间重置至本应判罚的时刻，裁判员执行点球犯规处理规程。</li>\n          <li>属判定本应判予角球或球门球的：比赛时间重置至本应出现角球或球门球的时刻。</li>\n        </ul>\n<p>在通过 VAR 回看教练挑战期间，于 VAR 裁判员公布最终判定之前，两队均可从任一再入场区换人。因挑战成功而被重新计入计时钟的时段内发生的所有进球、个人犯规和暂停均作废；但黄牌、红牌、暴力行为和不当行为仍保留于比赛记录中。</p>\n<p>若漏判点球犯规发生在临近比赛结束时，且挑战方在终场前未获控球，且非挑战方未请求暂停、未获判角球、未获判点球犯规，裁判员也未在非挑战方下一次立即控球期间因任何原因停球取球，则挑战方可在终场哨响后立即对该漏判点球犯规提出挑战。</p>",
        "text": "若挑战被接受 · If accepted 属暴力行为的：比赛时间重置至暴力或不当行为发生时刻，裁判员视情况执行暴力行为或不当行为处理规程。 属因挑战而被取消的点球犯规：比赛从判罚该点球犯规时刻重新开始；该次点球犯规作废，裁判员依水球规则改判。 若判定发生了点球犯规以外的犯规，裁判员依水球规则处理。 属经回看判定为点球犯规的漏判：比赛时间重置至本应判罚的时刻，裁判员执行点球犯规处理规程。 属判定本应判予角球或球门球的：比赛时间重置至本应出现角球或球门球的时刻。 在通过 VAR 回看教练挑战期间，于 VAR 裁判员公布最终判定之前，两队均可从任一再入场区换人。因挑战成功而被重新计入计时钟的时段内发生的所有进球、个人犯规和暂停均作废；但黄牌、红牌、暴力行为和不当行为仍保留于比赛记录中。 若漏判点球犯规发生在临近比赛结束时，且挑战方在终场前未获控球，且非挑战方未请求暂停、未获判角球、未获判点球犯规，裁判员也未在非挑战方下一次立即控球期间因任何原因停球取球，则挑战方可在终场哨响后立即对该漏判点球犯规提出挑战。"
      }
    ]
  }
];

export const waterPoloSignalCards: WaterPoloSignalCard[] = [
  {
    "id": "A",
    "image": "/assets/rules/signals/signal_A.png",
    "alt": "裁判手势 A",
    "category": "通用",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "将手臂由竖直放下，示意 (i) 某节开始、(ii) 进球后重新开始、(iii) 主罚罚点球。",
    "gestureText": "将手臂由竖直放下，示意 (i) 某节开始、(ii) 进球后重新开始、(iii) 主罚罚点球。",
    "whistleHtml": "<b>哨声：</b>鸣哨开始/重启；罚点球时鸣哨＋放臂（§6.3、§6.4、§15.3）",
    "whistleText": "哨声：鸣哨开始/重启；罚点球时鸣哨＋放臂（§6.3、§6.4、§15.3）"
  },
  {
    "id": "B",
    "image": "/assets/rules/signals/signal_B.png",
    "alt": "裁判手势 B",
    "category": "掷球",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "一臂指向进攻方向；必要时用另一臂指明掷球地点。",
    "gestureText": "一臂指向进攻方向；必要时用另一臂指明掷球地点。",
    "whistleHtml": "<b>哨声：</b>判任意球/球门球/角球：先鸣哨，再指方向（§20.5.7.6）",
    "whistleText": "哨声：判任意球/球门球/角球：先鸣哨，再指方向（§20.5.7.6）"
  },
  {
    "id": "C",
    "image": "/assets/rules/signals/signal_C.png",
    "alt": "裁判手势 C",
    "category": "掷球",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "示意中立球：指向判予地点，双手竖拇指并叫球。",
    "gestureText": "示意中立球：指向判予地点，双手竖拇指并叫球。",
    "whistleHtml": "<b>哨声：</b>鸣哨宣告中立球（§20.5.2.3）",
    "whistleText": "哨声：鸣哨宣告中立球（§20.5.2.3）"
  },
  {
    "id": "D",
    "image": "/assets/rules/signals/signal_D.png",
    "alt": "裁判手势 D",
    "category": "罚出",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "指向该队员，手臂迅速挥向场地边界，随后示意泳帽号码。",
    "gestureText": "指向该队员，手臂迅速挥向场地边界，随后示意泳帽号码。",
    "whistleHtml": "<b>哨声：</b>鸣哨判排他犯规、停球后做出（§20.5.2.3）",
    "whistleText": "哨声：鸣哨判排他犯规、停球后做出（§20.5.2.3）"
  },
  {
    "id": "E",
    "image": "/assets/rules/signals/signal_E.png",
    "alt": "裁判手势 E",
    "category": "罚出",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "双手分别指向两人，按 D 示意罚出，随即示意号码。",
    "gestureText": "双手分别指向两人，按 D 示意罚出，随即示意号码。",
    "whistleHtml": "<b>哨声：</b>鸣哨判同时罚出",
    "whistleText": "哨声：鸣哨判同时罚出"
  },
  {
    "id": "F",
    "image": "/assets/rules/signals/signal_F.png",
    "alt": "裁判手势 F",
    "category": "罚出",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "按 D（或 E）罚出，双手相互绕圈并出示红牌，再示号码。",
    "gestureText": "按 D（或 E）罚出，双手相互绕圈并出示红牌，再示号码。",
    "whistleHtml": "<b>哨声：</b>鸣哨判罚出（不当行为）＋红牌",
    "whistleText": "哨声：鸣哨判罚出（不当行为）＋红牌"
  },
  {
    "id": "G",
    "image": "/assets/rules/signals/signal_G.png",
    "alt": "裁判手势 G",
    "category": "罚出",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "按 D（或 E）罚出，交叉双臂并出示红牌，再示号码。",
    "gestureText": "按 D（或 E）罚出，交叉双臂并出示红牌，再示号码。",
    "whistleHtml": "<b>哨声：</b>鸣哨判罚出、4 分钟后换人＋红牌",
    "whistleText": "哨声：鸣哨判罚出、4 分钟后换人＋红牌"
  },
  {
    "id": "H",
    "image": "/assets/rules/signals/signal_H.png",
    "alt": "裁判手势 H",
    "category": "点球",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "举臂、张开五指，随后示意违规队员号码。",
    "gestureText": "举臂、张开五指，随后示意违规队员号码。",
    "whistleHtml": "<b>哨声：</b>鸣哨判罚点球（§19.19.1）；可先延迟鸣哨看是否进球（§10.1）",
    "whistleText": "哨声：鸣哨判罚点球（§19.19.1）；可先延迟鸣哨看是否进球（§10.1）"
  },
  {
    "id": "I",
    "image": "/assets/rules/signals/signal_I.png",
    "alt": "裁判手势 I",
    "category": "得分",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "鸣哨并立即指向比赛场地中央。",
    "gestureText": "鸣哨并立即指向比赛场地中央。",
    "whistleHtml": "<b>哨声：</b>进球：鸣哨＋指中央（§20.5.8 I 明文）",
    "whistleText": "哨声：进球：鸣哨＋指中央（§20.5.8 I 明文）"
  },
  {
    "id": "J",
    "image": "/assets/rules/signals/signal_J.png",
    "alt": "裁判手势 J",
    "category": "排他犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "一手握住另一手手腕。",
    "gestureText": "一手握住另一手手腕。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“抓握”性质（→任意球＋罚出）",
    "whistleText": "哨声：随犯规哨给出，指明“抓握”性质（→任意球＋罚出）"
  },
  {
    "id": "K",
    "image": "/assets/rules/signals/signal_K.png",
    "alt": "裁判手势 K",
    "category": "排他犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "双手由水平位置向下。",
    "gestureText": "双手由水平位置向下。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“按沉”性质",
    "whistleText": "哨声：随犯规哨给出，指明“按沉”性质"
  },
  {
    "id": "L",
    "image": "/assets/rules/signals/signal_L.png",
    "alt": "裁判手势 L",
    "category": "排他犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "双手竖直伸出、向身体方向拉拽。",
    "gestureText": "双手竖直伸出、向身体方向拉拽。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“回拽”性质",
    "whistleText": "哨声：随犯规哨给出，指明“回拽”性质"
  },
  {
    "id": "M",
    "image": "/assets/rules/signals/signal_M.png",
    "alt": "裁判手势 M",
    "category": "排他犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "做踢的动作。",
    "gestureText": "做踢的动作。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“踢踹”性质",
    "whistleText": "哨声：随犯规哨给出，指明“踢踹”性质"
  },
  {
    "id": "N",
    "image": "/assets/rules/signals/signal_N.png",
    "alt": "裁判手势 N",
    "category": "排他犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "握拳、由水平位置做击打动作。",
    "gestureText": "握拳、由水平位置做击打动作。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“击打”性质",
    "whistleText": "哨声：随犯规哨给出，指明“击打”性质"
  },
  {
    "id": "O",
    "image": "/assets/rules/signals/signal_O.png",
    "alt": "裁判手势 O",
    "category": "普通犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "由水平位置向外推离身体。",
    "gestureText": "由水平位置向外推离身体。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“推顶/借力”（→任意球）",
    "whistleText": "哨声：随犯规哨给出，指明“推顶/借力”（→任意球）"
  },
  {
    "id": "P",
    "image": "/assets/rules/signals/signal_P.png",
    "alt": "裁判手势 P",
    "category": "排他犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "一手水平横过另一手做交叉。",
    "gestureText": "一手水平横过另一手做交叉。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“阻碍”性质",
    "whistleText": "哨声：随犯规哨给出，指明“阻碍”性质"
  },
  {
    "id": "Q",
    "image": "/assets/rules/signals/signal_Q.png",
    "alt": "裁判手势 Q",
    "category": "普通犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "一手由水平位置向下。",
    "gestureText": "一手由水平位置向下。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“球带入水下”",
    "whistleText": "哨声：随犯规哨给出，指明“球带入水下”"
  },
  {
    "id": "R",
    "image": "/assets/rules/signals/signal_R.png",
    "alt": "裁判手势 R",
    "category": "普通犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "抬起并放下一只脚。",
    "gestureText": "抬起并放下一只脚。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“站立池底”",
    "whistleText": "哨声：随犯规哨给出，指明“站立池底”"
  },
  {
    "id": "S",
    "image": "/assets/rules/signals/signal_S.png",
    "alt": "裁判手势 S",
    "category": "普通犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "翻掌、举手一两次。",
    "gestureText": "翻掌、举手一两次。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“掷球无故拖延”",
    "whistleText": "哨声：随犯规哨给出，指明“掷球无故拖延”"
  },
  {
    "id": "T",
    "image": "/assets/rules/signals/signal_T.png",
    "alt": "裁判手势 T",
    "category": "普通犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "手臂竖直、伸食指与中指表示 2。",
    "gestureText": "手臂竖直、伸食指与中指表示 2。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“违反 2 米规则”",
    "whistleText": "哨声：随犯规哨给出，指明“违反 2 米规则”"
  },
  {
    "id": "U",
    "image": "/assets/rules/signals/signal_U.png",
    "alt": "裁判手势 U",
    "category": "普通犯规",
    "whistle": "🔔 鸣哨",
    "gestureHtml": "一手做两三次圆周动作。",
    "gestureText": "一手做两三次圆周动作。",
    "whistleHtml": "<b>哨声：</b>随犯规哨给出，指明“控球时间届满”",
    "whistleText": "哨声：随犯规哨给出，指明“控球时间届满”"
  },
  {
    "id": "V",
    "image": "/assets/rules/signals/signal_V.png",
    "alt": "裁判手势 V",
    "category": "通用",
    "whistle": "○ 不鸣哨",
    "gestureHtml": "示意允许在 6 米区域外射门。",
    "gestureText": "示意允许在 6 米区域外射门。",
    "whistleHtml": "<b>哨声：</b>有利/允许射门，比赛继续，不停哨",
    "whistleText": "哨声：有利/允许射门，比赛继续，不停哨"
  },
  {
    "id": "V1",
    "image": "/assets/rules/signals/signal_V1.png",
    "alt": "裁判手势 V1",
    "category": "黄牌",
    "whistle": "◐ 视情况",
    "gestureHtml": "举黄牌、一臂平行边线指向被罚球队替补席（§9.13.3）。",
    "gestureText": "举黄牌、一臂平行边线指向被罚球队替补席（§9.13.3）。",
    "whistleHtml": "<b>哨声：</b>对球队/替补席黄牌，通常于停表时出示",
    "whistleText": "哨声：对球队/替补席黄牌，通常于停表时出示"
  },
  {
    "id": "V2",
    "image": "/assets/rules/signals/signal_V2.png",
    "alt": "裁判手势 V2",
    "category": "黄牌",
    "whistle": "◐ 视情况",
    "gestureHtml": "举黄牌、一臂指向被罚的主教练（§16.3.1）。",
    "gestureText": "举黄牌、一臂指向被罚的主教练（§16.3.1）。",
    "whistleHtml": "<b>哨声：</b>对主教练黄牌（正式警告），多于停表时出示",
    "whistleText": "哨声：对主教练黄牌（正式警告），多于停表时出示"
  },
  {
    "id": "V3",
    "image": "/assets/rules/signals/signal_V3.png",
    "alt": "裁判手势 V3",
    "category": "红牌",
    "whistle": "◐ 视情况",
    "gestureHtml": "举红牌、一臂指向主教练/官员/队员（§16.3.2；或 §9.13、9.14 附加信号）。",
    "gestureText": "举红牌、一臂指向主教练/官员/队员（§16.3.2；或 §9.13、9.14 附加信号）。",
    "whistleHtml": "<b>哨声：</b>水中队员不当行为即停赛鸣哨；对教练席红牌于停表出示",
    "whistleText": "哨声：水中队员不当行为即停赛鸣哨；对教练席红牌于停表出示"
  },
  {
    "id": "W",
    "image": "/assets/rules/signals/signal_W.png",
    "alt": "裁判手势 W",
    "category": "通用",
    "whistle": "○ 不鸣哨",
    "gestureHtml": "示意控球权转换。",
    "gestureText": "示意控球权转换。",
    "whistleHtml": "<b>哨声：</b>控球权转换指示，不停哨",
    "whistleText": "哨声：控球权转换指示，不停哨"
  },
  {
    "id": "X",
    "image": "/assets/rules/signals/signal_X.png",
    "alt": "裁判手势 X",
    "category": "助理裁判",
    "whistle": "△ 助理裁判",
    "gestureHtml": "示意某节开始。",
    "gestureText": "示意某节开始。",
    "whistleHtml": "<b>哨声：</b>助理裁判仅举臂、不鸣哨；由主裁判鸣哨开赛（§20.5.3.2）",
    "whistleText": "哨声：助理裁判仅举臂、不鸣哨；由主裁判鸣哨开赛（§20.5.3.2）"
  },
  {
    "id": "Y",
    "image": "/assets/rules/signals/signal_Y.png",
    "alt": "裁判手势 Y",
    "category": "助理裁判",
    "whistle": "△ 助理裁判",
    "gestureHtml": "示意不当开始/重启或不当再入场。",
    "gestureText": "示意不当开始/重启或不当再入场。",
    "whistleHtml": "<b>哨声：</b>助理裁判举双臂、不鸣哨；提示主裁判",
    "whistleText": "哨声：助理裁判举双臂、不鸣哨；提示主裁判"
  },
  {
    "id": "Z",
    "image": "/assets/rules/signals/signal_Z.png",
    "alt": "裁判手势 Z",
    "category": "助理裁判",
    "whistle": "△ 助理裁判",
    "gestureHtml": "示意球门球或角球。",
    "gestureText": "示意球门球或角球。",
    "whistleHtml": "<b>哨声：</b>助理裁判指向、不鸣哨；由主裁判鸣哨宣告",
    "whistleText": "哨声：助理裁判指向、不鸣哨；由主裁判鸣哨宣告"
  },
  {
    "id": "AA",
    "image": "/assets/rules/signals/signal_AA.png",
    "alt": "裁判手势 AA",
    "category": "助理裁判",
    "whistle": "△ 助理裁判",
    "gestureHtml": "示意进球。",
    "gestureText": "示意进球。",
    "whistleHtml": "<b>哨声：</b>助理裁判交叉双臂、不鸣哨；由主裁判鸣哨确认进球",
    "whistleText": "哨声：助理裁判交叉双臂、不鸣哨；由主裁判鸣哨确认进球"
  }
];

export const waterPoloWhistleRows: WaterPoloWhistleRow[] = [
  {
    "scene": "开始 / 重新开始比赛",
    "whistleHtml": "一声（鸣哨开始）",
    "signal": "放臂（手势 A）；进球后由控制该进攻的裁判鸣哨重启",
    "basis": "规则 §6.3、§6.4（鸣哨）＋ 惯例（一声）"
  },
  {
    "scene": "普通（小）犯规",
    "whistleHtml": "<b>一声</b>（短促）",
    "signal": "一臂伸直指向进攻方向（手势 B）",
    "basis": "USA Water Polo / SwimOutlet"
  },
  {
    "scene": "排他犯规（罚出 20 秒）",
    "whistleHtml": "<b>两短一长</b>（亦有教材作“三短”）",
    "signal": "指向被罚队员 → 挥向再入区 → 举手示号码（手势 D）",
    "basis": "USA Water Polo（two short then one long）"
  },
  {
    "scene": "点球犯规",
    "whistleHtml": "<b>两声或三声</b>",
    "signal": "举臂张开五指（数字 5，手势 H）→ 示违规者号码",
    "basis": "USA Water Polo（two or three blasts）"
  },
  {
    "scene": "进球",
    "whistleHtml": "<b>一声</b>",
    "signal": "立即指向场地中央（手势 I）",
    "basis": "规则 §20.5.8 信号 I（鸣哨）＋ SwimOutlet（一声）"
  },
  {
    "scene": "每节结束（场地无电子号角时）",
    "whistleHtml": "<b>一声长而响</b>",
    "signal": "交叉双臂再向两侧平展",
    "basis": "SwimOutlet（one long, loud blast）"
  },
  {
    "scene": "暂停结束前预警",
    "whistleHtml": "计时台<b>鸣哨预警</b>（暂停将结束）",
    "signal": "—",
    "basis": "裁判惯例（计时台职责）"
  },
  {
    "scene": "每节结束（计时台示意）",
    "whistleHtml": "须“<b>独特、清晰有效、易于理解</b>”（可用哨或其他方式）",
    "signal": "—",
    "basis": "规则 §20.5.4.2（仅规定音质，未规定长短）"
  }
];

export const waterPoloWhistleNoticeHtml = "<b>来源与效力说明（重要）：</b>经查证，<b>World Aquatics《竞赛规则·第六部分》与官方《水球裁判手册》正文均未逐条规定哨声的“长短／次数”</b>；规则只规定哨声的<b>时机用途</b>与<b>音质要求</b>（须“独特、清晰有效、易于理解”，§20.5.4.2）。下表的“长短声／次数”来自各级<b>水球裁判教学与协会指南</b>（USA Water Polo、SwimOutlet 等通行说明），<b>各教材略有差异</b>（例如排他犯规：USA Water Polo 作“两短一长”，亦有教材作“三短”）。实际执裁请<b>以正式裁判讲习 / 当地竞赛规程为准</b>。";

export const waterPoloWhistlePrincipleHtml = "<b>总体原则：</b>① 哨声＝听觉信号（停/开与判罚），手势＝视觉信号（方向＋性质＋号码），二者配合；\n    ② <b>哨声的次数/力度大致随判罚严重程度递增</b>：普通犯规（一声）＜ 排他犯规（两短一长）＜ 点球犯规（两～三声）。";

export const waterPoloSignalPrincipleHtml = "<b>配合原则：</b>哨声＝听觉信号（停/开与判罚），手势＝视觉信号（方向＋性质＋号码）。标准次序——\n    裁判员<b>鸣哨</b>（开始/重启，或停球判罚）→ 手势 <b>A</b> 放臂 或 手势 <b>B</b> 指明进攻方向 → 再用 <b>D–U</b> 手势指明犯规性质与号码。\n    依据：§20.5.2.3（鸣哨开始/重启并宣告进球、各类掷球、违规）、§20.5.7.6（判掷球先鸣哨再指方向、用手势示性质）、§15.3（罚点球鸣哨＋放臂）。\n    助理裁判<b>仅举臂、不鸣哨</b>（§20.5.3.2），由主裁判据情鸣哨。";
